var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Vue$1 from "vue";
var render$w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-ada-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HCol", { staticClass: "flex-1", attrs: { "gap": "16" } }, [_c("HCol", { attrs: { "gap": "4" } }, [_c("h4", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.ada.companyName))]), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v("Ref: " + _vm._s(_vm.ada.id))])]), _c("HCol", { attrs: { "gap": "4" } }, [_vm.activity ? _c("p", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.$t("ada.activity")) + " " + _vm._s(_vm.activity))]) : _vm._e(), _c("p", [_vm._v(_vm._s(_vm.$t("ada.siren")) + " " + _vm._s(_vm.ada.siren))])]), _vm.ada.address ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", [_vm._v(_vm._s(_vm.ada.address.line1))]), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.ada.address.postcode) + " " + _vm._s(_vm.ada.address.town))])]) : _vm._e(), _c("HCol", { attrs: { "gap": "4" } }, [_c("p", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.Formatter.useFormatPhone(_vm.ada.telephone)))]), _c("p", [_vm._v(_vm._s(_vm.ada.email))])]), _vm.ownerName ? _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("ada.followed_by")) + " " + _vm._s(_vm.ownerName))]) : _vm._e()], 1)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_c("HRow", { staticClass: "a-ada-card__footer", attrs: { "justify-content": "space-between", "gap": "16" } }, [_c("HTag", { attrs: { "label": _vm.ada.active ? _vm.$t("ada.active") : _vm.$t("ada.inactive"), "color": _vm.ada.active ? "green" : "red" } }), _c("HTag", { attrs: { "label": _vm.$t("ada.status." + _vm.ada.status), "color": _vm.getStatusTagColor } })], 1)];
  }, proxy: true }]) });
};
var staticRenderFns$w = [];
var AAdaCard_vue_vue_type_style_index_0_scoped_true_lang = "";
function normalizeComponent(scriptExports, render4, staticRenderFns2, functionalTemplate, injectStyles2, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render4) {
    options.render = render4;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles2) {
        injectStyles2.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles2) {
    hook = shadowMode ? function() {
      injectStyles2.call(
        this,
        (options.functional ? this.parent : this).$root.$options.shadowRoot
      );
    } : injectStyles2;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const script$w = {
  name: "AAdaCard",
  props: {
    ada: {
      type: Object,
      default: () => {
      }
    },
    ownerName: {
      type: String,
      default: ""
    },
    activity: {
      type: String,
      default: ""
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  computed: {
    getStatusTagColor() {
      switch (this.ada.status) {
        case "ongoing":
          return "grey-300";
        case "sent":
          return "blue-300";
        case "received":
          return "yellow";
        case "valid":
          return "green";
      }
      return "grey-200";
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$w = {};
var __component__$w = /* @__PURE__ */ normalizeComponent(
  script$w,
  render$w,
  staticRenderFns$w,
  false,
  injectStyles$w,
  "578faf4b",
  null,
  null
);
function injectStyles$w(context) {
  for (let o in __cssModules$w) {
    this[o] = __cssModules$w[o];
  }
}
var AAdaCard = /* @__PURE__ */ function() {
  return __component__$w.exports;
}();
var render$v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HRow", { class: _vm.bold ? "text-bold" : "", attrs: { "gap": "4" } }, [_vm.client.title === "MR" || _vm.client.title === "MS" ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("client." + _vm.client.title.toLowerCase())) + " ")]) : _vm.allowUnknown ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("client.unknown")) + " ")]) : _vm._e(), !_vm.onlyTitle ? [_c("span", [_vm._v(" " + _vm._s(_vm.client.firstName) + " ")]), _c("span", { staticClass: "text-uppercase" }, [_vm._v(" " + _vm._s(_vm.client.lastName) + " ")])] : _vm._e()], 2);
};
var staticRenderFns$v = [];
const script$v = {
  name: "AClientName",
  props: {
    client: {
      type: Object,
      default: () => {
      },
      validator(obj) {
        return (obj.title === "MR" || obj.title === "MS") && obj.firstName && obj.lastName;
      }
    },
    onlyTitle: {
      type: Boolean,
      default: false
    },
    allowUnknown: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    }
  }
};
const __cssModules$v = {};
var __component__$v = /* @__PURE__ */ normalizeComponent(
  script$v,
  render$v,
  staticRenderFns$v,
  false,
  injectStyles$v,
  null,
  null,
  null
);
function injectStyles$v(context) {
  for (let o in __cssModules$v) {
    this[o] = __cssModules$v[o];
  }
}
var AClientName = /* @__PURE__ */ function() {
  return __component__$v.exports;
}();
var render$u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HTag", { attrs: { "label": _vm.$t("mandate.statusList." + _vm.status), "color": _vm.getColor } });
};
var staticRenderFns$u = [];
var AMandateStatusLabel_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$u = {
  name: "AMandateStatusLabel",
  props: {
    status: {
      type: String,
      validator(value) {
        return value === "prospection" || value === "draft" || value === "ready" || value === "emandate_ready" || value === "eavenant_ready" || value === "sent" || value === "signed" || value === "completed" || value === "renewed" || value === "void" || value === "cancelled";
      },
      required: true
    }
  },
  computed: {
    getColor() {
      if (this.status === "prospection") {
        return "grey-300";
      }
      if (this.status === "draft") {
        return "grey-400";
      }
      if (this.status === "ready" || this.status === "emandate_ready" || this.status === "eavenant_ready") {
        return "blue-300";
      }
      if (this.status === "sent") {
        return "blue-400";
      }
      if (this.status === "signed") {
        return "yellow";
      }
      if (this.status === "completed" || this.status === "renewed") {
        return "green";
      }
      if (this.status === "void" || this.status === "cancelled") {
        return "red";
      }
      return "";
    }
  }
};
const __cssModules$u = {};
var __component__$u = /* @__PURE__ */ normalizeComponent(
  script$u,
  render$u,
  staticRenderFns$u,
  false,
  injectStyles$u,
  "627e5c2b",
  null,
  null
);
function injectStyles$u(context) {
  for (let o in __cssModules$u) {
    this[o] = __cssModules$u[o];
  }
}
var AMandateStatusLabel = /* @__PURE__ */ function() {
  return __component__$u.exports;
}();
var render$t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-avenant-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HCol", { attrs: { "gap": "16" } }, [_c("HCol", { attrs: { "gap": "4" } }, [_c("h4", { staticClass: "text-bold" }, [_vm._v(" " + _vm._s(_vm.$t("avenant.title", { number: _vm.avenant.number, reference: _vm.avenant.mandate.reference || _vm.avenant.mandate.id })) + " ")]), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v("Ref: " + _vm._s(_vm.avenant.id))])]), _vm.primaryClient ? _c("AClientName", { attrs: { "client": _vm.primaryClient, "bold": "" } }) : _vm._e(), _vm.ownerName ? _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("client.followed_by")) + " " + _vm._s(_vm.ownerName))]) : _vm._e(), _vm.avenant.mandate.type ? _c("HCol", { staticClass: "text-bold", attrs: { "gap": "4" } }, [_vm.avenant.mandate.type && _vm.avenant.mandate.price && _vm.avenant.mandate.type.for === "property" ? [_c("span", [_vm._v(" " + _vm._s(_vm.Formatter.useFormatPrice(_vm.avenant.mandate.price.current.value + _vm.avenant.mandate.fees.current.value)) + " HAI ")]), _c("span", { class: _vm.avenant.mandate.fees.current.exact ? "" : "text-red" }, [_vm._v(" " + _vm._s(_vm.Formatter.useFormatPrice(_vm.avenant.mandate.fees.current.value)) + " " + _vm._s(_vm.$t("commissions.fees")) + " ")])] : _vm._e(), _vm.avenant.mandate.type && _vm.avenant.mandate.price && _vm.avenant.mandate.type.for === "client" ? _c("span", [_vm._v(" " + _vm._s(_vm.Formatter.useFormatPrice(_vm.avenant.mandate.price.current.min)) + " - " + _vm._s(_vm.Formatter.useFormatPrice(_vm.avenant.mandate.price.current.max)) + " ")]) : _vm._e()], 2) : _vm._e()], 1)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_c("HRow", { staticClass: "a-avenant-card__footer", attrs: { "justify-content": "flex-end", "gap": "16" } }, [_vm.avenant.status ? _c("AMandateStatusLabel", { attrs: { "status": _vm.avenant.status } }) : _vm._e()], 1)];
  }, proxy: true }]) });
};
var staticRenderFns$t = [];
var AAvenantCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$t = {
  name: "AAvenantCard",
  components: {
    AClientName,
    AMandateStatusLabel
  },
  props: {
    avenant: {
      type: Object,
      required: true
    },
    ownerName: {
      type: String,
      default: ""
    },
    primaryClient: {
      type: Object
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$t = {};
var __component__$t = /* @__PURE__ */ normalizeComponent(
  script$t,
  render$t,
  staticRenderFns$t,
  false,
  injectStyles$t,
  "b9337e7a",
  null,
  null
);
function injectStyles$t(context) {
  for (let o in __cssModules$t) {
    this[o] = __cssModules$t[o];
  }
}
var AAvenantCard = /* @__PURE__ */ function() {
  return __component__$t.exports;
}();
var render$s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HTag", { attrs: { "label": _vm.$t("booking.statusList." + _vm.status), "color": _vm.getColor } });
};
var staticRenderFns$s = [];
const script$s = {
  name: "ABookingStatusLabel",
  props: {
    status: {
      type: String,
      validator(value) {
        return value === "accepted";
      },
      required: true
    }
  },
  computed: {
    getColor() {
      if (this.status === "accepted") {
        return "green";
      }
      if (this.status === "cancelled") {
        return "red";
      }
      return "";
    }
  }
};
const __cssModules$s = {};
var __component__$s = /* @__PURE__ */ normalizeComponent(
  script$s,
  render$s,
  staticRenderFns$s,
  false,
  injectStyles$s,
  null,
  null,
  null
);
function injectStyles$s(context) {
  for (let o in __cssModules$s) {
    this[o] = __cssModules$s[o];
  }
}
var ABookingStatusLabel = /* @__PURE__ */ function() {
  return __component__$s.exports;
}();
var render$r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-booking-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HCol", { attrs: { "gap": "16" } }, [_c("HCol", { attrs: { "gap": "4" } }, [_c("h4", { staticClass: "text-bold" }, [_vm._v(" " + _vm._s(_vm.property.id) + " - " + _vm._s(_vm.property.title && _vm.property.title[_vm.$i18n.locale] ? _vm.property.title[_vm.$i18n.locale] : "") + " ")]), _c("p", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.$t("booking.name")) + " : " + _vm._s(_vm.booking.id))]), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("developer.name")) + " : " + _vm._s(_vm.booking.developer.name))])]), _vm.property && _vm.property.address ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", [_vm._v(_vm._s(_vm.property.address.line1))]), _vm.property.address.line2 ? _c("p", [_vm._v(_vm._s(_vm.property.address.line2))]) : _vm._e(), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.property.address.postcode) + " " + _vm._s(_vm.property.address.town))]), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.booking.program.typology ? _vm.booking.program.typology.toString() : ""))])]) : _vm._e(), _vm.booking.price && _vm.booking.fees ? _c("HCol", { attrs: { "gap": "4" } }, [_c("HRow", [_c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(" " + _vm._s(_vm.$t("booking.price")) + " " + _vm._s(_vm.booking.price) + " \u20AC")])]), _c("HRow", [_c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(" " + _vm._s(_vm.$t("booking.fees")) + " " + _vm._s(_vm.booking.fees) + " \u20AC")])])], 1) : _vm._e(), _vm.ownerName ? _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("client.followed_by")) + " " + _vm._s(_vm.ownerName))]) : _vm._e()], 1)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_c("HRow", { staticClass: "a-booking-card__footer", attrs: { "justify-content": "space-between", "gap": "16" } }, [_c("ABookingStatusLabel", { attrs: { "status": _vm.booking.status } })], 1)];
  }, proxy: true }]) });
};
var staticRenderFns$r = [];
var ABookingCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$r = {
  name: "ABookingCard",
  components: { ABookingStatusLabel },
  props: {
    booking: {
      type: Object,
      required: true
    },
    property: {
      type: Object,
      required: true
    },
    ownerName: {
      type: String,
      default: ""
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$r = {};
var __component__$r = /* @__PURE__ */ normalizeComponent(
  script$r,
  render$r,
  staticRenderFns$r,
  false,
  injectStyles$r,
  "baa66348",
  null,
  null
);
function injectStyles$r(context) {
  for (let o in __cssModules$r) {
    this[o] = __cssModules$r[o];
  }
}
var ABookingCard = /* @__PURE__ */ function() {
  return __component__$r.exports;
}();
var render$q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HRow", { staticClass: "a-client-alerts", attrs: { "align-items": "center", "gap": "16" } }, [_vm._l(_vm.slicedFlags, function(flag) {
    return _c("HTag", { key: flag.id, attrs: { "label": flag.name[_vm.$i18n.locale], "color": "red" } });
  }), _vm.clientAppointmentsCanceledOrNoShowInLastSevenDays > 0 ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("client.visits_cancel", _vm.clientAppointmentsCanceledOrNoShowInLastSevenDays, { number: _vm.clientAppointmentsCanceledOrNoShowInLastSevenDays })) + " ")];
  }, proxy: true }], null, false, 1078565082) }) : _vm._e(), _vm.clientIssuesCount > 0 ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("model.issue", _vm.clientIssuesCount, { number: _vm.clientIssuesCount })) + " ")];
  }, proxy: true }], null, false, 420532974) }) : _vm._e(), _vm.clientExpireMandatesCount > 0 ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("mandate.expired_mandates", _vm.clientExpireMandatesCount, { number: _vm.clientExpireMandatesCount })) + " ")];
  }, proxy: true }], null, false, 4060999843) }) : _vm._e(), _vm.nonShowedFlags.length > 0 ? _c("HInfoModal", { attrs: { "position": "top-right" }, scopedSlots: _vm._u([{ key: "activator", fn: function() {
    return [_c("HTag", { attrs: { "label": "+ " + _vm.nonShowedFlags.length, "color": "red" } })];
  }, proxy: true }, { key: "default", fn: function() {
    return _vm._l(_vm.nonShowedFlags, function(flag) {
      return _c("p", { key: flag.id }, [_vm._v(" " + _vm._s(flag.name[_vm.$i18n.locale]) + " ")]);
    });
  }, proxy: true }], null, false, 2400750770) }) : _vm._e(), !_vm.hasAlert ? _c("p", [_vm._v(" " + _vm._s(_vm.$t("main.noAlerts")) + " ")]) : _vm._e()], 2);
};
var staticRenderFns$q = [];
var AClientAlerts_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$q = {
  name: "AClientAlerts",
  props: {
    client: {
      type: Object,
      default: () => {
      },
      required: false
    },
    clientAppointmentsCanceledOrNoShowInLastSevenDays: {
      type: Number,
      default: 0,
      required: false
    },
    clientIssuesCount: {
      type: Number,
      default: 0,
      required: false
    },
    clientExpireMandatesCount: {
      type: Number,
      default: 0,
      required: false
    },
    maxAlertsShowed: {
      type: Number,
      default: 4,
      required: false
    }
  },
  computed: {
    nbAlertsWithoutFlags() {
      return this.clientAppointmentsCanceledOrNoShowInLastSevenDays + this.clientIssuesCount + this.clientExpireMandatesCount;
    },
    slicedFlags() {
      var _a;
      if (!((_a = this.client) == null ? void 0 : _a.flags)) {
        return [];
      }
      return this.client.flags.slice(0, this.maxAlertsShowed - this.nbAlertsWithoutFlags);
    },
    nonShowedFlags() {
      var _a;
      if (!((_a = this.client) == null ? void 0 : _a.flags)) {
        return [];
      }
      return this.client.flags.slice(this.maxAlertsShowed - this.nbAlertsWithoutFlags);
    },
    hasAlert() {
      var _a, _b;
      return ((_b = (_a = this.client) == null ? void 0 : _a.flags) == null ? void 0 : _b.length) > 0 || this.clientAppointmentsCanceledOrNoShowInLastSevenDays > 0 || this.clientIssuesCount > 0 || this.clientExpireMandatesCount > 0;
    }
  }
};
const __cssModules$q = {};
var __component__$q = /* @__PURE__ */ normalizeComponent(
  script$q,
  render$q,
  staticRenderFns$q,
  false,
  injectStyles$q,
  "637665ac",
  null,
  null
);
function injectStyles$q(context) {
  for (let o in __cssModules$q) {
    this[o] = __cssModules$q[o];
  }
}
var AClientAlerts = /* @__PURE__ */ function() {
  return __component__$q.exports;
}();
var __glob_0_0$1 = "data:image/png;base64,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";
var __glob_0_1$1 = "data:image/png;base64,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";
var __glob_0_2 = "data:image/png;base64,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";
var __glob_0_3 = "data:image/png;base64,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";
var render$p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("img", { style: _vm.getStyle, attrs: { "src": _vm.getRatingIcon, "alt": "rating-" + _vm.rating } });
};
var staticRenderFns$p = [];
var AClientRating_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$p = {
  name: "AClientRating",
  props: {
    rating: {
      type: Number,
      required: true,
      validator(number) {
        return number >= 0 && number <= 3;
      }
    },
    size: {
      type: Number,
      required: false,
      default: 20
    }
  },
  computed: {
    getRatingIcon() {
      return new URL({ "../../assets/icons/client/client-rating-0-96.png": __glob_0_0$1, "../../assets/icons/client/client-rating-1-96.png": __glob_0_1$1, "../../assets/icons/client/client-rating-2-96.png": __glob_0_2, "../../assets/icons/client/client-rating-3-96.png": __glob_0_3 }[`../../assets/icons/client/client-rating-${this.rating}-96.png`], self.location).href;
    },
    getStyle() {
      return `width: ${this.size}px; height: ${this.size}px;`;
    }
  }
};
const __cssModules$p = {};
var __component__$p = /* @__PURE__ */ normalizeComponent(
  script$p,
  render$p,
  staticRenderFns$p,
  false,
  injectStyles$p,
  "2c47da57",
  null,
  null
);
function injectStyles$p(context) {
  for (let o in __cssModules$p) {
    this[o] = __cssModules$p[o];
  }
}
var AClientRating = /* @__PURE__ */ function() {
  return __component__$p.exports;
}();
var render$o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._l(_vm.clientStates, function(state) {
    return _c("p", { key: state, staticClass: "text-bold text-s", class: state.startsWith("active") ? "text-yellow" : "text-blue-300" }, [_vm._v(" " + _vm._s(_vm.$t("client.states." + state)) + " ")]);
  }), 0);
};
var staticRenderFns$o = [];
var AClientState_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$o = {
  name: "AClientState",
  props: {
    clientStates: {
      type: Array,
      default: () => [],
      required: true
    }
  }
};
const __cssModules$o = {};
var __component__$o = /* @__PURE__ */ normalizeComponent(
  script$o,
  render$o,
  staticRenderFns$o,
  false,
  injectStyles$o,
  "02a95fb0",
  null,
  null
);
function injectStyles$o(context) {
  for (let o in __cssModules$o) {
    this[o] = __cssModules$o[o];
  }
}
var AClientState = /* @__PURE__ */ function() {
  return __component__$o.exports;
}();
var __glob_0_0 = "data:image/svg+xml;base64,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";
var __glob_0_1 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iOTAwIiBoZWlnaHQ9IjYwMCI+PHJlY3Qgd2lkdGg9IjkwMCIgaGVpZ2h0PSI2MDAiIGZpbGw9IiNFRDI5MzkiLz48cmVjdCB3aWR0aD0iNjAwIiBoZWlnaHQ9IjYwMCIgZmlsbD0iI2ZmZiIvPjxyZWN0IHdpZHRoPSIzMDAiIGhlaWdodD0iNjAwIiBmaWxsPSIjMDAyMzk1Ii8+PC9zdmc+DQo=";
var render$n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("img", { style: _vm.getStyle, attrs: { "src": _vm.getFlagIcon, "alt": "flag-" + _vm.flag } });
};
var staticRenderFns$n = [];
var AFlag_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$n = {
  name: "AFlag",
  props: {
    flag: {
      type: String,
      default: "fr",
      validator(value) {
        return value === "fr" || value === "en";
      },
      required: true
    },
    size: {
      type: Number,
      default: 24,
      required: false
    }
  },
  computed: {
    getFlagIcon() {
      return new URL({ "../../assets/icons/flag/flag-en.svg": __glob_0_0, "../../assets/icons/flag/flag-fr.svg": __glob_0_1 }[`../../assets/icons/flag/flag-${this.flag}.svg`], self.location).href;
    },
    getStyle() {
      return `width: ${this.size}px;`;
    }
  }
};
const __cssModules$n = {};
var __component__$n = /* @__PURE__ */ normalizeComponent(
  script$n,
  render$n,
  staticRenderFns$n,
  false,
  injectStyles$n,
  "1ba74373",
  null,
  null
);
function injectStyles$n(context) {
  for (let o in __cssModules$n) {
    this[o] = __cssModules$n[o];
  }
}
var AFlag = /* @__PURE__ */ function() {
  return __component__$n.exports;
}();
var render$m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HIcon", { attrs: { "icon": "heart", "color": _vm.isFavorite ? "red" : "grey-400", "size": _vm.size } });
};
var staticRenderFns$m = [];
var AFavorite_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$m = {
  name: "AFavorite",
  props: {
    isFavorite: {
      type: Boolean,
      default: false,
      required: false
    },
    size: {
      type: Number,
      default: 20,
      required: false
    }
  }
};
const __cssModules$m = {};
var __component__$m = /* @__PURE__ */ normalizeComponent(
  script$m,
  render$m,
  staticRenderFns$m,
  false,
  injectStyles$m,
  "663dd36c",
  null,
  null
);
function injectStyles$m(context) {
  for (let o in __cssModules$m) {
    this[o] = __cssModules$m[o];
  }
}
var AFavorite = /* @__PURE__ */ function() {
  return __component__$m.exports;
}();
var render$l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-client-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HRow", { staticClass: "a-client-card__content flex-1", attrs: { "flex-wrap": "wrap", "gap": "24" } }, [_c("HCol", { attrs: { "justify-content": "center", "gap": "8" } }, [_c("AClientRating", { attrs: { "rating": _vm.client.rating, "size": 72 } }), _c("AClientState", { attrs: { "client-states": _vm.client.state } })], 1), _c("HCol", { staticClass: "flex-1", attrs: { "gap": "16" } }, [_c("HRow", { staticClass: "flex-1", attrs: { "justify-content": "space-between" } }, [_c("HCol", { attrs: { "gap": "4" } }, [_c("h4", [_c("AClientName", { attrs: { "client": _vm.client, "bold": "" } })], 1), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v("Ref: " + _vm._s(_vm.client.id))])]), _vm.showFavorite ? _c("AFavorite", { attrs: { "is-favorite": _vm.isFavorite } }) : _vm._e()], 1), _c("HCol", { attrs: { "gap": "4" } }, [_c("p", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.getPrimaryPhone))]), _c("p", [_vm._v(_vm._s(_vm.getPrimaryEmail))])]), _vm.client.address ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.client.address.postcode) + " " + _vm._s(_vm.client.address.town))])]) : _vm._e(), _vm.ownerName ? _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("ada.followed_by")) + " " + _vm._s(_vm.ownerName))]) : _vm._e()], 1)], 1)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_c("HRow", { staticClass: "a-client-card__footer", attrs: { "justify-content": "space-between", "gap": "16" } }, [_vm.client.scammer ? _c("HTag", { attrs: { "label": _vm.$t("client.isScammer"), "color": "red" } }) : _vm._e(), _c("AClientAlerts", { attrs: { "client": _vm.client, "client-appointments-canceled-or-no-show-in-last-seven-days": _vm.clientAppointmentsCanceledOrNoShowInLastSevenDays, "client-issues-count": _vm.clientIssuesCount, "client-expire-mandates-count": _vm.clientExpireMandatesCount } }), _vm.isNew ? _c("HTag", { staticClass: "text-uppercase", attrs: { "label": _vm.$t("client.new"), "color": "red" } }) : _vm._e()], 1)];
  }, proxy: true }]) });
};
var staticRenderFns$l = [];
var AClientCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$l = {
  name: "AClientCard",
  components: {
    AClientName,
    AClientAlerts,
    AClientRating,
    AClientState,
    AFlag,
    AFavorite
  },
  props: {
    client: {
      type: Object,
      required: true
    },
    ownerName: {
      type: String,
      default: ""
    },
    clientAppointmentsCanceledOrNoShowInLastSevenDays: {
      type: Number,
      default: 0,
      required: false
    },
    clientIssuesCount: {
      type: Number,
      default: 0,
      required: false
    },
    clientExpireMandatesCount: {
      type: Number,
      default: 0,
      required: false
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    showFavorite: {
      type: Boolean,
      default: false
    },
    isFavorite: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  computed: {
    getPrimaryPhone() {
      var _a;
      const primary = (_a = this.client.phones) == null ? void 0 : _a.find((phone) => phone.primary);
      return (primary == null ? void 0 : primary.number) ? this.Formatter.useFormatPhone(primary.number) : "";
    },
    getPrimaryEmail() {
      var _a;
      const primary = (_a = this.client.emails) == null ? void 0 : _a.find((email) => email.primary);
      return (primary == null ? void 0 : primary.email) ? primary.email : "";
    },
    isNew() {
      return this.client.stages.find((stage) => stage === "new");
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$l = {};
var __component__$l = /* @__PURE__ */ normalizeComponent(
  script$l,
  render$l,
  staticRenderFns$l,
  false,
  injectStyles$l,
  "104adadf",
  null,
  null
);
function injectStyles$l(context) {
  for (let o in __cssModules$l) {
    this[o] = __cssModules$l[o];
  }
}
var AClientCard = /* @__PURE__ */ function() {
  return __component__$l.exports;
}();
var render$k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HRow", { staticClass: "a-client-alerts", attrs: { "align-items": "center", "gap": "16" } }, [_vm.companyIssuesCount > 0 ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("model.issue", _vm.companyIssuesCount, { number: _vm.companyIssuesCount })) + " ")];
  }, proxy: true }], null, false, 3099626094) }) : _vm._e(), _vm.companyExpireMandatesCount > 0 ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("mandate.expired_mandates", _vm.companyExpireMandatesCount, { number: _vm.companyExpireMandatesCount })) + " ")];
  }, proxy: true }], null, false, 1856001763) }) : _vm._e(), !_vm.hasAlert ? _c("p", [_vm._v(" " + _vm._s(_vm.$t("main.noAlerts")) + " ")]) : _vm._e()], 1);
};
var staticRenderFns$k = [];
var ACompanyAlerts_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$k = {
  name: "ACompanyAlerts",
  props: {
    companyIssuesCount: {
      type: Number,
      default: 0,
      required: false
    },
    companyExpireMandatesCount: {
      type: Number,
      default: 0,
      required: false
    }
  },
  computed: {
    hasAlert() {
      return this.companyIssuesCount > 0 || this.companyExpireMandatesCount > 0;
    }
  }
};
const __cssModules$k = {};
var __component__$k = /* @__PURE__ */ normalizeComponent(
  script$k,
  render$k,
  staticRenderFns$k,
  false,
  injectStyles$k,
  "7edebedb",
  null,
  null
);
function injectStyles$k(context) {
  for (let o in __cssModules$k) {
    this[o] = __cssModules$k[o];
  }
}
var ACompanyAlerts = /* @__PURE__ */ function() {
  return __component__$k.exports;
}();
var render$j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-company-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HCol", { attrs: { "gap": "16" } }, [_c("HCol", { attrs: { "gap": "4" } }, [_c("h4", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.company.name) + " " + _vm._s(_vm.company.type))]), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v("Ref: " + _vm._s(_vm.company.id))])]), _vm.company.address ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", [_vm._v(_vm._s(_vm.company.address.line1))]), _vm.company.address.line2 ? _c("p", [_vm._v(_vm._s(_vm.company.address.line2))]) : _vm._e(), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.company.address.postcode) + " " + _vm._s(_vm.company.address.town))])]) : _vm._e(), _vm.client ? _c("HCol", { attrs: { "gap": "4" } }, [_c("HRow", { staticClass: "text-bold" }, [_c("AClientName", { attrs: { "client": _vm.client } }), _vm.clientFunction ? _c("p", { staticClass: "text-capitalize" }, [_vm._v(" - " + _vm._s(_vm.clientFunction))]) : _vm._e()], 1), _c("p", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.getClientPrimaryPhone))]), _c("p", [_vm._v(_vm._s(_vm.getClientPrimaryEmail))])], 1) : _vm._e(), _vm.ownerName ? _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("client.followed_by")) + " " + _vm._s(_vm.ownerName))]) : _vm._e()], 1)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_c("HRow", { staticClass: "a-company-card__footer" }, [_c("ACompanyAlerts", { attrs: { "company-issues-count": _vm.companyIssuesCount, "company-expire-mandates-count": _vm.companyExpireMandatesCount } })], 1)];
  }, proxy: true }]) });
};
var staticRenderFns$j = [];
var ACompanyCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$j = {
  name: "ACompanyCard",
  components: {
    AClientName,
    ACompanyAlerts
  },
  props: {
    company: {
      type: Object,
      required: true
    },
    client: {
      type: Object,
      default: () => {
      }
    },
    ownerName: {
      type: String,
      default: ""
    },
    companyIssuesCount: {
      type: Number,
      default: 0,
      required: false
    },
    companyExpireMandatesCount: {
      type: Number,
      default: 0,
      required: false
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  computed: {
    clientFunction() {
      const findClient = this.company.clients.find((client2) => client2.clientId === this.client.id);
      return findClient ? findClient.function : null;
    },
    getClientPrimaryPhone() {
      var _a;
      const primary = (_a = this.client.phones) == null ? void 0 : _a.find((phone) => phone.primary);
      return (primary == null ? void 0 : primary.number) ? this.Formatter.useFormatPhone(primary.number) : "";
    },
    getClientPrimaryEmail() {
      var _a;
      const primary = (_a = this.client.emails) == null ? void 0 : _a.find((email) => email.primary);
      return (primary == null ? void 0 : primary.email) ? primary.email : "";
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$j = {};
var __component__$j = /* @__PURE__ */ normalizeComponent(
  script$j,
  render$j,
  staticRenderFns$j,
  false,
  injectStyles$j,
  "13c4f74b",
  null,
  null
);
function injectStyles$j(context) {
  for (let o in __cssModules$j) {
    this[o] = __cssModules$j[o];
  }
}
var ACompanyCard = /* @__PURE__ */ function() {
  return __component__$j.exports;
}();
var render$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HRow", { staticClass: "a-contract-alerts", attrs: { "align-items": "center", "gap": "16" } }, [_vm.contractIssuesCount > 0 ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("model.issue", _vm.contractIssuesCount, { number: _vm.contractIssuesCount })) + " ")];
  }, proxy: true }], null, false, 2802358382) }) : _vm._e(), _vm.contractExpired ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("contract.expired_contracts", _vm.contractExpired)) + " ")];
  }, proxy: true }], null, false, 386178869) }) : _vm._e(), !_vm.hasAlert ? _c("p", [_vm._v(" " + _vm._s(_vm.$t("main.noAlerts")) + " ")]) : _vm._e()], 1);
};
var staticRenderFns$i = [];
const script$i = {
  name: "AContractAlerts",
  props: {
    contractIssuesCount: {
      type: Number,
      default: 0,
      required: false
    },
    contractExpired: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    hasAlert() {
      return this.contractIssuesCount > 0 || this.contractExpired;
    }
  }
};
const __cssModules$i = {};
var __component__$i = /* @__PURE__ */ normalizeComponent(
  script$i,
  render$i,
  staticRenderFns$i,
  false,
  injectStyles$i,
  null,
  null,
  null
);
function injectStyles$i(context) {
  for (let o in __cssModules$i) {
    this[o] = __cssModules$i[o];
  }
}
var AContractAlerts = /* @__PURE__ */ function() {
  return __component__$i.exports;
}();
var render$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HTag", { attrs: { "label": _vm.$t("contract.statusList." + _vm.status), "color": _vm.getColor } });
};
var staticRenderFns$h = [];
const script$h = {
  name: "AContractStatusLabel",
  props: {
    status: {
      type: String,
      validator(value) {
        return value === "draft" || value === "ready" || value === "sent" || value === "completed" || value === "signed_by_leggett" || value === "signed_by_developer" || value === "void" || value === "cancelled";
      },
      required: true
    }
  },
  computed: {
    getColor() {
      if (this.status === "draft") {
        return "grey-400";
      }
      if (this.status === "ready") {
        return "blue-300";
      }
      if (this.status === "sent") {
        return "blue-400";
      }
      if (this.status === "signed_by_leggett" || this.status === "signed_by_developer") {
        return "yellow";
      }
      if (this.status === "completed") {
        return "green";
      }
      if (this.status === "void" || this.status === "cancelled") {
        return "red";
      }
      return "";
    }
  }
};
const __cssModules$h = {};
var __component__$h = /* @__PURE__ */ normalizeComponent(
  script$h,
  render$h,
  staticRenderFns$h,
  false,
  injectStyles$h,
  null,
  null,
  null
);
function injectStyles$h(context) {
  for (let o in __cssModules$h) {
    this[o] = __cssModules$h[o];
  }
}
var AContractStatusLabel = /* @__PURE__ */ function() {
  return __component__$h.exports;
}();
var render$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-contract-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HCol", { attrs: { "gap": "16" } }, [_c("HCol", { attrs: { "gap": "4" } }, [_c("h4", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.$t("contract.name")) + " - " + _vm._s(_vm.contract.reference))]), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("developer.name")) + " : " + _vm._s(_vm.contract.developer.name))])]), _vm.contract.developer.address ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", [_vm._v(_vm._s(_vm.contract.developer.address.line1))]), _vm.contract.developer.address.line2 ? _c("p", [_vm._v(_vm._s(_vm.contract.developer.address.line2))]) : _vm._e(), _c("p", { staticClass: "text-uppercase" }, [_vm._v(" " + _vm._s(_vm.contract.developer.address.postcode) + " " + _vm._s(_vm.contract.developer.address.town) + " ")])]) : _vm._e(), _vm.contact ? _c("HCol", { attrs: { "gap": "4" } }, [_c("HRow", { staticClass: "text-bold" }, [_c("AClientName", { attrs: { "client": _vm.contact } }), _vm.contact && _vm.contact.role ? _c("p", { staticClass: "text-capitalize" }, [_vm._v(" - " + _vm._s(_vm.contact.role))]) : _vm._e()], 1), _c("p", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.getContactPhone))]), _c("p", [_vm._v(_vm._s(_vm.getContactEmail))])], 1) : _vm._e(), _vm.ownerName ? _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("client.followed_by")) + " " + _vm._s(_vm.ownerName))]) : _vm._e()], 1)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_c("HRow", { staticClass: "a-contract-card__footer", attrs: { "justify-content": "space-between", "gap": "16" } }, [_c("AContractAlerts", { attrs: { "contract-issues-count": _vm.contractIssues && _vm.contractIssues.length ? _vm.contractIssues.length : 0, "contract-expired": _vm.isContractExpired } }), _c("AContractStatusLabel", { attrs: { "status": _vm.contract.status } })], 1)];
  }, proxy: true }]) });
};
var staticRenderFns$g = [];
var AContractCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$g = {
  name: "AContractCard",
  components: {
    AClientName,
    AContractAlerts,
    AContractStatusLabel
  },
  props: {
    contract: {
      type: Object,
      required: true
    },
    ownerName: {
      type: String,
      default: ""
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  computed: {
    contact() {
      var _a;
      return (_a = this.contract.developer.contacts) == null ? void 0 : _a.find((contact) => contact.representative);
    },
    getContactPhone() {
      const representative = this.contact;
      return (representative == null ? void 0 : representative.mobile) ? representative == null ? void 0 : representative.mobile : "";
    },
    getContactEmail() {
      const representative = this.contact;
      return (representative == null ? void 0 : representative.email) ? representative == null ? void 0 : representative.email : "";
    },
    isContractExpired() {
      return this.contract.expired;
    },
    contractIssues() {
      return this.contract.issues;
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$g = {};
var __component__$g = /* @__PURE__ */ normalizeComponent(
  script$g,
  render$g,
  staticRenderFns$g,
  false,
  injectStyles$g,
  "3a678c1a",
  null,
  null
);
function injectStyles$g(context) {
  for (let o in __cssModules$g) {
    this[o] = __cssModules$g[o];
  }
}
var AContractCard = /* @__PURE__ */ function() {
  return __component__$g.exports;
}();
var render$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HRow", { staticClass: "a-lot-alerts", attrs: { "align-items": "center", "gap": "16" } }, [_vm.lotIssuesCount > 0 ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("model.issue", _vm.lotIssuesCount, { number: _vm.lotIssuesCount })) + " ")];
  }, proxy: true }], null, false, 2348004718) }) : _vm._e(), _vm.graceActive ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$t("lot.grace_active")) + " ")];
  }, proxy: true }], null, false, 4039030866) }) : _vm._e(), !_vm.hasAlert ? _c("p", [_vm._v(" " + _vm._s(_vm.$t("main.noAlerts")) + " ")]) : _vm._e()], 1);
};
var staticRenderFns$f = [];
const script$f = {
  name: "ALotAlerts",
  props: {
    lotIssuesCount: {
      type: Number,
      default: 0,
      required: false
    },
    graceActive: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    hasAlert() {
      return this.lotIssuesCount > 0 || this.graceActive;
    }
  }
};
const __cssModules$f = {};
var __component__$f = /* @__PURE__ */ normalizeComponent(
  script$f,
  render$f,
  staticRenderFns$f,
  false,
  injectStyles$f,
  null,
  null,
  null
);
function injectStyles$f(context) {
  for (let o in __cssModules$f) {
    this[o] = __cssModules$f[o];
  }
}
var ALotAlerts = /* @__PURE__ */ function() {
  return __component__$f.exports;
}();
var render$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HTag", { attrs: { "label": _vm.$t("program.statusList." + _vm.status), "color": _vm.getColor } });
};
var staticRenderFns$e = [];
const script$e = {
  name: "AProgramStatusLabel",
  props: {
    status: {
      type: String,
      validator(value) {
        return value === "draft" || value === "ready" || value === "void" || value === "cancelled";
      },
      required: true
    }
  },
  computed: {
    getColor() {
      if (this.status === "draft") {
        return "grey-400";
      }
      if (this.status === "ready") {
        return "blue-300";
      }
      if (this.status === "void" || this.status === "cancelled") {
        return "red";
      }
      return "";
    }
  }
};
const __cssModules$e = {};
var __component__$e = /* @__PURE__ */ normalizeComponent(
  script$e,
  render$e,
  staticRenderFns$e,
  false,
  injectStyles$e,
  null,
  null,
  null
);
function injectStyles$e(context) {
  for (let o in __cssModules$e) {
    this[o] = __cssModules$e[o];
  }
}
var AProgramStatusLabel = /* @__PURE__ */ function() {
  return __component__$e.exports;
}();
var render$d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-lot-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HCol", { attrs: { "gap": "16" } }, [_c("HCol", { attrs: { "gap": "4" } }, [_c("h4", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.lot.propertyId) + " - " + _vm._s(_vm.property.title[_vm.$i18n.locale] ? _vm.property.title[_vm.$i18n.locale] : ""))]), _c("p", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.$t("lot.name")) + " : " + _vm._s(_vm.lot.id))]), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("developer.name")) + " : " + _vm._s(_vm.lot.developer.name))]), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.Formatter.useFormatPrice(_vm.lot.price.min)) + " / " + _vm._s(_vm.Formatter.useFormatPrice(_vm.lot.price.max)))])]), _vm.property.address ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", [_vm._v(_vm._s(_vm.property.address.line1))]), _vm.property.address.line2 ? _c("p", [_vm._v(_vm._s(_vm.property.address.line2))]) : _vm._e(), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.property.address.postcode) + " " + _vm._s(_vm.property.address.town))]), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.lot.program.typology.toString()))])]) : _vm._e(), _vm.lot.program.deliveryDate && _vm.lot.program.actableDate ? _c("HCol", { attrs: { "gap": "4" } }, [_c("HRow", [_c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(" " + _vm._s(_vm.$t("lot.actability")) + " quarter." + _vm._s(_vm.lot.program.actableDate.quarter) + " / " + _vm._s(_vm.lot.program.actableDate.year))])]), _c("HRow", [_c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(" " + _vm._s(_vm.$t("lot.delivery")) + " quarter." + _vm._s(_vm.lot.program.deliveryDate.quarter) + " / " + _vm._s(_vm.lot.program.deliveryDate.year))])])], 1) : _vm._e(), _vm.ownerName ? _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("client.followed_by")) + " " + _vm._s(_vm.ownerName))]) : _vm._e()], 1)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_c("HRow", { staticClass: "a-lot-card__footer", attrs: { "justify-content": "space-between", "gap": "16" } }, [_c("ALotAlerts", { attrs: { "lot-issues-count": _vm.lotIssues && _vm.lotIssues.length ? _vm.lotIssues.length : 0, "grace-active": _vm.lot && _vm.lot.grace ? _vm.lot.grace.active : false } }), _vm.lot && _vm.lot.program && _vm.lot.status ? _c("AProgramStatusLabel", { attrs: { "status": _vm.lot.program.status } }) : _vm._e()], 1)];
  }, proxy: true }]) });
};
var staticRenderFns$d = [];
var ALotCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$d = {
  name: "ALotCard",
  components: {
    AProgramStatusLabel,
    ALotAlerts
  },
  props: {
    lot: {
      type: Object,
      required: true
    },
    property: {
      type: Object,
      required: true
    },
    ownerName: {
      type: String,
      default: ""
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  computed: {
    lotIssues() {
      var _a;
      return (_a = this.program) == null ? void 0 : _a.issues;
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$d = {};
var __component__$d = /* @__PURE__ */ normalizeComponent(
  script$d,
  render$d,
  staticRenderFns$d,
  false,
  injectStyles$d,
  "bb7b4616",
  null,
  null
);
function injectStyles$d(context) {
  for (let o in __cssModules$d) {
    this[o] = __cssModules$d[o];
  }
}
var ALotCard = /* @__PURE__ */ function() {
  return __component__$d.exports;
}();
var commonjsGlobal$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var dayjs_min = { exports: {} };
(function(module, exports) {
  !function(t3, e) {
    module.exports = e();
  }(commonjsGlobal$1, function() {
    var t3 = 1e3, e = 6e4, n2 = 36e5, r = "millisecond", i2 = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d2 = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t4) {
      var e2 = ["th", "st", "nd", "rd"], n3 = t4 % 100;
      return "[" + t4 + (e2[(n3 - 20) % 10] || e2[n3] || e2[0]) + "]";
    } }, m = function(t4, e2, n3) {
      var r2 = String(t4);
      return !r2 || r2.length >= e2 ? t4 : "" + Array(e2 + 1 - r2.length).join(n3) + t4;
    }, v = { s: m, z: function(t4) {
      var e2 = -t4.utcOffset(), n3 = Math.abs(e2), r2 = Math.floor(n3 / 60), i3 = n3 % 60;
      return (e2 <= 0 ? "+" : "-") + m(r2, 2, "0") + ":" + m(i3, 2, "0");
    }, m: function t4(e2, n3) {
      if (e2.date() < n3.date())
        return -t4(n3, e2);
      var r2 = 12 * (n3.year() - e2.year()) + (n3.month() - e2.month()), i3 = e2.clone().add(r2, c), s2 = n3 - i3 < 0, u2 = e2.clone().add(r2 + (s2 ? -1 : 1), c);
      return +(-(r2 + (n3 - i3) / (s2 ? i3 - u2 : u2 - i3)) || 0);
    }, a: function(t4) {
      return t4 < 0 ? Math.ceil(t4) || 0 : Math.floor(t4);
    }, p: function(t4) {
      return { M: c, y: h, w: o, d: a, D: d2, h: u, m: s, s: i2, ms: r, Q: f }[t4] || String(t4 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t4) {
      return void 0 === t4;
    } }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t4) {
      return t4 instanceof _ || !(!t4 || !t4[p]);
    }, w = function t4(e2, n3, r2) {
      var i3;
      if (!e2)
        return g;
      if ("string" == typeof e2) {
        var s2 = e2.toLowerCase();
        D[s2] && (i3 = s2), n3 && (D[s2] = n3, i3 = s2);
        var u2 = e2.split("-");
        if (!i3 && u2.length > 1)
          return t4(u2[0]);
      } else {
        var a2 = e2.name;
        D[a2] = e2, i3 = a2;
      }
      return !r2 && i3 && (g = i3), i3 || !r2 && g;
    }, O = function(t4, e2) {
      if (S(t4))
        return t4.clone();
      var n3 = "object" == typeof e2 ? e2 : {};
      return n3.date = t4, n3.args = arguments, new _(n3);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t4, e2) {
      return O(t4, { locale: e2.$L, utc: e2.$u, x: e2.$x, $offset: e2.$offset });
    };
    var _ = function() {
      function M2(t4) {
        this.$L = w(t4.locale, null, true), this.parse(t4), this.$x = this.$x || t4.x || {}, this[p] = true;
      }
      var m2 = M2.prototype;
      return m2.parse = function(t4) {
        this.$d = function(t5) {
          var e2 = t5.date, n3 = t5.utc;
          if (null === e2)
            return new Date(NaN);
          if (b.u(e2))
            return new Date();
          if (e2 instanceof Date)
            return new Date(e2);
          if ("string" == typeof e2 && !/Z$/i.test(e2)) {
            var r2 = e2.match($);
            if (r2) {
              var i3 = r2[2] - 1 || 0, s2 = (r2[7] || "0").substring(0, 3);
              return n3 ? new Date(Date.UTC(r2[1], i3, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2)) : new Date(r2[1], i3, r2[3] || 1, r2[4] || 0, r2[5] || 0, r2[6] || 0, s2);
            }
          }
          return new Date(e2);
        }(t4), this.init();
      }, m2.init = function() {
        var t4 = this.$d;
        this.$y = t4.getFullYear(), this.$M = t4.getMonth(), this.$D = t4.getDate(), this.$W = t4.getDay(), this.$H = t4.getHours(), this.$m = t4.getMinutes(), this.$s = t4.getSeconds(), this.$ms = t4.getMilliseconds();
      }, m2.$utils = function() {
        return b;
      }, m2.isValid = function() {
        return !(this.$d.toString() === l);
      }, m2.isSame = function(t4, e2) {
        var n3 = O(t4);
        return this.startOf(e2) <= n3 && n3 <= this.endOf(e2);
      }, m2.isAfter = function(t4, e2) {
        return O(t4) < this.startOf(e2);
      }, m2.isBefore = function(t4, e2) {
        return this.endOf(e2) < O(t4);
      }, m2.$g = function(t4, e2, n3) {
        return b.u(t4) ? this[e2] : this.set(n3, t4);
      }, m2.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m2.valueOf = function() {
        return this.$d.getTime();
      }, m2.startOf = function(t4, e2) {
        var n3 = this, r2 = !!b.u(e2) || e2, f2 = b.p(t4), l2 = function(t5, e3) {
          var i3 = b.w(n3.$u ? Date.UTC(n3.$y, e3, t5) : new Date(n3.$y, e3, t5), n3);
          return r2 ? i3 : i3.endOf(a);
        }, $2 = function(t5, e3) {
          return b.w(n3.toDate()[t5].apply(n3.toDate("s"), (r2 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e3)), n3);
        }, y2 = this.$W, M3 = this.$M, m3 = this.$D, v2 = "set" + (this.$u ? "UTC" : "");
        switch (f2) {
          case h:
            return r2 ? l2(1, 0) : l2(31, 11);
          case c:
            return r2 ? l2(1, M3) : l2(0, M3 + 1);
          case o:
            var g2 = this.$locale().weekStart || 0, D2 = (y2 < g2 ? y2 + 7 : y2) - g2;
            return l2(r2 ? m3 - D2 : m3 + (6 - D2), M3);
          case a:
          case d2:
            return $2(v2 + "Hours", 0);
          case u:
            return $2(v2 + "Minutes", 1);
          case s:
            return $2(v2 + "Seconds", 2);
          case i2:
            return $2(v2 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m2.endOf = function(t4) {
        return this.startOf(t4, false);
      }, m2.$set = function(t4, e2) {
        var n3, o2 = b.p(t4), f2 = "set" + (this.$u ? "UTC" : ""), l2 = (n3 = {}, n3[a] = f2 + "Date", n3[d2] = f2 + "Date", n3[c] = f2 + "Month", n3[h] = f2 + "FullYear", n3[u] = f2 + "Hours", n3[s] = f2 + "Minutes", n3[i2] = f2 + "Seconds", n3[r] = f2 + "Milliseconds", n3)[o2], $2 = o2 === a ? this.$D + (e2 - this.$W) : e2;
        if (o2 === c || o2 === h) {
          var y2 = this.clone().set(d2, 1);
          y2.$d[l2]($2), y2.init(), this.$d = y2.set(d2, Math.min(this.$D, y2.daysInMonth())).$d;
        } else
          l2 && this.$d[l2]($2);
        return this.init(), this;
      }, m2.set = function(t4, e2) {
        return this.clone().$set(t4, e2);
      }, m2.get = function(t4) {
        return this[b.p(t4)]();
      }, m2.add = function(r2, f2) {
        var d3, l2 = this;
        r2 = Number(r2);
        var $2 = b.p(f2), y2 = function(t4) {
          var e2 = O(l2);
          return b.w(e2.date(e2.date() + Math.round(t4 * r2)), l2);
        };
        if ($2 === c)
          return this.set(c, this.$M + r2);
        if ($2 === h)
          return this.set(h, this.$y + r2);
        if ($2 === a)
          return y2(1);
        if ($2 === o)
          return y2(7);
        var M3 = (d3 = {}, d3[s] = e, d3[u] = n2, d3[i2] = t3, d3)[$2] || 1, m3 = this.$d.getTime() + r2 * M3;
        return b.w(m3, this);
      }, m2.subtract = function(t4, e2) {
        return this.add(-1 * t4, e2);
      }, m2.format = function(t4) {
        var e2 = this, n3 = this.$locale();
        if (!this.isValid())
          return n3.invalidDate || l;
        var r2 = t4 || "YYYY-MM-DDTHH:mm:ssZ", i3 = b.z(this), s2 = this.$H, u2 = this.$m, a2 = this.$M, o2 = n3.weekdays, c2 = n3.months, f2 = n3.meridiem, h2 = function(t5, n4, i4, s3) {
          return t5 && (t5[n4] || t5(e2, r2)) || i4[n4].slice(0, s3);
        }, d3 = function(t5) {
          return b.s(s2 % 12 || 12, t5, "0");
        }, $2 = f2 || function(t5, e3, n4) {
          var r3 = t5 < 12 ? "AM" : "PM";
          return n4 ? r3.toLowerCase() : r3;
        };
        return r2.replace(y, function(t5, r3) {
          return r3 || function(t6) {
            switch (t6) {
              case "YY":
                return String(e2.$y).slice(-2);
              case "YYYY":
                return b.s(e2.$y, 4, "0");
              case "M":
                return a2 + 1;
              case "MM":
                return b.s(a2 + 1, 2, "0");
              case "MMM":
                return h2(n3.monthsShort, a2, c2, 3);
              case "MMMM":
                return h2(c2, a2);
              case "D":
                return e2.$D;
              case "DD":
                return b.s(e2.$D, 2, "0");
              case "d":
                return String(e2.$W);
              case "dd":
                return h2(n3.weekdaysMin, e2.$W, o2, 2);
              case "ddd":
                return h2(n3.weekdaysShort, e2.$W, o2, 3);
              case "dddd":
                return o2[e2.$W];
              case "H":
                return String(s2);
              case "HH":
                return b.s(s2, 2, "0");
              case "h":
                return d3(1);
              case "hh":
                return d3(2);
              case "a":
                return $2(s2, u2, true);
              case "A":
                return $2(s2, u2, false);
              case "m":
                return String(u2);
              case "mm":
                return b.s(u2, 2, "0");
              case "s":
                return String(e2.$s);
              case "ss":
                return b.s(e2.$s, 2, "0");
              case "SSS":
                return b.s(e2.$ms, 3, "0");
              case "Z":
                return i3;
            }
            return null;
          }(t5) || i3.replace(":", "");
        });
      }, m2.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m2.diff = function(r2, d3, l2) {
        var $2, y2 = this, M3 = b.p(d3), m3 = O(r2), v2 = (m3.utcOffset() - this.utcOffset()) * e, g2 = this - m3, D2 = function() {
          return b.m(y2, m3);
        };
        switch (M3) {
          case h:
            $2 = D2() / 12;
            break;
          case c:
            $2 = D2();
            break;
          case f:
            $2 = D2() / 3;
            break;
          case o:
            $2 = (g2 - v2) / 6048e5;
            break;
          case a:
            $2 = (g2 - v2) / 864e5;
            break;
          case u:
            $2 = g2 / n2;
            break;
          case s:
            $2 = g2 / e;
            break;
          case i2:
            $2 = g2 / t3;
            break;
          default:
            $2 = g2;
        }
        return l2 ? $2 : b.a($2);
      }, m2.daysInMonth = function() {
        return this.endOf(c).$D;
      }, m2.$locale = function() {
        return D[this.$L];
      }, m2.locale = function(t4, e2) {
        if (!t4)
          return this.$L;
        var n3 = this.clone(), r2 = w(t4, e2, true);
        return r2 && (n3.$L = r2), n3;
      }, m2.clone = function() {
        return b.w(this.$d, this);
      }, m2.toDate = function() {
        return new Date(this.valueOf());
      }, m2.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m2.toISOString = function() {
        return this.$d.toISOString();
      }, m2.toString = function() {
        return this.$d.toUTCString();
      }, M2;
    }(), k = _.prototype;
    return O.prototype = k, [["$ms", r], ["$s", i2], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d2]].forEach(function(t4) {
      k[t4[1]] = function(e2) {
        return this.$g(e2, t4[0], t4[1]);
      };
    }), O.extend = function(t4, e2) {
      return t4.$i || (t4(e2, _, O), t4.$i = true), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t4) {
      return O(1e3 * t4);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
  });
})(dayjs_min);
var dayjs = dayjs_min.exports;
var isSameOrBefore$1 = { exports: {} };
(function(module, exports) {
  !function(e, i2) {
    module.exports = i2();
  }(commonjsGlobal$1, function() {
    return function(e, i2) {
      i2.prototype.isSameOrBefore = function(e2, i3) {
        return this.isSame(e2, i3) || this.isBefore(e2, i3);
      };
    };
  });
})(isSameOrBefore$1);
var isSameOrBefore = isSameOrBefore$1.exports;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var awesomePhonenumber = { exports: {} };
var lib = { exports: {} };
(function(module) {
  (function() {
    var aa = this || self;
    function h(a, b) {
      function c() {
      }
      c.prototype = b.prototype;
      a.Ba = b.prototype;
      a.prototype = new c();
      a.prototype.constructor = a;
      a.Ha = function(d2, e, f) {
        for (var g = Array(arguments.length - 2), l = 2; l < arguments.length; l++)
          g[l - 2] = arguments[l];
        return b.prototype[e].apply(d2, g);
      };
    }
    function ba(a) {
      var b = [];
      let c = 0;
      for (var d2 in a)
        b[c++] = a[d2];
      return b;
    }
    function ca(a, b) {
      this.h = a;
      this.g = {};
      for (a = 0; a < b.length; a++) {
        var c = b[a];
        this.g[c.g] = c;
      }
    }
    function da(a) {
      a = ba(a.g);
      a.sort(function(b, c) {
        return b.g - c.g;
      });
      return a;
    }
    function ea(a, b) {
      this.g = a;
      this.l = !!b.fa;
      this.h = b.i;
      this.s = b.type;
      this.o = false;
      switch (this.h) {
        case fa:
        case ha:
        case ia:
        case ja:
        case ka:
        case la:
        case ma:
          this.o = true;
      }
      this.j = b.defaultValue;
    }
    var ma = 1, la = 2, fa = 3, ha = 4, ia = 6, ja = 16, ka = 18;
    function k() {
      this.h = {};
      this.j = this.m().g;
      this.g = this.l = null;
    }
    k.prototype.has = function(a) {
      return m(this, a.g);
    };
    k.prototype.get = function(a, b) {
      return n2(this, a.g, b);
    };
    k.prototype.set = function(a, b) {
      p(this, a.g, b);
    };
    k.prototype.add = function(a, b) {
      na(this, a.g, b);
    };
    function oa(a, b) {
      for (var c = da(a.m()), d2 = 0; d2 < c.length; d2++) {
        var e = c[d2], f = e.g;
        if (m(b, f)) {
          a.g && delete a.g[e.g];
          var g = 11 == e.h || 10 == e.h;
          if (e.l) {
            e = r(b, f);
            for (var l = 0; l < e.length; l++)
              na(a, f, g ? e[l].clone() : e[l]);
          } else
            e = t3(b, f), g ? (g = t3(a, f)) ? oa(g, e) : p(a, f, e.clone()) : p(a, f, e);
        }
      }
    }
    k.prototype.clone = function() {
      var a = new this.constructor();
      a != this && (a.h = {}, a.g && (a.g = {}), oa(a, this));
      return a;
    };
    function m(a, b) {
      return null != a.h[b];
    }
    function t3(a, b) {
      var c = a.h[b];
      if (null == c)
        return null;
      if (a.l) {
        if (!(b in a.g)) {
          var d2 = a.l, e = a.j[b];
          if (null != c)
            if (e.l) {
              for (var f = [], g = 0; g < c.length; g++)
                f[g] = d2.h(e, c[g]);
              c = f;
            } else
              c = d2.h(e, c);
          return a.g[b] = c;
        }
        return a.g[b];
      }
      return c;
    }
    function n2(a, b, c) {
      var d2 = t3(a, b);
      return a.j[b].l ? d2[c || 0] : d2;
    }
    function u(a, b) {
      if (m(a, b))
        a = n2(a, b);
      else
        a: {
          a = a.j[b];
          if (void 0 === a.j)
            if (b = a.s, b === Boolean)
              a.j = false;
            else if (b === Number)
              a.j = 0;
            else if (b === String)
              a.j = a.o ? "0" : "";
            else {
              a = new b();
              break a;
            }
          a = a.j;
        }
      return a;
    }
    function r(a, b) {
      return t3(a, b) || [];
    }
    function v(a, b) {
      return a.j[b].l ? m(a, b) ? a.h[b].length : 0 : m(a, b) ? 1 : 0;
    }
    function p(a, b, c) {
      a.h[b] = c;
      a.g && (a.g[b] = c);
    }
    function na(a, b, c) {
      a.h[b] || (a.h[b] = []);
      a.h[b].push(c);
      a.g && delete a.g[b];
    }
    function w(a, b) {
      var c = [], d2;
      for (d2 in b)
        0 != d2 && c.push(new ea(d2, b[d2]));
      return new ca(a, c);
    }
    function x() {
    }
    x.prototype.g = function(a) {
      new a.h();
      throw Error("Unimplemented");
    };
    x.prototype.h = function(a, b) {
      if (11 == a.h || 10 == a.h)
        return b instanceof k ? b : this.g(a.s.prototype.m(), b);
      if (14 == a.h)
        return "string" === typeof b && pa.test(b) && (a = Number(b), 0 < a) ? a : b;
      if (!a.o)
        return b;
      a = a.s;
      if (a === String) {
        if ("number" === typeof b)
          return String(b);
      } else if (a === Number && "string" === typeof b && ("Infinity" === b || "-Infinity" === b || "NaN" === b || pa.test(b)))
        return Number(b);
      return b;
    };
    var pa = /^-?[0-9]+$/;
    function qa() {
    }
    h(qa, x);
    qa.prototype.g = function(a, b) {
      a = new a.h();
      a.l = this;
      a.h = b;
      a.g = {};
      return a;
    };
    function y() {
    }
    h(y, qa);
    y.prototype.h = function(a, b) {
      return 8 == a.h ? !!b : x.prototype.h.apply(this, arguments);
    };
    y.prototype.g = function(a, b) {
      return y.Ba.g.call(this, a, b);
    };
    function z(a, b) {
      null != a && this.g.apply(this, arguments);
    }
    z.prototype.h = "";
    z.prototype.set = function(a) {
      this.h = "" + a;
    };
    z.prototype.g = function(a, b, c) {
      this.h += String(a);
      if (null != b)
        for (let d2 = 1; d2 < arguments.length; d2++)
          this.h += arguments[d2];
      return this;
    };
    function A(a) {
      a.h = "";
    }
    z.prototype.toString = function() {
      return this.h;
    };
    function B() {
      k.call(this);
    }
    h(B, k);
    var ra = null;
    function C() {
      k.call(this);
    }
    h(C, k);
    var sa = null;
    function D() {
      k.call(this);
    }
    h(D, k);
    var ta = null;
    D.prototype.ha = function() {
      return n2(this, 10);
    };
    B.prototype.m = function() {
      var a = ra;
      a || (ra = a = w(B, { 0: { name: "NumberFormat", ma: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: true, i: 9, type: String }, 2: { name: "format", required: true, i: 9, type: String }, 3: { name: "leading_digits_pattern", fa: true, i: 9, type: String }, 4: { name: "national_prefix_formatting_rule", i: 9, type: String }, 6: { name: "national_prefix_optional_when_formatting", i: 8, defaultValue: false, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", i: 9, type: String } }));
      return a;
    };
    B.m = B.prototype.m;
    C.prototype.m = function() {
      var a = sa;
      a || (sa = a = w(C, { 0: { name: "PhoneNumberDesc", ma: "i18n.phonenumbers.PhoneNumberDesc" }, 2: { name: "national_number_pattern", i: 9, type: String }, 9: { name: "possible_length", fa: true, i: 5, type: Number }, 10: { name: "possible_length_local_only", fa: true, i: 5, type: Number }, 6: { name: "example_number", i: 9, type: String } }));
      return a;
    };
    C.m = C.prototype.m;
    D.prototype.m = function() {
      var a = ta;
      a || (ta = a = w(D, {
        0: { name: "PhoneMetadata", ma: "i18n.phonenumbers.PhoneMetadata" },
        1: { name: "general_desc", i: 11, type: C },
        2: { name: "fixed_line", i: 11, type: C },
        3: { name: "mobile", i: 11, type: C },
        4: { name: "toll_free", i: 11, type: C },
        5: { name: "premium_rate", i: 11, type: C },
        6: { name: "shared_cost", i: 11, type: C },
        7: { name: "personal_number", i: 11, type: C },
        8: { name: "voip", i: 11, type: C },
        21: { name: "pager", i: 11, type: C },
        25: { name: "uan", i: 11, type: C },
        27: { name: "emergency", i: 11, type: C },
        28: { name: "voicemail", i: 11, type: C },
        29: { name: "short_code", i: 11, type: C },
        30: { name: "standard_rate", i: 11, type: C },
        31: { name: "carrier_specific", i: 11, type: C },
        33: { name: "sms_services", i: 11, type: C },
        24: { name: "no_international_dialling", i: 11, type: C },
        9: { name: "id", required: true, i: 9, type: String },
        10: { name: "country_code", i: 5, type: Number },
        11: { name: "international_prefix", i: 9, type: String },
        17: { name: "preferred_international_prefix", i: 9, type: String },
        12: { name: "national_prefix", i: 9, type: String },
        13: { name: "preferred_extn_prefix", i: 9, type: String },
        15: {
          name: "national_prefix_for_parsing",
          i: 9,
          type: String
        },
        16: { name: "national_prefix_transform_rule", i: 9, type: String },
        18: { name: "same_mobile_and_fixed_line_pattern", i: 8, defaultValue: false, type: Boolean },
        19: { name: "number_format", fa: true, i: 11, type: B },
        20: { name: "intl_number_format", fa: true, i: 11, type: B },
        22: { name: "main_country_for_code", i: 8, defaultValue: false, type: Boolean },
        23: { name: "leading_digits", i: 9, type: String },
        26: { name: "leading_zero_possible", i: 8, defaultValue: false, type: Boolean }
      }));
      return a;
    };
    D.m = D.prototype.m;
    function E() {
      k.call(this);
    }
    h(E, k);
    var ua = null;
    E.prototype.ha = function() {
      return n2(this, 1);
    };
    var va = { Ga: 0, Fa: 1, Ea: 5, Da: 10, Ca: 20 };
    E.prototype.m = function() {
      var a = ua;
      a || (ua = a = w(E, { 0: { name: "PhoneNumber", ma: "i18n.phonenumbers.PhoneNumber" }, 1: { name: "country_code", required: true, i: 5, type: Number }, 2: { name: "national_number", required: true, i: 4, type: Number }, 3: { name: "extension", i: 9, type: String }, 4: { name: "italian_leading_zero", i: 8, type: Boolean }, 8: { name: "number_of_leading_zeros", i: 5, defaultValue: 1, type: Number }, 5: { name: "raw_input", i: 9, type: String }, 6: { name: "country_code_source", i: 14, defaultValue: 0, type: va }, 7: {
        name: "preferred_domestic_carrier_code",
        i: 9,
        type: String
      } }));
      return a;
    };
    E.ctor = E;
    E.ctor.m = E.prototype.m;
    var F = {
      1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
      7: ["RU", "KZ"],
      20: ["EG"],
      27: ["ZA"],
      30: ["GR"],
      31: ["NL"],
      32: ["BE"],
      33: ["FR"],
      34: ["ES"],
      36: ["HU"],
      39: ["IT", "VA"],
      40: ["RO"],
      41: ["CH"],
      43: ["AT"],
      44: ["GB", "GG", "IM", "JE"],
      45: ["DK"],
      46: ["SE"],
      47: ["NO", "SJ"],
      48: ["PL"],
      49: ["DE"],
      51: ["PE"],
      52: ["MX"],
      53: ["CU"],
      54: ["AR"],
      55: ["BR"],
      56: ["CL"],
      57: ["CO"],
      58: ["VE"],
      60: ["MY"],
      61: ["AU", "CC", "CX"],
      62: ["ID"],
      63: ["PH"],
      64: ["NZ"],
      65: ["SG"],
      66: ["TH"],
      81: ["JP"],
      82: ["KR"],
      84: ["VN"],
      86: ["CN"],
      90: ["TR"],
      91: ["IN"],
      92: ["PK"],
      93: ["AF"],
      94: ["LK"],
      95: ["MM"],
      98: ["IR"],
      211: ["SS"],
      212: ["MA", "EH"],
      213: ["DZ"],
      216: ["TN"],
      218: ["LY"],
      220: ["GM"],
      221: ["SN"],
      222: ["MR"],
      223: ["ML"],
      224: ["GN"],
      225: ["CI"],
      226: ["BF"],
      227: ["NE"],
      228: ["TG"],
      229: ["BJ"],
      230: ["MU"],
      231: ["LR"],
      232: ["SL"],
      233: ["GH"],
      234: ["NG"],
      235: ["TD"],
      236: ["CF"],
      237: ["CM"],
      238: ["CV"],
      239: ["ST"],
      240: ["GQ"],
      241: ["GA"],
      242: ["CG"],
      243: ["CD"],
      244: ["AO"],
      245: ["GW"],
      246: ["IO"],
      247: ["AC"],
      248: ["SC"],
      249: ["SD"],
      250: ["RW"],
      251: ["ET"],
      252: ["SO"],
      253: ["DJ"],
      254: ["KE"],
      255: ["TZ"],
      256: ["UG"],
      257: ["BI"],
      258: ["MZ"],
      260: ["ZM"],
      261: ["MG"],
      262: ["RE", "YT"],
      263: ["ZW"],
      264: ["NA"],
      265: ["MW"],
      266: ["LS"],
      267: ["BW"],
      268: ["SZ"],
      269: ["KM"],
      290: ["SH", "TA"],
      291: ["ER"],
      297: ["AW"],
      298: ["FO"],
      299: ["GL"],
      350: ["GI"],
      351: ["PT"],
      352: ["LU"],
      353: ["IE"],
      354: ["IS"],
      355: ["AL"],
      356: ["MT"],
      357: ["CY"],
      358: ["FI", "AX"],
      359: ["BG"],
      370: ["LT"],
      371: ["LV"],
      372: ["EE"],
      373: ["MD"],
      374: ["AM"],
      375: ["BY"],
      376: ["AD"],
      377: ["MC"],
      378: ["SM"],
      380: ["UA"],
      381: ["RS"],
      382: ["ME"],
      383: ["XK"],
      385: ["HR"],
      386: ["SI"],
      387: ["BA"],
      389: ["MK"],
      420: ["CZ"],
      421: ["SK"],
      423: ["LI"],
      500: ["FK"],
      501: ["BZ"],
      502: ["GT"],
      503: ["SV"],
      504: ["HN"],
      505: ["NI"],
      506: ["CR"],
      507: ["PA"],
      508: ["PM"],
      509: ["HT"],
      590: ["GP", "BL", "MF"],
      591: ["BO"],
      592: ["GY"],
      593: ["EC"],
      594: ["GF"],
      595: ["PY"],
      596: ["MQ"],
      597: ["SR"],
      598: ["UY"],
      599: ["CW", "BQ"],
      670: ["TL"],
      672: ["NF"],
      673: ["BN"],
      674: ["NR"],
      675: ["PG"],
      676: ["TO"],
      677: ["SB"],
      678: ["VU"],
      679: ["FJ"],
      680: ["PW"],
      681: ["WF"],
      682: ["CK"],
      683: ["NU"],
      685: ["WS"],
      686: ["KI"],
      687: ["NC"],
      688: ["TV"],
      689: ["PF"],
      690: ["TK"],
      691: ["FM"],
      692: ["MH"],
      800: ["001"],
      808: ["001"],
      850: ["KP"],
      852: ["HK"],
      853: ["MO"],
      855: ["KH"],
      856: ["LA"],
      870: ["001"],
      878: ["001"],
      880: ["BD"],
      881: ["001"],
      882: ["001"],
      883: ["001"],
      886: ["TW"],
      888: ["001"],
      960: ["MV"],
      961: ["LB"],
      962: ["JO"],
      963: ["SY"],
      964: ["IQ"],
      965: ["KW"],
      966: ["SA"],
      967: ["YE"],
      968: ["OM"],
      970: ["PS"],
      971: ["AE"],
      972: ["IL"],
      973: ["BH"],
      974: ["QA"],
      975: ["BT"],
      976: ["MN"],
      977: ["NP"],
      979: ["001"],
      992: ["TJ"],
      993: ["TM"],
      994: ["AZ"],
      995: ["GE"],
      996: ["KG"],
      998: ["UZ"]
    }, G = {
      AC: [, [
        ,
        ,
        "(?:[01589]\\d|[46])\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6]
      ], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:0[1-9]|[1589]\\d)\\d{4}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]],
      AD: [
        ,
        [, , "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", , , , , , , [6, 8, 9]],
        [, , "[78]\\d{5}", , , , "712345", , , [6]],
        [, , "690\\d{6}|[356]\\d{5}", , , , "312345", , , [6, 9]],
        [, , "180[02]\\d{4}", , , , "18001234", , , [8]],
        [, , "[19]\\d{5}", , , , "912345", , , [6]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AD",
        376,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "1800\\d{4}", , , , , , , [8]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AE: [
        ,
        [, , "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
        [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]],
        [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]],
        [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"],
        [, , "900[02]\\d{5}", , , , "900234567", , , [9]],
        [, , "700[05]\\d{5}", , , , "700012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AE",
        971,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "600[25]\\d{5}", , , , "600212345", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AF: [, [, , "[2-7]\\d{8}", , , , , , , [9], [7]], [
        ,
        ,
        "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}",
        ,
        ,
        ,
        "234567890",
        ,
        ,
        ,
        [7]
      ], [, , "7\\d{8}", , , , "701234567", , , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AG: [
        ,
        [, , "(?:268|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}",
          ,
          ,
          ,
          "2684601234",
          ,
          ,
          ,
          [7]
        ],
        [, , "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}", , , , "2684641234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]],
        "AG",
        1,
        "011",
        "1",
        ,
        ,
        "1|([457]\\d{6})$",
        "268$1",
        ,
        ,
        ,
        ,
        [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]],
        ,
        "268",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AI: [, [, , "(?:264|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "264(?:292|4(?:6[12]|9[78]))\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "1|([2457]\\d{6})$", "264$1", , , , , [, , "264724\\d{4}", , , , "2647241234", , , , [7]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AL: [, [, , "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", , , , , , , [6, 7, 8, 9], [5]], [, , "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[78][2-9]|9\\d)\\d{6}", , , , "672123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [
        ,
        ,
        "900[1-9]\\d\\d",
        ,
        ,
        ,
        "900123",
        ,
        ,
        [6]
      ], [, , "808[1-9]\\d\\d", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AM: [, [
        ,
        ,
        "(?:[1-489]\\d|55|60|77)\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8],
        [5, 6]
      ], [, , "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}", , , , "10123456", , , , [5, 6]], [, , "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], [, , "90[016]\\d{5}", , , , "90012345"], [, , "80[1-4]\\d{5}", , , , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[01])\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [
        ,
        "(\\d{3})(\\d{5})",
        "$1 $2",
        ["2|3[12]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AO: [
        ,
        [, , "[29]\\d{8}", , , , , , , [9]],
        [, , "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}", , , , "222123456"],
        [, , "9[1-59]\\d{7}", , , , "923123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AO",
        244,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AR: [
        ,
        [, , "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", , , , , , , [10, 11], [6, 7, 8]],
        [
          ,
          ,
          "3888[013-9]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
          ,
          ,
          ,
          "1123456789",
          ,
          ,
          [10],
          [6, 7, 8]
        ],
        [
          ,
          ,
          "93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
          ,
          ,
          ,
          "91123456789",
          ,
          ,
          ,
          [6, 7, 8]
        ],
        [, , "800\\d{7,8}", , , , "8001234567"],
        [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "AR",
        54,
        "00",
        "0",
        ,
        ,
        "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
        "9$1",
        ,
        ,
        [[, "(\\d{3})", "$1", ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[1-9]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[1-8]"]], [
          ,
          "(\\d{4})(\\d{2})(\\d{4})",
          "$1 $2-$3",
          [
            "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
            "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ],
          "0$1",
          ,
          1
        ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [
          ,
          "(\\d)(\\d{4})(\\d{2})(\\d{4})",
          "$2 15-$3-$4",
          [
            "9(?:2[2-469]|3[3-578])",
            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ],
          "0$1"
        ], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]],
        [
          [
            ,
            "(\\d{4})(\\d{2})(\\d{4})",
            "$1 $2-$3",
            [
              "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
              "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
              "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
            ],
            "0$1",
            ,
            1
          ],
          [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1],
          [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", [
            "9(?:2[2-469]|3[3-578])",
            "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
            "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
            "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
          ]],
          [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]],
          [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"],
          [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9"]]
        ],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "810\\d{7}", , , , , , , [10]],
        [, , "810\\d{7}", , , , "8101234567", , , [10]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AS: [, [, , "(?:[58]\\d\\d|684|900)\\d{7}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:48|5[2468]|72)|7(?:3[13]|70|82))\\d{4}", , , , "6847331234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "1|([267]\\d{6})$", "684$1", , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AT: [, [
        ,
        ,
        "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
        ,
        ,
        ,
        ,
        ,
        ,
        [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        [3]
      ], [, , "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}", , , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], [
        ,
        ,
        "800\\d{6,10}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9, 10, 11, 12, 13]
      ], [, , "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10|2[018])\\d{6,10}|828\\d{5}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", , , , "780123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , [
        [, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
        [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
        [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
        [, "(\\d{6})", "$1", ["1"]],
        [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"],
        [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
        [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
        [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]
      ], [
        [, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
        [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
        [, "(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
        [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"],
        [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
        [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
        [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AU: [
        ,
        [, , "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", , , , , , , [5, 6, 7, 8, 9, 10, 12]],
        [
          ,
          ,
          "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
          ,
          ,
          ,
          "212345678",
          ,
          ,
          [9],
          [8]
        ],
        [, , "4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", , , , "412345678", , , [9]],
        [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
        [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
        [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
        "AU",
        61,
        "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
        "0",
        ,
        ,
        "0|(183[12])",
        ,
        "0011",
        ,
        [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]], [
          ,
          "(\\d{4})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["130"]
        ]],
        [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]],
        [, , "163\\d{2,6}", , , , "1631234", , , [5, 6, 7, 8, 9]],
        1,
        ,
        [, , "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}", , , , , , , [6, 7, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      AW: [, [
        ,
        ,
        "(?:[25-79]\\d\\d|800)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7]
      ], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:28\\d|501)\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      AX: [, [
        ,
        ,
        "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 8, 9, 10, 11, 12]
      ], [, , "18[1-8]\\d{3,6}", , , , "181234567", , , [6, 7, 8, 9]], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , "18", [, , , , , , , , , [-1]], [
        ,
        ,
        "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
        ,
        ,
        ,
        "10112345"
      ], , , [, , , , , , , , , [-1]]],
      AZ: [, [, , "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", , , , , , , [9], [7]], [, , "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}", , , , "123123456", , , , [7]], [, , "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["90"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[13-9]"],
        "0$1"
      ]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BA: [
        ,
        [, , "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", , , , , , , [8, 9], [6]],
        [, , "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", , , , "30212345", , , [8], [6]],
        [, , "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}", , , , "61123456"],
        [, , "8[08]\\d{6}", , , , "80123456", , , [8]],
        [, , "9[0246]\\d{6}", , , , "90123456", , , [8]],
        [, , "8[12]\\d{6}", , , , "82123456", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BA",
        387,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
        [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BB: [, [, , "(?:246|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}", , , , "2462501234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "(?:246976|900[2-9]\\d\\d)\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "1|([2-9]\\d{6})$", "246$1", , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [
        ,
        ,
        "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
        ,
        ,
        ,
        "2464301234",
        ,
        ,
        ,
        [7]
      ], , , [, , , , , , , , , [-1]]],
      BD: [, [, , "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [
        ,
        ,
        "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
        ,
        ,
        ,
        "27111234"
      ], [, , "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], [
        ,
        "(\\d{3})(\\d{3,7})",
        "$1-$2",
        ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
        "0$1"
      ], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BE: [
        ,
        [, , "4\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9]],
        [, , "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", , , , "12345678", , , [8]],
        [, , "4[5-9]\\d{7}", , , , "470123456", , , [9]],
        [, , "800[1-9]\\d{4}", , , , "80012345", , , [8]],
        [
          ,
          ,
          "(?:70(?:2[0-57]|3[04-7]|44|69|7[0579])|90(?:0[0-8]|1[36]|2[0-3568]|3[013-689]|[47][2-68]|5[1-68]|6[0-378]|9[34679]))\\d{4}",
          ,
          ,
          ,
          "90012345",
          ,
          ,
          [8]
        ],
        [, , "7879\\d{4}", , , , "78791234", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BE",
        32,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "78(?:0[57]|1[0458]|2[25]|3[15-8]|48|[56]0|7[078]|9\\d)\\d{4}", , , , "78102345", , , [8]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BF: [, [, , "[025-7]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:0[125-7]|5[1-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BG: [, [
        ,
        ,
        "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
        ,
        ,
        ,
        ,
        ,
        ,
        [6, 7, 8, 9],
        [4, 5]
      ], [, , "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", , , , "2123456", , , [6, 7, 8], [4, 5]], [, , "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", , , , "43012345", , , [8, 9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90\\d{6}", , , , "90123456", , , [8]], [, , "700\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BG", 359, "00", "0", , , "0", , , , [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
        ,
        "(\\d{3})(\\d{4})",
        "$1 $2",
        ["43[1-6]|70[1-9]"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
        ,
        "(\\d{3})(\\d{4})",
        "$1 $2",
        ["43[1-6]|70[1-9]"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BH: [, [, , "[136-9]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}",
        ,
        ,
        ,
        "17001234"
      ], [, , "(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}", , , , "36001234"], [, , "80\\d{6}", , , , "80123456"], [, , "(?:87|9[014578])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BI: [, [, , "(?:[267]\\d|31)\\d{6}", , , , , , , [8]], [, , "(?:22|31)\\d{6}", , , , "22201234"], [
        ,
        ,
        "(?:29|6[1257-9]|7[125-9])\\d{6}",
        ,
        ,
        ,
        "79561234"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BJ: [
        ,
        [, , "(?:[25689]\\d|40)\\d{6}", , , , , , , [8]],
        [, , "2(?:02|1[037]|2[45]|3[68])\\d{5}", , , , "20211234"],
        [, , "(?:40|5[1-8]|6\\d|9[013-9])\\d{6}", , , , "90011234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "857[58]\\d{4}", , , , "85751234"],
        "BJ",
        229,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "81\\d{6}", , , , "81123456"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BL: [, [, , "(?:590|(?:69|80)\\d|976)\\d{6}", , , , , , , [9]], [, , "590(?:2[7-9]|5[12]|87)\\d{4}", , , , "590271234"], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "976[01]\\d{5}", , , , "976012345"], "BL", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BM: [, [, , "(?:441|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}", , , , "4414123456", , , , [7]], [, , "441(?:[2378]\\d|5[0-39])\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "1|([2-8]\\d{6})$", "441$1", , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BN: [
        ,
        [, , "[2-578]\\d{6}", , , , , , , [7]],
        [, , "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}", , , , "2345678"],
        [, , "(?:22[89]|[78]\\d\\d)\\d{4}", , , , "7123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "5[34]\\d{5}", , , , "5345678"],
        "BN",
        673,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BO: [
        ,
        [, , "(?:[2-467]\\d\\d|8001)\\d{5}", , , , , , , [8, 9], [7]],
        [, , "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , [8], [7]],
        [, , "[67]\\d{7}", , , , "71234567", , , [8]],
        [, , "8001[07]\\d{4}", , , , "800171234", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "BO",
        591,
        "00(?:1\\d)?",
        "0",
        ,
        ,
        "0(1\\d)?",
        ,
        ,
        ,
        [[, "(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"], , "0$CC $1"], [, "(\\d{8})", "$1", ["[67]"], , "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], , "0$CC $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "8001[07]\\d{4}", , , , , , , [9]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      BQ: [, [, , "(?:[34]1|7\\d)\\d{5}", , , , , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "[347]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BR: [, [, , "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", , , , "11961234567", , , [10, 11], [8, 9]], [
        ,
        ,
        "800\\d{6,7}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9, 10]
      ], [, , "300\\d{6}|[59]00\\d{6,7}", , , , "300123456", , , [9, 10]], [, , "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", , , , "40041234", , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [[, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
        ,
        "(\\d{4})(\\d{4})",
        "$1-$2",
        ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]
      ], [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], [
        ,
        "(\\d{3})(\\d{2,3})(\\d{4})",
        "$1 $2 $3",
        ["(?:[358]|90)0"],
        "0$1"
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "4020\\d{4}|[34]00\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BS: [, [, , "(?:242|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}",
        ,
        ,
        ,
        "2423456789",
        ,
        ,
        ,
        [7]
      ], [, , "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}", , , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "BS", 1, "011", "1", , , "1|([3-8]\\d{6})$", "242$1", , , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , "242225\\d{4}", , , , "2422250123"], , , [, , , , , , , , , [-1]]],
      BT: [, [, , "[17]\\d{7}|[2-8]\\d{6}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [
        ,
        "(\\d)(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[2-68]|7[246]"]
      ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BW: [, [, , "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [
        ,
        ,
        "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}",
        ,
        ,
        ,
        "2401234",
        ,
        ,
        [7]
      ], [, , "(?:321|7(?:[1-7]\\d|8[01]))\\d{5}", , , , "71123456", , , [8]], [, , "(?:0800|800\\d)\\d{6}", , , , "0800012345", , , [10]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79(?:1(?:[01]\\d|20)|2[0-25-7]\\d)\\d{3}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], [
        ,
        "(\\d{3})(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["8"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BY: [, [, , "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , "152450911", , , [9], [5, 6, 7]], [
        ,
        ,
        "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}",
        ,
        ,
        ,
        "294911911",
        ,
        ,
        [9]
      ], [, , "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "0|80?", , "8~10", , [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [
        ,
        "(\\d{4})(\\d{2})(\\d{3})",
        "$1 $2-$3",
        ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],
        "8 0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      BZ: [, [, , "(?:0800\\d|[2-8])\\d{6}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", , , , "2221234", , , [7]], [
        ,
        ,
        "6[0-35-7]\\d{5}",
        ,
        ,
        ,
        "6221234",
        ,
        ,
        [7]
      ], [, , "0800\\d{7}", , , , "08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CA: [, [, , "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", , , , , , , [7, 10]], [
        ,
        ,
        "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
        ,
        ,
        ,
        "5062345678",
        ,
        ,
        [10],
        [7]
      ], [, , "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|68|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", , , , "5062345678", , , [10], [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , [10]], [, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-7]|33|44|66|77|88)|622)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678",
        ,
        ,
        [10]
      ], [, , "600[2-9]\\d{6}", , , , "6002012345", , , [10]], "CA", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "310\\d{4}", , , , "3101234", , , [7]], , , [, , , , , , , , , [-1]]],
      CC: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [
        ,
        ,
        "4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}",
        ,
        ,
        ,
        "412345678",
        ,
        ,
        [9]
      ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "0|([59]\\d{7})$", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CD: [, [
        ,
        ,
        "[189]\\d{8}|[1-68]\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 9]
      ], [, , "12\\d{7}|[1-6]\\d{6}", , , , "1234567"], [, , "88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}", , , , "991234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CF: [, [
        ,
        ,
        "(?:[27]\\d{3}|8776)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[02457]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CG: [, [, , "222\\d{6}|(?:0\\d|80)\\d{7}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [
        ,
        ,
        "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}",
        ,
        ,
        ,
        "061234567"
      ], [, , , , , , , , , [-1]], [, , "80(?:0\\d\\d|120)\\d{4}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CH: [, [, , "8\\d{11}|[2-9]\\d{8}", , , , , , , [9, 12]], [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]], [, , "7[35-9]\\d{7}", , , , "781234567", , , [9]], [
        ,
        ,
        "800\\d{6}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [9]
      ], [, , "90[016]\\d{6}", , , , "900123456", , , [9]], [, , "84[0248]\\d{6}", , , , "840123456", , , [9]], [, , "878\\d{6}", , , , "878123456", , , [9]], [, , , , , , , , , [-1]], "CH", 41, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], , [, , "74[0248]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "5[18]\\d{7}", , , , "581234567", , , [9]], , , [
        ,
        ,
        "860\\d{9}",
        ,
        ,
        ,
        "860123456789",
        ,
        ,
        [12]
      ]],
      CI: [
        ,
        [, , "[02]\\d{9}", , , , , , , [10]],
        [, , "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|[23][45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}", , , , "2123456789"],
        [, , "0704[0-7]\\d{5}|0(?:[15]\\d\\d|7(?:0[0-37-9]|[4-9][7-9]))\\d{6}", , , , "0123456789"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "CI",
        225,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      CK: [, [, , "[2-578]\\d{4}", , , , , , , [5]], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[578]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CL: [, [, , "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", , , , , , , [9, 10, 11]], [
        ,
        ,
        "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[034]\\d|1[0-35-9]|2[1-9]|5[0-2])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}",
        ,
        ,
        ,
        "221234567",
        ,
        ,
        [9]
      ], [, , "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[034]\\d|1[0-35-9]|2[1-9]|5[0-2])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", , , , "221234567", , , [9]], [, , "(?:123|8)00\\d{6}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [
        ,
        ,
        "600\\d{7,8}",
        ,
        ,
        ,
        "6001234567",
        ,
        ,
        [10, 11]
      ], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , 1, [[, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],
        "($1)"
      ], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [[, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["60|8"]
      ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CM: [, [, , "[26]\\d{8}|88\\d{6,7}", , , , , , , [8, 9]], [, , "2(?:22|33)\\d{6}", , , , "222123456", , , [9]], [, , "(?:24[23]|6[25-9]\\d)\\d{6}", , , , "671234567", , , [9]], [, , "88\\d{6,7}", , , , "88012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["88"]
      ], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CN: [, [, , "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [
        ,
        ,
        "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
        ,
        ,
        ,
        "1012345678",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|5[0-35-9]|6[25-7]|7[0-35-8]|9[0135-9])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:(?:10|21)8|8)00\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [
        ,
        ,
        "400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
        ,
        ,
        ,
        "4001234567",
        ,
        ,
        [7, 8, 9, 10, 11],
        [5, 6]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "00|1(?:[12]\\d|79)\\d\\d00", "0", , , "0|(1(?:[12]\\d|79)\\d\\d)", , "00", , [
        [, "(\\d{5,6})", "$1", ["96"]],
        [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])", "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"]],
        [
          ,
          "(\\d{4})(\\d{4})",
          "$1 $2",
          ["16[08]"]
        ],
        [
          ,
          "(\\d{3})(\\d{5,6})",
          "$1 $2",
          [
            "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
            "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
            "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
            "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
          ],
          "0$1",
          "$CC $1"
        ],
        [, "(\\d{4})(\\d{4})", "$1 $2", [
          "[1-9]",
          "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
          "26|3(?:[0268]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9])|(?:34|85[23])[0-8]|(?:1|58)[1-9]|(?:63|95)[06-9]|(?:33|85[23]9)[0-46-9]|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
          "26|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:1|58|85[23]10)[1-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
        ]],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
        [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
        [
          ,
          "(\\d{3})(\\d{7,8})",
          "$1 $2",
          ["9"]
        ],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
      ], [
        [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{5,6})", "$1 $2", [
          "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
          "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
          "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
          "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
        ], "0$1", "$CC $1"],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
        [
          ,
          "(\\d{2})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],
          "0$1",
          "$CC $1",
          1
        ],
        [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{7,8})", "$1 $2", ["9"]],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
        [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
      ], [, , , , , , , , , [-1]], , , [, , "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}", , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CO: [, [, , "(?:(?:1\\d|[36])\\d{3}|9101)\\d{6}|[124-8]\\d{7}", , , , , , , [8, 10, 11], [7]], [, , "60[124-8][2-9]\\d{6}|[124-8][2-9]\\d{6}", , , , "12345678", , , [8, 10], [7]], [, , "3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", , , , "3211234567", , , [10]], [
        ,
        ,
        "1800\\d{7}",
        ,
        ,
        ,
        "18001234567",
        ,
        ,
        [11]
      ], [, , "19(?:0[01]|4[78])\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0([3579]|4(?:[14]4|56))?", , , , [[, "(\\d)(\\d{7})", "$1 $2", ["[146][2-9]|[2578]"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["[39]"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1"]], [[, "(\\d)(\\d{7})", "$1 $2", ["[146][2-9]|[2578]"], "($1)", "0$CC $1"], [
        ,
        "(\\d{3})(\\d{7})",
        "$1 $2",
        ["6"],
        "($1)"
      ], [, "(\\d{3})(\\d{7})", "$1 $2", ["[39]"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CR: [
        ,
        [, , "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", , , , , , , [8, 10]],
        [, , "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", , , , "22123456", , , [8]],
        [, , "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", , , , "83123456", , , [8]],
        [, , "800\\d{7}", , , , "8001234567", , , [10]],
        [, , "90[059]\\d{7}", , , , "9001234567", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "(?:210[0-6]|4\\d{3}|5100)\\d{4}", , , , "40001234", , , [8]],
        "CR",
        506,
        "00",
        ,
        ,
        ,
        "(19(?:0[0-2468]|1[09]|20|66|77|99))",
        ,
        ,
        ,
        [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], , "$CC $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      CU: [, [, , "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", , , , , , , [6, 7, 8, 10], [4, 5]], [
        ,
        ,
        "(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}",
        ,
        ,
        ,
        "71234567",
        ,
        ,
        ,
        [4, 5]
      ], [, , "5\\d{7}", , , , "51234567", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , "807\\d{7}", , , , "8071234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CV: [, [, , "(?:[2-59]\\d\\d|800)\\d{4}", , , , , , , [7]], [
        ,
        ,
        "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}",
        ,
        ,
        ,
        "2211234"
      ], [, , "(?:36|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , "800\\d{4}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[3-5]|4[356])\\d{5}", , , , "3401234"], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CW: [, [, , "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", , , , , , , [7, 8]], [
        ,
        ,
        "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}",
        ,
        ,
        ,
        "94351234"
      ], [, , "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}", , , , "95181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], , [, , "955\\d{5}", , , , "95581234", , , [8]], 1, "[69]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      CX: [
        ,
        [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]],
        [
          ,
          ,
          "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
          ,
          ,
          ,
          "891641234",
          ,
          ,
          [9],
          [8]
        ],
        [, , "4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", , , , "412345678", , , [9]],
        [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
        [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
        [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
        [, , , , , , , , , [-1]],
        [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
        "CX",
        61,
        "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
        "0",
        ,
        ,
        "0|([59]\\d{7})$",
        "8$1",
        "0011",
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      CY: [, [, , "(?:[279]\\d|[58]0)\\d{6}", , , , , , , [8]], [, , "2[2-6]\\d{6}", , , , "22345678"], [, , "9[4-79]\\d{6}", , , , "96123456"], [, , "800\\d{5}", , , , "80001234"], [, , "90[09]\\d{5}", , , , "90012345"], [, , "80[1-9]\\d{5}", , , , "80112345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "CY", 357, "00", , , , , , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:50|77)\\d{6}", , , , "77123456"], , , [, , , , , , , , , [-1]]],
      CZ: [
        ,
        [, , "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]],
        [, , "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , , "212345678", , , [9]],
        [, , "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]],
        [, , "8[134]\\d{7}", , , , "811234567", , , [9]],
        [, , "70[01]\\d{6}", , , , "700123456", , , [9]],
        [, , "9[17]0\\d{6}", , , , "910123456", , , [9]],
        "CZ",
        420,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [
          ,
          "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
          "$1 $2 $3 $4",
          ["96"]
        ], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "9(?:5\\d|7[2-4])\\d{6}", , , , "972123456", , , [9]],
        ,
        ,
        [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]
      ],
      DE: [, [, , "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:1\\d|2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|[23]1|[46][1-8])\\d{1,9}", , , , , , , [
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15
      ], [2, 3]], [
        ,
        ,
        "32\\d{9,11}|49[2-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
        ,
        ,
        ,
        "30123456",
        ,
        ,
        [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        [2, 3, 4]
      ], [, , "15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", , , , "9001234567", , , [10, 11]], [, , "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, "00", "0", , , "0", , , , [
        [, "(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"],
        [
          ,
          "(\\d{3})(\\d{3,12})",
          "$1 $2",
          ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],
          "0$1"
        ],
        [
          ,
          "(\\d{4})(\\d{2,11})",
          "$1 $2",
          ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
          "0$1"
        ],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
        [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
        [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
        [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
        [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
        [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
        [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
        [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
        [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
        [, "(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"],
        [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
        [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
        [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
        [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
        [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
      ], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [
        ,
        ,
        "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
        ,
        ,
        ,
        "177991234567",
        ,
        ,
        [12, 13]
      ]],
      DJ: [, [, , "(?:2\\d|77)\\d{6}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DK: [, [, , "[2-9]\\d{7}", , , , , , , [8]], [, , "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}", , , , "32123456"], [
        ,
        ,
        "(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}",
        ,
        ,
        ,
        "32123456"
      ], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , 1, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DM: [
        ,
        [, , "(?:[58]\\d\\d|767|900)\\d{7}", , , , , , , [10], [7]],
        [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}", , , , "7674201234", , , , [7]],
        [, , "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}", , , , "7672251234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "DM",
        1,
        "011",
        "1",
        ,
        ,
        "1|([2-7]\\d{6})$",
        "767$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "767",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      DO: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}", , , , "8092345678", , , , [7]], [, , "8[024]9[2-9]\\d{6}", , , , "8092345678", , , , [7]], [
        ,
        ,
        "8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}",
        ,
        ,
        ,
        "8002123456"
      ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DO", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "8001|8[024]9", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      DZ: [
        ,
        [, , "(?:[1-4]|[5-79]\\d|80)\\d{7}", , , , , , , [8, 9]],
        [, , "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}", , , , "12345678"],
        [, , "(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", , , , "551234567", , , [9]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]],
        [, , "80[12]1\\d{5}", , , , "801123456", , , [9]],
        [, , , , , , , , , [-1]],
        [, , "98[23]\\d{6}", , , , "983123456", , , [9]],
        "DZ",
        213,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [
          [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"],
          [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"],
          [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]
        ],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EC: [
        ,
        [, , "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", , , , , , , [8, 9, 10, 11], [7]],
        [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]],
        [, , "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", , , , "991234567", , , [9]],
        [, , "1800\\d{7}|1[78]00\\d{6}", , , , "18001234567", , , [10, 11]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]],
        "EC",
        593,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]],
        [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      EE: [, [, , "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [
        ,
        ,
        "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}",
        ,
        ,
        ,
        "3212345",
        ,
        ,
        [7]
      ], [, , "(?:5\\d{5}|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:23|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[3679]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", , , , "51234567", , , [7, 8]], [, , "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}", , , , "80012345"], [, , "(?:40\\d\\d|900)\\d{4}", , , , "9001234", , , [7, 8]], [, , , , , , , , , [-1]], [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], "EE", 372, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , "800[2-9]\\d{3}", , , , , , , [7]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      EG: [, [
        ,
        ,
        "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10],
        [6, 7]
      ], [, , "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", , , , "234567890", , , [8, 9], [6, 7]], [, , "1[0-25]\\d{8}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["[189]"],
        "0$1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      EH: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "528[89]\\d{5}", , , , "528812345"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-367]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "592(?:4[0-2]|93)\\d{4}", , , , "592401234"], "EH", 212, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , "528[89]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ER: [, [
        ,
        ,
        "[178]\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7],
        [6]
      ], [, , "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", , , , "8370362", , , , [6]], [, , "(?:17[1-3]|7\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ES: [, [, , "[5-9]\\d{8}", , , , , , , [9]], [
        ,
        ,
        "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}",
        ,
        ,
        ,
        "810123456"
      ], [, , "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}", , , , "612345678"], [, , "[89]00\\d{6}", , , , "800123456"], [, , "80[367]\\d{6}", , , , "803123456"], [, , "90[12]\\d{6}", , , , "901123456"], [, , "70\\d{7}", , , , "701234567"], [, , , , , , , , , [-1]], "ES", 34, "00", , , , , , , , [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], [
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]],
        [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "51\\d{7}", , , , "511234567"], , , [, , , , , , , , , [-1]]],
      ET: [, [, , "(?:11|[2-59]\\d)\\d{7}", , , , , , , [9], [7]], [
        ,
        ,
        "11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[78]|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
        ,
        ,
        ,
        "111112345",
        ,
        ,
        ,
        [7]
      ], [, , "9\\d{8}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FI: [, [, , "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [, , "(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}", , , , "131234567", , , [5, 6, 7, 8, 9]], [
        ,
        ,
        "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}",
        ,
        ,
        ,
        "412345678",
        ,
        ,
        [6, 7, 8, 9, 10]
      ], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FI", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [
        ,
        "(\\d{2})(\\d{6,10})",
        "$1 $2",
        ["7"],
        "0$1"
      ]], [[, "(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], [, , , , , , , , , [-1]], 1, "1[03-79]|[2-9]", [, , "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"], [
        ,
        ,
        "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
        ,
        ,
        ,
        "10112345"
      ], , , [, , , , , , , , , [-1]]],
      FJ: [, [, , "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", , , , , , , [7, 11]], [, , "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]], [, , "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", , , , "7012345", , , [7]], [, , "0800\\d{7}", , , , "08001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FJ", 679, "0(?:0|52)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      FK: [, [, , "[2-7]\\d{4}", , , , , , , [5]], [, , "[2-47]\\d{4}", , , , "31234"], [, , "[56]\\d{4}", , , , "51234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FK", 500, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FM: [, [, , "(?:[39]\\d\\d|820)\\d{4}", , , , , , , [7]], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}", , , , "3201234"], [
        ,
        ,
        "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}",
        ,
        ,
        ,
        "3501234"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FO: [, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[34]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d|91)\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [, , "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d", , , , "901123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:6[0-36]|88)\\d{4}",
        ,
        ,
        ,
        "601234"
      ], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", ["[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      FR: [
        ,
        [, , "[1-9]\\d{8}", , , , , , , [9]],
        [, , "(?:[1-35]\\d|4[1-9])\\d{7}", , , , "123456789"],
        [, , "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7(?:00|[3-9]\\d))\\d{6}", , , , "612345678"],
        [, , "80[0-5]\\d{6}", , , , "801234567"],
        [, , "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}", , , , "891123456"],
        [
          ,
          ,
          "8(?:1[01]|2[0156]|4[02]|84)\\d{6}",
          ,
          ,
          ,
          "884012345"
        ],
        [, , , , , , , , , [-1]],
        [, , "9\\d{8}", , , , "912345678"],
        "FR",
        33,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{4})", "$1", ["10"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]],
        [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "80[6-9]\\d{6}", , , , "806123456"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GA: [, [, , "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", , , , , , , [7, 8]], [, , "[01]1\\d{6}", , , , "01441234", , , [8]], [, , "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}", , , , "06031234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["11|[67]"],
        "0$1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GB: [, [, , "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", , , , , , , [7, 9, 10], [4, 5, 6, 8]], [
        ,
        ,
        "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[01359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[0-79]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-26-9])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
        ,
        ,
        ,
        "1212345678",
        ,
        ,
        [9, 10],
        [4, 5, 6, 7, 8]
      ], [, , "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", , , , "7400123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [
        ,
        ,
        "56\\d{8}",
        ,
        ,
        ,
        "5612345678",
        ,
        ,
        [10]
      ], "GB", 44, "00", "0", " x", , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", [
        "[25]|7(?:0|6[02-9])",
        "[25]|7(?:0|6(?:[03-9]|2[356]))"
      ], "0$1"], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], , [, , "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
      GD: [
        ,
        [, , "(?:473|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
          ,
          ,
          ,
          "4732691234",
          ,
          ,
          ,
          [7]
        ],
        [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "GD",
        1,
        "011",
        "1",
        ,
        ,
        "1|([2-9]\\d{6})$",
        "473$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "473",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GE: [, [, , "(?:[3-57]\\d\\d|800)\\d{6}", , , , , , , [9], [6, 7]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6, 7]], [
        ,
        ,
        "5(?:(?:0555|1177)[5-9]|757(?:7[7-9]|8[01]))\\d{3}|5(?:00(?:0\\d|50)|11(?:00|1\\d|2[0-4]|3[01])|5200|75(?:00|[57]5)|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88)))\\d{4}|5(?:0070|11(?:33|51)|[25]222|3333)[0-4]\\d{3}|(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}",
        ,
        ,
        ,
        "555123456"
      ], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70[67]\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "70[67]\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GF: [, [
        ,
        ,
        "(?:[56]94|80\\d|976)\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9]
      ], [, , "594(?:[023]\\d|1[01]|4[03-9]|5[6-9]|6[0-3]|80|9[0-8])\\d{4}", , , , "594101234"], [, , "694(?:[0-249]\\d|3[0-48])\\d{4}", , , , "694201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "976\\d{6}", , , , "976012345"], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GG: [, [
        ,
        ,
        "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 9, 10],
        [6]
      ], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:(?:781|839)\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", , , "0|([25-9]\\d{5})$", "1481$1", , , , , [
        ,
        ,
        "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
        ,
        ,
        ,
        "7640123456",
        ,
        ,
        [10]
      ], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
      GH: [, [, , "(?:[235]\\d{3}|800)\\d{5}", , , , , , , [8, 9], [7]], [, , "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", , , , "302345678", , , [9], [7]], [, , "(?:2(?:[0346-8]\\d|5[67])|5(?:[0457]\\d|6[01]|9[1-9]))\\d{6}", , , , "231234567", , , [9]], [
        ,
        ,
        "800\\d{5}",
        ,
        ,
        ,
        "80012345",
        ,
        ,
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|8[0-2]"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GI: [, [, , "(?:[25]\\d\\d|606)\\d{5}", , , , , , , [8]], [
        ,
        ,
        "21(?:6[24-7]\\d|90[0-2])\\d{3}|2(?:00|2[25])\\d{5}",
        ,
        ,
        ,
        "20012345"
      ], [, , "(?:5[146-8]\\d|606)\\d{5}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GL: [, [, , "(?:19|[2-689]\\d|70)\\d{4}", , , , , , , [6]], [, , "(?:19|3[1-7]|6[14689]|70|8[14-79]|9\\d)\\d{4}", , , , "321000"], [, , "[245]\\d{5}", , , , "221234"], [, , "80\\d{4}", , , , "801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "3[89]\\d{4}",
        ,
        ,
        ,
        "381234"
      ], "GL", 299, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GM: [, [, , "[2-9]\\d{6}", , , , , , , [7]], [, , "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"], [, , "(?:[23679]\\d|5[0-389])\\d{5}", , , , "3012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GM", 220, "00", , , , , , , , [[
        ,
        "(\\d{3})(\\d{4})",
        "$1 $2",
        ["[2-9]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GN: [, [, , "722\\d{6}|(?:3|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", , , , "30241234", , , [8]], [, , "6[0-356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[67]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GP: [, [, , "(?:590|(?:69|80)\\d|976)\\d{6}", , , , , , , [9]], [, , "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}", , , , "590201234"], [, , "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "976[01]\\d{5}", , , , "976012345"], "GP", 590, "00", "0", , , "0", , , , [[
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[569]"],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GQ: [, [, , "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", , , , , , , [9]], [, , "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}", , , , "333091234"], [, , "(?:222|55\\d)\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], [, , "90\\d[1-9]\\d{5}", , , , "900123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]],
        [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]
      ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GR: [, [, , "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", , , , , , , [10, 11, 12]], [
        ,
        ,
        "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
        ,
        ,
        ,
        "2123456789",
        ,
        ,
        [10]
      ], [, , "68[57-9]\\d{7}|(?:69|94)\\d{8}", , , , "6912345678", , , [10]], [, , "800\\d{7,9}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567", , , [10]], [, , "8(?:0[16]|12|[27]5|50)\\d{7}", , , , "8011234567", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], [
        ,
        "(\\d{3})(\\d{3,4})(\\d{5})",
        "$1 $2 $3",
        ["8"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5005000\\d{3}", , , , "5005000123", , , [10]], , , [, , , , , , , , , [-1]]],
      GT: [
        ,
        [, , "(?:1\\d{3}|[2-7])\\d{7}", , , , , , , [8, 11]],
        [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]],
        [, , "[3-5]\\d{7}", , , , "51234567", , , [8]],
        [, , "18[01]\\d{8}", , , , "18001112222", , , [11]],
        [, , "19\\d{9}", , , , "19001112222", , , [11]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "GT",
        502,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      GU: [, [, , "(?:[58]\\d\\d|671|900)\\d{7}", , , , , , , [10], [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [
        ,
        ,
        "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
        ,
        ,
        ,
        "6713001234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "1|([3-9]\\d{6})$", "671$1", , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      GW: [, [, , "[49]\\d{8}|4\\d{6}", , , , , , , [7, 9]], [, , "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      GY: [, [, , "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}", , , , , , , [7]], [
        ,
        ,
        "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}",
        ,
        ,
        ,
        "2201234"
      ], [, , "(?:6\\d\\d|70[015-7])\\d{4}", , , , "6091234"], [, , "(?:289|862)\\d{4}", , , , "2891234"], [, , "9008\\d{3}", , , , "9008123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GY", 592, "001", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      HK: [
        ,
        [, , "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", , , , , , , [
          5,
          6,
          7,
          8,
          9,
          11
        ]],
        [, , "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|5[0-5]|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}", , , , "21234567", , , [8]],
        [, , "(?:4(?:44[5-9]|6(?:0[0-7]|1[0-6]|4[0-57-9]|6[0-4]|7[0-8]))|573[0-6]|6(?:26[013-8]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|9(?:29[013-9]|59[0-4]))\\d{4}|(?:4(?:40|6[2358])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-24679])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", , , , "51234567", , , [8]],
        [, , "800\\d{6}", , , , "800123456", , , [9]],
        [, , "900(?:[0-24-9]\\d{7}|3\\d{1,4})", , , , "90012345678", , , [5, 6, 7, 8, 11]],
        [, , , , , , , , , [-1]],
        [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", , , , "81123456", , , [8]],
        [, , , , , , , , , [-1]],
        "HK",
        852,
        "00(?:30|5[09]|[126-9]?)",
        ,
        ,
        ,
        ,
        ,
        "00",
        ,
        [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]],
        ,
        [
          ,
          ,
          "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
          ,
          ,
          ,
          "71123456",
          ,
          ,
          [8]
        ],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      HN: [, [, , "8\\d{10}|[237-9]\\d{7}", , , , , , , [8, 11]], [
        ,
        ,
        "2(?:2(?:0[0-39]|1[1-367]|[23]\\d|4[03-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[78]|2[3-59]|3[13-9]|4[0-68]|5[1-35])|5(?:0[7-9]|16|4[03-5]|5\\d|6[014-6]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
        ,
        ,
        ,
        "22123456",
        ,
        ,
        [8]
      ], [, , "[37-9]\\d{7}", , , , "91234567", , , [8]], [, , "8002\\d{7}", , , , "80021234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [, , , , , , , , , [-1]], , , [, , "8002\\d{7}", , , , , , , [11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      HR: [, [, , "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", , , , , , , [6, 7, 8, 9]], [
        ,
        ,
        "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
        ,
        ,
        ,
        "12345678",
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "98\\d{6,7}|975(?:1\\d|9[67])\\d{4}|9(?:0[1-9]|[1259]\\d|7[0679])\\d{6}", , , , "921234567", , , [8, 9]], [, , "80[01]\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "6[01459]\\d{6}|6[01]\\d{4,5}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["[67]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "62\\d{6,7}|72\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]],
      HT: [, [, , "[2-489]\\d{7}", , , , , , , [8]], [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"], [, , "[34]\\d{7}", , , , "34101234"], [, , "8\\d{7}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}",
        ,
        ,
        ,
        "98901234"
      ], "HT", 509, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      HU: [, [, , "[235-7]\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6, 7]], [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]], [, , "(?:[48]0\\d|680[29])\\d{5}", , , , "80123456"], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "21\\d{7}",
        ,
        ,
        ,
        "211234567",
        ,
        ,
        [9]
      ], "HU", 36, "00", "06", , , "06", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], , [, , , , , , , , , [-1]], , , [, , "(?:[48]0\\d|680[29])\\d{5}"], [, , "38\\d{7}", , , , "381234567", , , [9]], , , [, , , , , , , , , [-1]]],
      ID: [
        ,
        [, , "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", , , , , , , [7, 8, 9, 10, 11, 12, 13], [5, 6]],
        [, , "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", , , , "218350123", , , [7, 8, 9, 10, 11], [5, 6]],
        [
          ,
          ,
          "8[1-35-9]\\d{7,10}",
          ,
          ,
          ,
          "812345678",
          ,
          ,
          [9, 10, 11, 12]
        ],
        [, , "00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}", , , , "8001234567", , , [8, 9, 10, 11, 12, 13]],
        [, , "809\\d{7}", , , , "8091234567", , , [10]],
        [, , "804\\d{7}", , , , "8041234567", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "ID",
        62,
        "00[89]",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [
          ,
          "(\\d{3})(\\d{3,4})(\\d{3})",
          "$1-$2-$3",
          ["8[1-35-9]"],
          "0$1"
        ], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["001"]], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]],
        [
          [, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]],
          [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"],
          [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"],
          [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"],
          [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"],
          [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"],
          [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"],
          [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"],
          [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]
        ],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "001803\\d{6,7}|(?:007803\\d|8071)\\d{6}", , , , , , , [10, 12, 13]],
        [, , "(?:1500|8071\\d{3})\\d{3}", , , , "8071123456", , , [7, 10]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      IE: [
        ,
        [
          ,
          ,
          "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 8, 9, 10],
          [5, 6]
        ],
        [, , "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}", , , , "2212345", , , , [5, 6]],
        [, , "8(?:22|[35-9]\\d)\\d{6}", , , , "850123456", , , [9]],
        [, , "1800\\d{6}", , , , "1800123456", , , [10]],
        [, , "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", , , , "1520123456", , , [10]],
        [, , "18[59]0\\d{6}", , , , "1850123456", , , [10]],
        [, , "700\\d{6}", , , , "700123456", , , [9]],
        [, , "76\\d{7}", , , , "761234567", , , [9]],
        "IE",
        353,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [
          ,
          "(\\d{2})(\\d{4})(\\d{4})",
          "$1 $2 $3",
          ["4"],
          "(0$1)"
        ], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "18[59]0\\d{6}", , , , , , , [10]],
        [, , "818\\d{6}", , , , "818123456", , , [9]],
        ,
        ,
        [, , "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", , , , "8551234567", , , [10]]
      ],
      IL: [, [, , "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", , , , , , , [7, 8, 9, 10, 11, 12]], [, , "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", , , , "21234567", , , [8, 11, 12], [7]], [
        ,
        ,
        "5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-9]|3[0-3]|4[34]|5[015689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}",
        ,
        ,
        ,
        "502345678",
        ,
        ,
        [9]
      ], [, , "1(?:255|80[019]\\d{3})\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", , , , "1919123456", , , [8, 10]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , "7(?:380|8(?:33|55|77|81))\\d{5}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", , , , "771234567", , , [9]], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [
        [, "(\\d{4})(\\d{3})", "$1-$2", ["125"]],
        [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]],
        [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"],
        [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"],
        [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]],
        [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]],
        [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]],
        [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]
      ], , [, , , , , , , , , [-1]], , , [, , "1700\\d{6}", , , , , , , [10]], [, , "1599\\d{6}", , , , "1599123456", , , [10]], , , [, , "151\\d{8,9}", , , , "15112340000", , , [11, 12]]],
      IM: [, [, , "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [
        ,
        ,
        "1624(?:230|[5-8]\\d\\d)\\d{3}",
        ,
        ,
        ,
        "1624756789",
        ,
        ,
        ,
        [6]
      ], [, , "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"], [, , "808162\\d{4}", , , , "8081624567"], [, , "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}", , , , "9016247890"], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678"], [, , "56\\d{8}", , , , "5612345678"], "IM", 44, "00", "0", , , "0|([25-8]\\d{5})$", "1624$1", , , , , [, , , , , , , , , [-1]], , "74576|(?:16|7[56])24", [, , , , , , , , , [-1]], [, , "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}", , , , "5512345678"], , , [, , , , , , , , , [-1]]],
      IN: [, [, , "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [
        ,
        ,
        "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
        ,
        ,
        ,
        "7410410123",
        ,
        ,
        [10],
        [6, 7, 8]
      ], [
        ,
        ,
        "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
        ,
        ,
        ,
        "8123456789",
        ,
        ,
        [10]
      ], [, , "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["140"],
        ,
        ,
        1
      ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        [
          "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
        ],
        "0$1",
        ,
        1
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
      ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3 $4",
        ["0"]
      ], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
        "0$1",
        ,
        1
      ], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        [
          "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
          "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
        ],
        "0$1",
        ,
        1
      ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
      ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
        ,
        "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3 $4",
        ["18"],
        ,
        ,
        1
      ]], [, , , , , , , , , [-1]], , , [, , "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]],
      IO: [, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      IQ: [, [
        ,
        ,
        "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10],
        [6, 7]
      ], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      IR: [
        ,
        [, , "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", , , , , , , [4, 5, 6, 7, 10], [8]],
        [, , "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}", , , , "2123456789", , , [6, 7, 10], [4, 5, 8]],
        [, , "9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:1\\d|88)|9(?:0[0-3]|[19]\\d|21|77|8[7-9])))\\d{5}", , , , "9123456789", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "IR",
        98,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))", , , , , , , [4, 5, 10]],
        [
          ,
          ,
          "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
          ,
          ,
          ,
          "9601",
          ,
          ,
          [4, 5]
        ],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      IS: [, [, , "(?:38\\d|[4-9])\\d{6}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", , , , "4101234", , , [7]], [, , "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}", , , , "6111234"], [, , "80[0-8]\\d{4}", , , , "8001234", , , [7]], [
        ,
        ,
        "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
        ,
        ,
        ,
        "9001234",
        ,
        ,
        [7]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49[0-24-79]\\d{4}", , , , "4921234", , , [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:689|8(?:7[18]|80)|95[48])\\d{4}", , , , "6891234", , , [7]]],
      IT: [, [, , "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [
        ,
        ,
        "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
        ,
        ,
        ,
        "0212345678",
        ,
        ,
        [6, 7, 8, 9, 10, 11]
      ], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "IT", 39, "00", , , , , , , , [
        [, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]],
        [, "(\\d{6})", "$1", ["1(?:1|92)"]],
        [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
        [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],
        [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
        [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]],
        [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]],
        [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]],
        [
          ,
          "(\\d{2})(\\d{4})(\\d{5})",
          "$1 $2 $3",
          ["0[26]"]
        ],
        [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
        [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]
      ], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [
        ,
        "(\\d{3})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["1(?:44|[679])|[378]"]
      ], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
      JE: [, [, , "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [
        ,
        ,
        "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}",
        ,
        ,
        ,
        "7797712345"
      ], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , , , , , , , , [-1]], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "0|([0-24-8]\\d{5})$", "1534$1", , , , , [, , "76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
        ,
        ,
        ,
        "5512345678"
      ], , , [, , , , , , , , , [-1]]],
      JM: [, [, , "(?:[58]\\d\\d|658|900)\\d{7}", , , , , , , [10], [7]], [, , "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[02357-9]|[23]\\d|40|5[06]|6[2-589]|7[0257]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", , , , "8765230123", , , , [7]], [
        ,
        ,
        "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
        ,
        ,
        ,
        "8762101234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "658|876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      JO: [, [, , "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", , , , , , , [8, 9]], [
        ,
        ,
        "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
        ,
        ,
        ,
        "62001234",
        ,
        ,
        [8]
      ], [, , "7(?:[78][0-25-9]|9\\d)\\d{6}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "9\\d{7}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [
        ,
        ,
        "74(?:66|77)\\d{5}",
        ,
        ,
        ,
        "746612345",
        ,
        ,
        [9]
      ], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]],
      JP: [, [, , "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", , , , "312345678", , , [9]], [
        ,
        ,
        "[7-9]0[1-9]\\d{7}",
        ,
        ,
        ,
        "9012345678",
        ,
        ,
        [10]
      ], [, , "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "0", , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", [
        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])",
        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
      ], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [
        ,
        "(\\d)(\\d{4})(\\d{4})",
        "$1-$2-$3",
        ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],
        "0$1"
      ], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
        ],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [
        ,
        "(\\d{4})(\\d{6})(\\d{6,7})",
        "$1-$2-$3",
        ["0"]
      ]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
        ,
        "(\\d{4})(\\d)(\\d{4})",
        "$1-$2-$3",
        ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1-$2-$3",
        [
          "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]",
          "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
        ],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"], [, , "570\\d{6}", , , , "570123456", , , [9]], , , [, , , , , , , , , [-1]]],
      KE: [, [, , "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", , , , , , , [7, 8, 9, 10]], [
        ,
        ,
        "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
        ,
        ,
        ,
        "202012345",
        ,
        ,
        [7, 8, 9]
      ], [, , "(?:1(?:0[0-6]|1[0-5]|2[014])|7\\d\\d)\\d{6}", , , , "712123456", , , [9]], [, , "800[2-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KG: [, [
        ,
        ,
        "8\\d{9}|(?:[235-8]\\d|99)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9, 10],
        [5, 6]
      ], [, , "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", , , , "312123456", , , [9], [5, 6]], [, , "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|7(?:[07]\\d|55)|880|99[05-9])\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KH: [
        ,
        [, , "1\\d{9}|[1-9]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]],
        [
          ,
          ,
          "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
          ,
          ,
          ,
          "23756789",
          ,
          ,
          [8, 9],
          [6, 7]
        ],
        [, , "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", , , , "91234567", , , [8, 9]],
        [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]],
        [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "KH",
        855,
        "00[14-9]",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      KI: [
        ,
        [, , "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", , , , , , , [5, 8]],
        [, , "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", , , , "31234"],
        [, , "(?:63\\d{3}|73(?:0[0-5]\\d|140))\\d{3}|[67]200[01]\\d{3}", , , , "72001234", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", , , , "30010000", , , [8]],
        "KI",
        686,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      KM: [, [, , "[3478]\\d{6}", , , , , , , [7], [4]], [, , "7[4-7]\\d{5}", , , , "7712345", , , , [4]], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KN: [
        ,
        [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
        [
          ,
          ,
          "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}",
          ,
          ,
          ,
          "8692361234",
          ,
          ,
          ,
          [7]
        ],
        [, , "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "KN",
        1,
        "011",
        "1",
        ,
        ,
        "1|([2-7]\\d{6})$",
        "869$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "869",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      KP: [, [, , "85\\d{6}|(?:19\\d|[2-7])\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}", , , , "21234567", , , , [6, 7]], [, , "19[1-3]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["1"],
        "0$1"
      ]], , [, , , , , , , , , [-1]], , , [, , "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KR: [, [, , "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [, , "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", , , , "22123456", , , [5, 6, 8, 9, 10], [3, 4, 7]], [
        ,
        ,
        "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}",
        ,
        ,
        ,
        "1020000000",
        ,
        ,
        [9, 10]
      ], [, , "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8,9}", , , , "5012345678", , , [10, 11]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0", , , "0(8(?:[1-46-8]|5\\d\\d))?", , , , [[, "(\\d{5})", "$1", ["1[016-9]1", "1[016-9]11", "1[016-9]114"], "0$1"], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [
        ,
        "(\\d{4})(\\d{4})",
        "$1-$2",
        ["1"]
      ], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [
        ,
        "(\\d{5})(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3 $4",
        ["0"]
      ]], [[, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]], [
        ,
        ,
        "15\\d{7,8}",
        ,
        ,
        ,
        "1523456789",
        ,
        ,
        [9, 10]
      ], , , [, , "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})", , , , , , , [11, 12, 13, 14]], [, , "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]],
      KW: [, [, , "18\\d{5}|(?:[2569]\\d|41)\\d{6}", , , , , , , [7, 8]], [, , "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", , , , "22345678", , , [8]], [
        ,
        ,
        "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|111|222|333|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|22|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|3(?:00|33)|5(?:00|5\\d)))\\d{4}",
        ,
        ,
        ,
        "50012345",
        ,
        ,
        [8]
      ], [, , "18\\d{5}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KY: [, [, , "(?:345|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}",
        ,
        ,
        ,
        "3452221234",
        ,
        ,
        ,
        [7]
      ], [, , "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "(?:345976|900[2-9]\\d\\d)\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "1|([2-9]\\d{6})$", "345$1", , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      KZ: [, [, , "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", , , , , , , [10, 14], [5, 6, 7]], [
        ,
        ,
        "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
        ,
        ,
        ,
        "7123456789",
        ,
        ,
        [10],
        [5, 6, 7]
      ], [, , "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", , , , "7710009998", , , [10]], [, , "8(?:00|108\\d{3})\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , "751\\d{7}", , , , "7511234567", , , [10]], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , "33|7", [, , "751\\d{7}", , , , , , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LA: [
        ,
        [, , "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", , , , , , , [8, 9, 10], [6]],
        [
          ,
          ,
          "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
          ,
          ,
          ,
          "21212862",
          ,
          ,
          [8],
          [6]
        ],
        [, , "(?:20(?:[239]\\d|5[24-9]|7[6-8]|88)|302\\d)\\d{6}", , , , "2023123456", , , [10]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "LA",
        856,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "30[013-9]\\d{6}", , , , "301234567", , , [9]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      LB: [, [, , "[27-9]\\d{7}|[13-9]\\d{6}", , , , , , , [7, 8]], [, , "7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}", , , , "1123456"], [, , "793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[
        ,
        "(\\d)(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LC: [
        ,
        [, , "(?:[58]\\d\\d|758|900)\\d{7}", , , , , , , [10], [7]],
        [, , "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}", , , , "7584305678", , , , [7]],
        [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}", , , , "7582845678", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
        [, , "900[2-9]\\d{6}", , , , "9002123456"],
        [, , , , , , , , , [-1]],
        [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
        [, , , , , , , , , [-1]],
        "LC",
        1,
        "011",
        "1",
        ,
        ,
        "1|([2-8]\\d{6})$",
        "758$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "758",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      LI: [, [, , "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", , , , , , , [7, 9]], [
        ,
        ,
        "(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}",
        ,
        ,
        ,
        "2345678",
        ,
        ,
        [7]
      ], [, , "(?:6(?:(?:4[5-9]|5[0-4])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}", , , , "660234567"], [, , "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}", , , , "8002222"], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", , , , "9002222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "0|(1001)", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{2})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["69"],
        ,
        "$CC $1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d\\d", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]],
      LK: [, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", , , , "112345678", , , , [7]], [, , "7(?:[0-25-8]\\d|4[0-4])\\d{6}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "1973\\d{5}", , , , "197312345"], , , [, , , , , , , , , [-1]]],
      LR: [, [, , "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}", , , , , , , [7, 8, 9]], [, , "(?:2\\d{3}|33333)\\d{4}", , , , "21234567", , , [8, 9]], [, , "(?:(?:330|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [
        ,
        ,
        "332(?:02|[34]\\d)\\d{4}",
        ,
        ,
        ,
        "332021234",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LS: [, [, , "(?:[256]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LT: [, [, , "(?:[3469]\\d|52|[78]0)\\d{6}", , , , , , , [8]], [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"], [, , "6\\d{7}", , , , "61234567"], [, , "80[02]\\d{5}", , , , "80012345"], [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , "70[05]\\d{5}", , , , "70012345"], [, , "[89]01\\d{5}", , , , "80123456"], "LT", 370, "00", "8", , , "[08]", , , , [[
        ,
        "(\\d)(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["52[0-7]"],
        "(8-$1)",
        ,
        1
      ], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", , 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", , 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70[67]\\d{5}", , , , "70712345"], , , [, , , , , , , , , [-1]]],
      LU: [, [, , "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}",
        ,
        ,
        ,
        "27123456"
      ], [, , "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3",
        ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"],
        ,
        "$CC $1"
      ], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
        "$1 $2 $3 $4",
        ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"],
        ,
        "$CC $1"
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LV: [, [, , "(?:[268]\\d|90)\\d{6}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , "2\\d{7}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      LY: [
        ,
        [, , "[2-9]\\d{8}", , , , , , , [9], [7]],
        [, , "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}", , , , "212345678", , , , [7]],
        [, , "9[1-6]\\d{7}", , , , "912345678"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "LY",
        218,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MA: [
        ,
        [, , "[5-8]\\d{8}", , , , , , , [9]],
        [, , "5(?:29(?:[189][05]|2[29]|3[01])|389[05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[08]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}", , , , "520123456"],
        [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-367]))\\d{6}", , , , "650123456"],
        [, , "80\\d{7}", , , , "801234567"],
        [, , "89\\d{7}", , , , "891234567"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "592(?:4[0-2]|93)\\d{4}", , , , "592401234"],
        "MA",
        212,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[89]|389)", "5(?:29[89]|389)0"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], [, "(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        1,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MC: [, [, , "(?:[3489]|6\\d)\\d{7}", , , , , , , [8, 9]], [
        ,
        ,
        "(?:870|9[2-47-9]\\d)\\d{5}",
        ,
        ,
        ,
        "99123456",
        ,
        ,
        [8]
      ], [, , "4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}", , , , "612345678"], [, , "(?:800|90\\d)\\d{5}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MC", 377, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["87"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [[
        ,
        "(\\d{2})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["4"],
        "0$1"
      ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "8[07]0\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MD: [
        ,
        [, , "(?:[235-7]\\d|[89]0)\\d{6}", , , , , , , [8]],
        [, , "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"],
        [, , "562\\d{5}|(?:6\\d|7[16-9])\\d{6}", , , , "62112345"],
        [, , "800\\d{5}", , , , "80012345"],
        [, , "90[056]\\d{5}", , , , "90012345"],
        [, , "808\\d{5}", , , , "80812345"],
        [, , , , , , , , , [-1]],
        [, , "3[08]\\d{6}", , , , "30123456"],
        "MD",
        373,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "803\\d{5}", , , , "80312345"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ME: [, [, , "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", , , , , , , [8, 9], [6]], [, , "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", , , , "30234567", , , [8], [6]], [
        ,
        ,
        "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}",
        ,
        ,
        ,
        "67622901",
        ,
        ,
        [8]
      ], [, , "80(?:[0-2578]|9\\d)\\d{5}", , , , "80080002"], [, , "9(?:4[1568]|5[178])\\d{5}", , , , "94515151", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780", , , [8]], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012", , , [8]], , , [, , , , , , , , , [-1]]],
      MF: [, [, , "(?:590|(?:69|80)\\d|976)\\d{6}", , , , , , , [9]], [, , "590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}", , , , "590271234"], [
        ,
        ,
        "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}",
        ,
        ,
        ,
        "690001234"
      ], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "976[01]\\d{5}", , , , "976012345"], "MF", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MG: [
        ,
        [, , "[23]\\d{8}", , , , , , , [9], [7]],
        [, , "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}", , , , "202123456", , , , [7]],
        [, , "3[2-489]\\d{7}", , , , "321234567"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "22\\d{7}", , , , "221234567"],
        "MG",
        261,
        "00",
        "0",
        ,
        ,
        "0|([24-9]\\d{6})$",
        "20$1",
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MH: [, [, , "329\\d{4}|(?:[256]\\d|45)\\d{5}", , , , , , , [7]], [, , "(?:247|528|625)\\d{4}", , , , "2471234"], [, , "(?:(?:23|54)5|329|45[356])\\d{4}", , , , "2351234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "635\\d{4}", , , , "6351234"], "MH", 692, "011", "1", , , "1", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MK: [
        ,
        [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]],
        [, , "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[23]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]],
        [, , "7(?:3555|4(?:60\\d|747)|94(?:[01]\\d|2[0-4]))\\d{3}|7(?:[0-25-8]\\d|3[1-4]|42|9[23])\\d{5}", , , , "72345678"],
        [, , "800\\d{5}", , , , "80012345"],
        [, , "5[02-9]\\d{6}", , , , "50012345"],
        [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "MK",
        389,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      ML: [
        ,
        [, , "[24-9]\\d{7}", , , , , , , [8]],
        [, , "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}", , , , "20212345"],
        [, , "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[239])\\d{6}", , , , "65012345"],
        [, , "80\\d{6}", , , , "80012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "ML",
        223,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]],
        [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , "80\\d{6}"],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MM: [, [
        ,
        ,
        "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [6, 7, 8, 9, 10],
        [5]
      ], [
        ,
        ,
        "(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[2-469]|39|46|6[25]|7[0-3]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|2[246]|39|46|62|7[0-3]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[0-3])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|247[23]|3(?:20\\d|470)|4(?:2[04]\\d|47[23])|7(?:(?:3\\d|8[01459])\\d|4(?:39|60|7[013]))))\\d{4}|5(?:2(?:2\\d{5,6}|47[023]\\d{4})|(?:347[23]|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[0-2])|8(?:20\\d|47[02])|9(?:20\\d|47[01]))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:2\\d|4[1-9]|51)\\d|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
        ,
        ,
        ,
        "1234567",
        ,
        ,
        [6, 7, 8, 9],
        [5]
      ], [, , "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", , , , "92123456", , , [7, 8, 9, 10]], [, , "80080(?:[01][1-9]|2\\d)\\d{3}", , , , "8008001234", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1333\\d{4}|[12]468\\d{4}", , , , "13331234", , , [8]], "MM", 95, "00", "0", , , "0", , , , [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [
        ,
        "(\\d{2})(\\d{2})(\\d{3})",
        "$1 $2 $3",
        ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],
        "0$1"
      ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [, "(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MN: [
        ,
        [, , "[12]\\d{7,9}|[57-9]\\d{7}", , , , , , , [8, 9, 10], [4, 5, 6]],
        [, , "[12]2[1-3]\\d{5,6}|7(?:0[0-5]\\d|128)\\d{4}|(?:[12](?:1|27)|5[368])\\d{6}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}", , , , "53123456", , , , [4, 5, 6]],
        [, , "(?:83[01]|920)\\d{5}|(?:5[05]|8[05689]|9[013-9])\\d{6}", , , , "88123456", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "712[0-79]\\d{4}|7(?:1[013-9]|[25-8]\\d)\\d{5}", , , , "75123456", , , [8]],
        "MN",
        976,
        "001",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MO: [, [, , "0800\\d{3}|(?:28|[68]\\d)\\d{6}", , , , , , , [7, 8]], [
        ,
        ,
        "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
        ,
        ,
        ,
        "28212345",
        ,
        ,
        [8]
      ], [, , "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", , , , "66123456", , , [8]], [, , "0800\\d{3}", , , , "0800501", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MP: [, [, , "[58]\\d{9}|(?:67|90)0\\d{7}", , , , , , , [10], [7]], [
        ,
        ,
        "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
        ,
        ,
        ,
        "6702345678",
        ,
        ,
        ,
        [7]
      ], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "1|([2-9]\\d{6})$", "670$1", , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MQ: [
        ,
        [, , "(?:69|80)\\d{7}|(?:59|97)6\\d{6}", , , , , , , [9]],
        [, , "596(?:[04-7]\\d|10|2[7-9]|3[014-9]|8[09]|9[4-9])\\d{4}", , , , "596301234"],
        [, , "69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}", , , , "696201234"],
        [, , "80[0-5]\\d{6}", , , , "800012345"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "976(?:6\\d|7[0-367])\\d{4}", , , , "976612345"],
        "MQ",
        596,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      MR: [, [, , "(?:[2-4]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "(?:25[08]|35\\d|45[1-7])\\d{5}", , , , "35123456"], [, , "[2-4][0-46-9]\\d{6}", , , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[2-48]"]
      ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MS: [, [, , "(?:[58]\\d\\d|664|900)\\d{7}", , , , , , , [10], [7]], [, , "6644(?:1[0-3]|91)\\d{4}", , , , "6644912345", , , , [7]], [, , "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "1|([34]\\d{6})$", "664$1", , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MT: [, [, , "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}", , , , "96961234"], [, , "800(?:02|[3467]\\d)\\d{3}", , , , "80071234"], [
        ,
        ,
        "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
        ,
        ,
        ,
        "50037123"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]],
      MU: [, [, , "(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}", , , , , , , [7, 8, 10]], [, , "(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", , , , "54480123", , , [7, 8]], [
        ,
        ,
        "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])\\d{5}",
        ,
        ,
        ,
        "52512345",
        ,
        ,
        [8]
      ], [, , "802\\d{7}|80[0-2]\\d{4}", , , , "8001234", , , [7, 10]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", , , , , , "020", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["5"]], [, "(\\d{5})(\\d{5})", "$1 $2", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MV: [, [, , "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", , , , , , , [7, 10]], [
        ,
        ,
        "(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024-68]|8[024689]))\\d{4}",
        ,
        ,
        ,
        "6701234",
        ,
        ,
        [7]
      ], [, , "46[46]\\d{4}|(?:7\\d|9[13-9])\\d{5}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9[13-9]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "4(?:0[01]|50)\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]],
      MW: [, [, , "(?:[129]\\d|31|77|88)\\d{7}|1\\d{6}", , , , , , , [7, 9]], [
        ,
        ,
        "(?:1[2-9]|2[12]\\d\\d)\\d{5}",
        ,
        ,
        ,
        "1234567"
      ], [, , "111\\d{6}|(?:31|77|88|9[89])\\d{7}", , , , "991234567", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MX: [, [
        ,
        ,
        "1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [10, 11],
        [7, 8]
      ], [, , "6571\\d{6}|(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}", , , , "2001234567", , , [10], [7, 8]], [
        ,
        ,
        "6571\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}",
        ,
        ,
        ,
        "12221234567",
        ,
        ,
        ,
        [7, 8]
      ], [, , "8(?:00|88)\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , "300\\d{7}", , , , "3001234567", , , [10]], [, , "500\\d{7}", , , , "5001234567", , , [10]], [, , , , , , , , , [-1]], "MX", 52, "0[09]", "01", , , "0(?:[12]|4[45])|1", , "00", , [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [
        ,
        "(\\d)(\\d{3})(\\d{3})(\\d{4})",
        "$2 $3 $4",
        ["1"],
        ,
        ,
        1
      ]], [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], , , 1], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], , , 1], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], , , 1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MY: [, [, , "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [
        ,
        ,
        "(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}",
        ,
        ,
        ,
        "323856789",
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "1(?:1888[69]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0134]\\d|2[1-9]|5[0-6]))|(?:(?:[269]|59)\\d|[37][1-9]|4[235-9])\\d|8(?:1[23]|[236]\\d|4[06]|5[7-9]|7[016-9]|8[01]|9[0-8]))\\d{5}", , , , "123456789", , , [9, 10]], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}",
        ,
        ,
        ,
        "1546012345",
        ,
        ,
        [10]
      ], "MY", 60, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9])|8"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      MZ: [, [
        ,
        ,
        "(?:2|8\\d)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9]
      ], [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]], [, , "8[2-79]\\d{7}", , , , "821234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MZ", 258, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NA: [, [, , "[68]\\d{7,8}", , , , , , , [8, 9]], [
        ,
        ,
        "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
        ,
        ,
        ,
        "61221234"
      ], [, , "(?:60|8[1245])\\d{7}", , , , "811234567", , , [9]], [, , "80\\d{7}", , , , "800123456", , , [9]], [, , "8701\\d{5}", , , , "870123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d\\d|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      NC: [, [, , "(?:050|[2-57-9]\\d\\d)\\d{3}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [, , "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}", , , , "751234"], [, , "050\\d{3}", , , , "050012"], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{3})", "$1", ["5[6-8]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      NE: [, [, , "[027-9]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}", , , , "20201234"], [, , "(?:23|7[04]|[89]\\d)\\d{6}", , , , "93123456"], [, , "08\\d{6}", , , , "08123456"], [, , "09\\d{6}", , , , "09123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NE", 227, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      NF: [, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", , , , "106609", , , , [5]], [, , "(?:14|3[58])\\d{4}", , , , "381234", , , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , "([0-258]\\d{4})$", "3$1", , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], [, "(\\d)(\\d{5})", "$1 $2", ["[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NG: [
        ,
        [
          ,
          ,
          "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
          ,
          ,
          ,
          ,
          ,
          ,
          [7, 8, 10, 11, 12, 13, 14],
          [5, 6]
        ],
        [, , "(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}", , , , "18040123", , , [7, 8], [5, 6]],
        [, , "(?:702[0-24-9]|8(?:01|19)[01])\\d{6}|(?:70[13-689]|8(?:0[2-9]|1[0-8])|9(?:0[1-9]|1[2356]))\\d{7}", , , , "8021234567", , , [10]],
        [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "NG",
        234,
        "009",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      NI: [, [
        ,
        ,
        "(?:1800|[25-8]\\d{3})\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8]
      ], [, , "2\\d{7}", , , , "21234567"], [, , "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}", , , , "81234567"], [, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NL: [, [, , "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", , , , , , , [5, 6, 7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
        ,
        ,
        ,
        "101234567",
        ,
        ,
        [9]
      ], [, , "(?:6[1-58]|970\\d)\\d{7}", , , , "612345678", , , [9, 11]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:85|91)\\d{7}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{3})",
        "$1 $2 $3",
        ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
        "0$1"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [
        ,
        "(\\d{3})(\\d{3})(\\d{5})",
        "$1 $2 $3",
        ["9"],
        "0$1"
      ]], [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d", , , , , , , [5, 6]], [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", , , , "14020", , , [5, 6, 9]], , , [, , , , , , , , , [-1]]],
      NO: [, [, , "(?:0|[2-9]\\d{3})\\d{4}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [
        ,
        ,
        "(?:4[015-8]|59|9\\d)\\d{6}",
        ,
        ,
        ,
        "40612345",
        ,
        ,
        [8]
      ], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|59"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], , [, , , , , , , , , [-1]], 1, "[02-689]|7[0-8]", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
        ,
        ,
        "81[23]\\d{5}",
        ,
        ,
        ,
        "81212345",
        ,
        ,
        [8]
      ]],
      NP: [, [, , "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", , , , , , , [8, 10, 11], [6, 7]], [, , "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", , , , "14567890", , , [8], [6, 7]], [, , "9(?:6[0-3]|7[24-6]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , "1(?:66001|800\\d\\d)\\d{5}", , , , "16600101234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [
        ,
        "(\\d{2})(\\d{6})",
        "$1-$2",
        ["1[01]|[2-8]|9(?:[1-579]|6[2-6])"],
        "0$1"
      ], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]], [, "(\\d{4})(\\d{2})(\\d{5})", "$1-$2-$3", ["1"]]], [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-579]|6[2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      NR: [
        ,
        [, , "(?:444|(?:55|8\\d)\\d|666)\\d{4}", , , , , , , [7]],
        [, , "444\\d{4}", , , , "4441234"],
        [, , "(?:55[3-9]|666|8\\d\\d)\\d{4}", , , , "5551234"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "NR",
        674,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      NU: [
        ,
        [, , "(?:[47]|888\\d)\\d{3}", , , , , , , [4, 7]],
        [, , "[47]\\d{3}", , , , "7012", , , [4]],
        [, , "888[4-9]\\d{3}", , , , "8884012", , , [7]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "NU",
        683,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      NZ: [
        ,
        [, , "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10]],
        [, , "24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", , , , "32345678", , , [8], [7]],
        [, , "2[0-27-9]\\d{7,8}|21\\d{6}", , , , "211234567", , , [8, 9, 10]],
        [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456", , , [8, 9, 10]],
        [, , "(?:11\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", , , , "900123456", , , [7, 8, 9, 10]],
        [, , , , , , , , , [-1]],
        [, , "70\\d{7}", , , , "701234567", , , [9]],
        [, , , , , , , , , [-1]],
        "NZ",
        64,
        "0(?:0|161)",
        "0",
        ,
        ,
        "0",
        ,
        "00",
        ,
        [[, "(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]],
        ,
        [
          ,
          ,
          "[28]6\\d{6,7}",
          ,
          ,
          ,
          "26123456",
          ,
          ,
          [8, 9]
        ],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "8(?:1[6-9]|22|3\\d|4[045]|5[459]|7[0-3579]|90)\\d{2,7}", , , , "83012378"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      OM: [, [, , "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", , , , , , , [7, 8, 9]], [, , "2[2-6]\\d{6}", , , , "23123456", , , [8]], [, , "1505\\d{4}|(?:7(?:[1289]\\d|7[0-4])|9(?:0[1-9]|[1-9]\\d))\\d{5}", , , , "92123456", , , [8]], [, , "8007\\d{4,5}|(?:500|800[05])\\d{4}", , , , "80071234"], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "OM", 968, "00", , , , , , , , [[
        ,
        "(\\d{3})(\\d{4,6})",
        "$1 $2",
        ["[58]"]
      ], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PA: [, [, , "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", , , , , , , [7, 8, 10, 11]], [
        ,
        ,
        "(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[258]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
        ,
        ,
        ,
        "2001234",
        ,
        ,
        [7]
      ], [, , "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", , , , "61234567", , , [7, 8]], [, , "800\\d{4,5}|(?:00800|800\\d)\\d{6}", , , , "8001234"], [, , "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PE: [, [
        ,
        ,
        "(?:[14-8]|9\\d)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9],
        [6, 7]
      ], [, , "(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "19(?:1[124]|77|90)00", "0", " Anexo ", , "0", , , , [
        [, "(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"],
        [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"],
        [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"],
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]
      ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PF: [, [, , "4\\d{5}(?:\\d{2})?|8\\d{7,8}", , , , , , , [6, 8, 9]], [, , "4(?:0[4-689]|9[4-68])\\d{5}", , , , "40412345", , , [8]], [, , "8[7-9]\\d{6}", , , , "87123456", , , [8]], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "499\\d{5}", , , , "49901234", , , [8]], "PF", 689, "00", , , , , , , , [[
        ,
        "(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3",
        ["44"]
      ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , "44\\d{4}", , , , , , , [6]], [, , "44\\d{4}", , , , "440123", , , [6]], , , [, , , , , , , , , [-1]]],
      PG: [, [, , "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", , , , , , , [7, 8]], [, , "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", , , , "3123456", , , [7]], [, , "(?:7\\d|8[128])\\d{6}", , , , "70123456", , , [8]], [
        ,
        ,
        "180\\d{4}",
        ,
        ,
        ,
        "1801234",
        ,
        ,
        [7]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-47]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "00|140[1-3]", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], , [, , "27[01]\\d{4}", , , , "2700123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PH: [, [, , "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [
        ,
        ,
        "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
        ,
        ,
        ,
        "232345678",
        ,
        ,
        [6, 8, 9, 10],
        [4, 5, 7]
      ], [, , "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [
        ,
        "(\\d{4})(\\d{4,6})",
        "$1 $2",
        ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
        "(0$1)"
      ], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PK: [, [
        ,
        ,
        "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [8, 9, 10, 11, 12],
        [5, 6, 7]
      ], [, , "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", , , , "2123456789", , , [9, 10], [5, 6, 7, 8]], [, , "3(?:[0-24]\\d|3[0-7]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}(?:\\d{3})?", , , , "80012345", , , [8, 11]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [
        ,
        ,
        "122\\d{6}",
        ,
        ,
        ,
        "122044444",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [
        ,
        "(\\d{3})(\\d{6,7})",
        "$1 $2",
        ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
        ,
        ,
        ,
        "21111825888",
        ,
        ,
        [11, 12]
      ], , , [, , , , , , , , , [-1]]],
      PL: [, [, , "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?", , , , , , , [6, 7, 8, 9, 10]], [, , "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", , , , "123456789", , , [7, 9]], [, , "21(?:1(?:[145]\\d|3[1-5])|2[0-4]\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [
        ,
        ,
        "801\\d{6}",
        ,
        ,
        ,
        "801234567",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [
        [, "(\\d{5})", "$1", ["19"]],
        [, "(\\d{3})(\\d{3})", "$1 $2", ["11|64"]],
        [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],
        [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]],
        [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],
        [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]
      ], , [, , "64\\d{4,7}", , , , "641234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]],
      PM: [
        ,
        [, , "(?:[45]|80\\d\\d)\\d{5}", , , , , , , [6, 9]],
        [, , "(?:4[1-356]|50)\\d{4}", , , , "430123", , , [6]],
        [, , "(?:4[02-4]|5[056])\\d{4}", , , , "551234", , , [6]],
        [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "PM",
        508,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      PR: [, [, , "(?:[589]\\d\\d|787)\\d{7}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PS: [, [, , "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", , , , , , , [8, 9, 10], [7]], [, , "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", , , , "22234567", , , [8], [7]], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[
        ,
        "(\\d)(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["[2489]"],
        "0$1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PT: [, [, , "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", , , , , , , [9]], [, , "2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}", , , , "212345678"], [, , "6[0356]92(?:30|9\\d)\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}", , , , "912345678"], [, , "80[02]\\d{6}", , , , "800123456"], [
        ,
        ,
        "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}",
        ,
        ,
        ,
        "760123456"
      ], [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"], [, , "884[0-4689]\\d{5}", , , , "884123456"], [, , "30\\d{7}", , , , "301234567"], "PT", 351, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70(?:7\\d|8[17])\\d{5}", , , , "707123456"], , , [, , "600\\d{6}", , , , "600110000"]],
      PW: [, [, , "(?:[24-8]\\d\\d|345|900)\\d{4}", , , , , , , [7]], [
        ,
        ,
        "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}",
        ,
        ,
        ,
        "2771234"
      ], [, , "(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}", , , , "6201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PW", 680, "01[12]", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      PY: [, [, , "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [
        ,
        ,
        "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
        ,
        ,
        ,
        "212345678",
        ,
        ,
        [7, 8, 9],
        [5, 6]
      ], [, , "9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , "9800\\d{5,7}", , , , "98000123456", , , [9, 10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], [
        ,
        "(\\d{2})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
        "(0$1)"
      ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]]],
      QA: [, [, , "[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}", , , , , , , [7, 8, 9]], [
        ,
        ,
        "4141\\d{4}|(?:23|4[04])\\d{6}",
        ,
        ,
        ,
        "44123456",
        ,
        ,
        [8]
      ], [, , "(?:2[89]|[35-7]\\d)\\d{6}", , , , "33123456", , , [8]], [, , "800\\d{4}(?:\\d{2})?", , , , "8001234", , , [7, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]]], , [, , "2(?:[12]\\d|61)\\d{4}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RE: [, [, , "9769\\d{5}|(?:26|[68]\\d)\\d{7}", , , , , , , [9]], [, , "26(?:2\\d\\d|30[0-5])\\d{4}", , , , "262161234"], [
        ,
        ,
        "(?:69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|6[0-6]|7[0-27]|8[0-8]|9[0-479]))|9769\\d)\\d{4}",
        ,
        ,
        ,
        "692123456"
      ], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RE", 262, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], , [, , , , , , , , , [-1]], 1, "26[23]|69|[89]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RO: [, [, , "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", , , , , , , [6, 9]], [, , "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d", , , , "211234567"], [
        ,
        ,
        "7020\\d{5}|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[019])\\d{6}",
        ,
        ,
        ,
        "712034567",
        ,
        ,
        [9]
      ], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[0136]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "(?:37\\d|80[578])\\d{6}",
        ,
        ,
        ,
        "372123456",
        ,
        ,
        [9]
      ], , , [, , , , , , , , , [-1]]],
      RS: [, [, , "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", , , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [, , "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [4, 5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [, , "800\\d{3,9}", , , , "80012345"], [, , "(?:78\\d|90[0169])\\d{3,7}", , , , "90012345", , , [6, 7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], "RS", 381, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]],
      RU: [, [, , "8\\d{13}|[347-9]\\d{9}", , , , , , , [10, 14], [7]], [, , "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", , , , "3011234567", , , [10], [7]], [
        ,
        ,
        "9\\d{9}",
        ,
        ,
        ,
        "9123456789",
        ,
        ,
        [10]
      ], [, , "8(?:0[04]|108\\d{3})\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[0-79]"]], [, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
        ,
        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [
        ,
        "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
        "$1 $2 $3 $4",
        ["8"],
        "8 ($1)"
      ]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
        ,
        "(\\d{5})(\\d)(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
        "8 ($1)",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [, , , , , , , , , [-1]], 1, "3[04-689]|[489]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      RW: [, [, , "(?:06|[27]\\d\\d|[89]00)\\d{6}", , , , , , , [8, 9]], [, , "(?:06|2[23568]\\d)\\d{6}", , , , "250123456"], [, , "7[2389]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
        ,
        ,
        "900\\d{6}",
        ,
        ,
        ,
        "900123456",
        ,
        ,
        [9]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SA: [, [, , "92\\d{7}|(?:[15]|8\\d)\\d{8}", , , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [9], [7]], [
        ,
        ,
        "579[01]\\d{5}|5(?:[013-689]\\d|7[0-35-8])\\d{6}",
        ,
        ,
        ,
        "512345678",
        ,
        ,
        [9]
      ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "925\\d{6}", , , , "925012345", , , [9]], [, , "920\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        "811\\d{7}",
        ,
        ,
        ,
        "8110123456",
        ,
        ,
        [10]
      ], , , [, , , , , , , , , [-1]]],
      SB: [
        ,
        [, , "(?:[1-6]|[7-9]\\d\\d)\\d{4}", , , , , , , [5, 7]],
        [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]],
        [, , "48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}", , , , "7421234"],
        [, , "1[38]\\d{3}", , , , "18123", , , [5]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "5[12]\\d{3}", , , , "51123", , , [5]],
        "SB",
        677,
        "0[01]",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SC: [, [, , "800\\d{4}|(?:[249]\\d|64)\\d{5}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[125-8]\\d{5}", , , , "2510123"], [, , "800[08]\\d{3}", , , , "8000000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "971\\d{4}|(?:64|95)\\d{5}", , , , "6412345"], "SC", 248, "010|0[0-2]", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SD: [, [, , "[19]\\d{8}", , , , , , , [9]], [
        ,
        ,
        "1(?:5\\d|8[35-7])\\d{6}",
        ,
        ,
        ,
        "153123456"
      ], [, , "(?:1[0-2]|9[0-3569])\\d{7}", , , , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SE: [, [, , "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", , , , , , , [6, 7, 8, 9, 10, 12]], [
        ,
        ,
        "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
        ,
        ,
        ,
        "8123456",
        ,
        ,
        [7, 8, 9]
      ], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77[0-7]\\d{6}", , , , "771234567", , , [9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1"], [
        ,
        "(\\d{2})(\\d{3})(\\d{2})",
        "$1-$2 $3",
        ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
        "0$1"
      ], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1"], [
        ,
        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
        "$1-$2 $3 $4",
        ["8"],
        "0$1"
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44|9)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [
        ,
        "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["8"]
      ], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["10|7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [
        ,
        "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
      ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "10[1-8]\\d{6}", , , , "102345678", , , [9]], , , [, , "(?:25[245]|67[3-68])\\d{9}", , , , "254123456789", , , [12]]],
      SG: [, [, , "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", , , , , , , [8, 10, 11]], [
        ,
        ,
        "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
        ,
        ,
        ,
        "61234567",
        ,
        ,
        [8]
      ], [, , "8(?:051|95[0-2])\\d{4}|(?:8(?:0[1-4]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}", , , , "81234567", , , [8]], [, , "(?:18|8)00\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[12]\\d|666)\\d{5}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [[, "(\\d{4,5})", "$1", ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-5]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [
        ,
        "(\\d{4})(\\d{4})(\\d{3})",
        "$1 $2 $3",
        ["7"]
      ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-5]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]],
      SH: [
        ,
        [, , "(?:[256]\\d|8)\\d{3}", , , , , , , [4, 5]],
        [, , "2(?:[0-57-9]\\d|6[4-9])\\d\\d", , , , "22158"],
        [, , "[56]\\d{4}", , , , "51234", , , [5]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "262\\d\\d", , , , "26212", , , [5]],
        "SH",
        290,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        1,
        "[256]",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SI: [, [, , "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", , , , , , , [5, 6, 7, 8]], [, , "(?:[1-357][2-8]|4[24-8])\\d{6}", , , , "12345678", , , [8], [7]], [, , "65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", , , , "31234567", , , [8]], [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]], [, , "89[1-3]\\d{2,5}|90\\d{4,6}", , , , "90123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", , , , "59012345", , , [8]], "SI", 386, "00|10(?:22|66|88|99)", "0", , , "0", , "00", , [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SJ: [, [
        ,
        ,
        "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 8]
      ], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|59|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "79", [, , , , , , , , , [-1]], [, , "(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [, , "81[23]\\d{5}", , , , "81212345", , , [8]]],
      SK: [, [
        ,
        ,
        "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
        ,
        ,
        ,
        ,
        ,
        ,
        [6, 7, 9]
      ], [, , "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", , , , "221234567"], [, , "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", , , , "912123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:00|[78]\\d)\\d{6}", , , , "900123456", , , [9]], [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]], [, , , , , , , , , [-1]], [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]], "SK", 421, "00", "0", , , "0", , , , [[
        ,
        "(\\d)(\\d{2})(\\d{3,4})",
        "$1 $2 $3",
        ["21"],
        "0$1"
      ], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [
        ,
        "(\\d)(\\d{3})(\\d{3})(\\d{2})",
        "$1/$2 $3 $4",
        ["2"],
        "0$1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], [, , "9090\\d{3}", , , , "9090123", , , [7]], , , [, , "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}", , , , , , , [7, 9]], [, , "96\\d{7}", , , , "961234567", , , [9]], , , [, , , , , , , , , [-1]]],
      SL: [, [, , "(?:[237-9]\\d|66)\\d{6}", , , , , , , [8], [6]], [, , "22[2-4][2-9]\\d{4}", , , , "22221234", , , , [6]], [, , "(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}", , , , "25123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SM: [
        ,
        [, , "(?:0549|[5-7]\\d)\\d{6}", , , , , , , [8, 10], [6]],
        [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]],
        [, , "6[16]\\d{6}", , , , "66661212", , , [8]],
        [, , , , , , , , , [-1]],
        [, , "7[178]\\d{6}", , , , "71123456", , , [8]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "5[158]\\d{6}", , , , "58001110", , , [8]],
        "SM",
        378,
        "00",
        ,
        ,
        ,
        "([89]\\d{5})$",
        "0549$1",
        ,
        ,
        [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]],
        [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SN: [, [, , "(?:[378]\\d|93)\\d{7}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [
        ,
        ,
        "75(?:01|[38]3)\\d{5}|7(?:[06-8]\\d|21|5[4-7]|90)\\d{6}",
        ,
        ,
        ,
        "701234567"
      ], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SO: [, [, , "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", , , , , , , [6, 7, 8, 9]], [
        ,
        ,
        "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
        ,
        ,
        ,
        "4012345",
        ,
        ,
        [6, 7]
      ], [, , "(?:(?:15|(?:3[59]|4[89]|79|8[08])\\d|6(?:0[5-7]|[1-9]\\d)|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:6\\d|7[1-9])\\d{6}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], [
        ,
        "(\\d)(\\d{7})",
        "$1 $2",
        ["24|[67]"]
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SR: [
        ,
        [, , "(?:[2-5]|68|[78]\\d)\\d{5}", , , , , , , [6, 7]],
        [, , "(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}", , , , "211234"],
        [, , "(?:7[124-7]|8[124-9])\\d{5}", , , , "7412345", , , [7]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "56\\d{4}", , , , "561234", , , [6]],
        "SR",
        597,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      SS: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1[89]\\d{7}", , , , "181234567"], [, , "(?:12|9[1257-9])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ST: [, [, , "(?:22|9\\d)\\d{5}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SV: [, [, , "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", , , , , , , [7, 8, 11]], [
        ,
        ,
        "2(?:[1-6]\\d{3}|[79]90[034]|890[0245])\\d{3}",
        ,
        ,
        ,
        "21234567",
        ,
        ,
        [8]
      ], [, , "66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}", , , , "70123456", , , [8]], [, , "800\\d{4}(?:\\d{4})?", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SX: [, [
        ,
        ,
        "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [10],
        [7]
      ], [, , "7215(?:4[2-8]|8[239]|9[056])\\d{4}", , , , "7215425678", , , , [7]], [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "SX", 1, "011", "1", , , "1|(5\\d{6})$", "721$1", , , , , [, , , , , , , , , [-1]], , "721", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SY: [, [, , "[1-39]\\d{8}|[1-5]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "9[1-689]\\d{7}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[
        ,
        "(\\d{2})(\\d{3})(\\d{3,4})",
        "$1 $2 $3",
        ["[1-5]"],
        "0$1",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      SZ: [, [, , "0800\\d{4}|(?:[237]\\d|900)\\d{6}", , , , , , , [8, 9]], [, , "[23][2-5]\\d{6}", , , , "22171234", , , [8]], [, , "7[6-9]\\d{6}", , , , "76123456", , , [8]], [, , "0800\\d{4}", , , , "08001234", , , [8]], [, , "900\\d{6}", , , , "900012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{6}", , , , "70012345", , , [8]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [
        ,
        "(\\d{5})(\\d{4})",
        "$1 $2",
        ["9"]
      ]], , [, , , , , , , , , [-1]], , , [, , "0800\\d{4}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TA: [, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TC: [, [, , "(?:[58]\\d\\d|649|900)\\d{7}", , , , , , , [10], [7]], [, , "649(?:266|712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [
        ,
        ,
        "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}",
        ,
        ,
        ,
        "6492311234",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "649(?:71[01]|966)\\d{4}", , , , "6497101234", , , , [7]], "TC", 1, "011", "1", , , "1|([2-479]\\d{6})$", "649$1", , , , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TD: [, [, , "(?:22|[69]\\d|77)\\d{6}", , , , , , , [8]], [, , "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:6[023568]|77|9\\d)\\d{6}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", , , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TG: [, [, , "[279]\\d{7}", , , , , , , [8]], [
        ,
        ,
        "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
        ,
        ,
        ,
        "22212345"
      ], [, , "(?:7[09]|9[0-36-9])\\d{6}", , , , "90112345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TH: [, [, , "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", , , , , , , [8, 9, 10, 13]], [, , "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [
        ,
        ,
        "671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
        ,
        ,
        ,
        "812345678",
        ,
        ,
        [9]
      ], [, , "(?:001800\\d|1800)\\d{6}", , , , "1800123456", , , [10, 13]], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00[1-9]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TJ: [, [, , "(?:00|[1-57-9]\\d)\\d{7}", , , , , , , [9], [3, 5, 6, 7]], [
        ,
        ,
        "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
        ,
        ,
        ,
        "372123456",
        ,
        ,
        ,
        [3, 5, 6, 7]
      ], [, , "41[18]\\d{6}|(?:[034]0|[17][017]|2[02]|5[05]|8[08]|9\\d)\\d{7}", , , , "917123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TJ", 992, "810", , , , , , "8~10", , [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"]], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TK: [, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TL: [, [, , "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", , , , , , , [7, 8]], [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]], [, , "7[2-8]\\d{6}", , , , "77212345", , , [8]], [, , "80\\d{5}", , , , "8012345", , , [7]], [
        ,
        ,
        "90\\d{5}",
        ,
        ,
        ,
        "9012345",
        ,
        ,
        [7]
      ], [, , , , , , , , , [-1]], [, , "70\\d{5}", , , , "7012345", , , [7]], [, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TM: [
        ,
        [, , "[1-6]\\d{7}", , , , , , , [8]],
        [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"],
        [, , "6\\d{7}", , , , "66123456"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "TM",
        993,
        "810",
        "8",
        ,
        ,
        "8",
        ,
        "8~10",
        ,
        [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      TN: [, [, , "[2-57-9]\\d{7}", , , , , , , [8]], [, , "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}", , , , "30010123"], [, , "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}", , , , "20123456"], [
        ,
        ,
        "8010\\d{4}",
        ,
        ,
        ,
        "80101234"
      ], [, , "88\\d{6}", , , , "88123456"], [, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TO: [
        ,
        [, , "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", , , , , , , [5, 7]],
        [, , "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", , , , "20123", , , [5]],
        [, , "(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", , , , "7715123", , , [7]],
        [, , "0800\\d{3}", , , , "0800222", , , [7]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "55[0-37-9]\\d{4}", , , , "5510123", , , [7]],
        "TO",
        676,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      TR: [, [, , "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", , , , , , , [7, 10, 12, 13]], [
        ,
        ,
        "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
        ,
        ,
        ,
        "2123456789",
        ,
        ,
        [10]
      ], [, , "56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", , , , "5012345678", , , [10]], [, , "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", , , , "8001234567", , , [10, 12, 13]], [, , "(?:8[89]8|900)\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , "592(?:21[12]|461)\\d{4}", , , , "5922121234", , , [10]], [, , "850\\d{7}", , , , "8500123456", , , [10]], "TR", 90, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
        "$1 $2 $3 $4",
        ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"],
        "0$1",
        ,
        1
      ], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1], [
        ,
        "(\\d{3})(\\d{3})(\\d{6,7})",
        "$1 $2 $3",
        ["80"],
        "0$1",
        ,
        1
      ]], [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "(?:444|811\\d{3})\\d{4}", , , , , , , [7, 10]], [, , "444\\d{4}", , , , "4441444", , , [7]], , , [, , , , , , , , , [-1]]],
      TT: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "868(?:2(?:0[13]|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [, , "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}", , , , "8682911234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002345678"
      ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "1|([2-46-8]\\d{6})$", "868$1", , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]],
      TV: [, [
        ,
        ,
        "(?:2|7\\d\\d|90)\\d{4}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7]
      ], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:7[01]\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["90"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      TW: [, [, , "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", , , , , , , [7, 8, 9, 10, 11]], [
        ,
        ,
        "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
        ,
        ,
        ,
        "221234567",
        ,
        ,
        [8, 9]
      ], [, , "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}|800\\d{5}", , , , "800123456", , , [8, 9]], [, , "20(?:[013-9]\\d\\d|2)\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", , , , "7012345678", , , [10, 11]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", , "0", , , , [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], [
        ,
        "(\\d)(\\d{3,4})(\\d{4})",
        "$1 $2 $3",
        ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],
        "0$1"
      ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]],
      TZ: [, [, , "(?:[26-8]\\d|41|90)\\d{7}", , , , , , , [9]], [, , "2[2-8]\\d{7}", , , , "222345678"], [, , "77[2-9]\\d{6}|(?:6[1-9]|7[1-689])\\d{7}", , , , "621234567"], [, , "80[08]\\d{6}", , , , "800123456"], [
        ,
        ,
        "90\\d{7}",
        ,
        ,
        ,
        "900123456"
      ], [, , "8(?:40|6[01])\\d{6}", , , , "840123456"], [, , , , , , , , , [-1]], [, , "41\\d{7}", , , , "412345678"], "TZ", 255, "00[056]", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UA: [, [, , "[89]\\d{9}|[3-9]\\d{8}", , , , , , , [9, 10], [5, 6, 7]], [
        ,
        ,
        "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
        ,
        ,
        ,
        "311234567",
        ,
        ,
        [9],
        [5, 6, 7]
      ], [, , "(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}", , , , "501234567", , , [9]], [, , "800[1-8]\\d{5,6}", , , , "800123456"], [, , "900[239]\\d{5,6}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567", , , [9]], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", [
        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
      ], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UG: [, [, , "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", , , , , , , [9], [5, 6, 7]], [
        ,
        ,
        "20(?:(?:(?:24|81)0|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
        ,
        ,
        ,
        "312345678",
        ,
        ,
        ,
        [5, 6, 7]
      ], [, , "726[01]\\d{5}|7(?:[01578]\\d|20|36|[46][0-4]|9[89])\\d{6}", , , , "712345678"], [, , "800[1-3]\\d{5}", , , , "800123456"], [, , "90[1-3]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      US: [, [
        ,
        ,
        "[2-9]\\d{9}|3\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [10],
        [7]
      ], [
        ,
        ,
        "5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|22|33)|4(?:00|4[24]|65|82)|5(?:00|29|58|83)|6(?:00|66|82)|7(?:58|77)|8(?:00|42|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0157-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
        ,
        ,
        ,
        "2015550123",
        ,
        ,
        ,
        [7]
      ], [
        ,
        ,
        "5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|22|33)|4(?:00|4[24]|65|82)|5(?:00|29|58|83)|6(?:00|66|82)|7(?:58|77)|8(?:00|42|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0157-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}",
        ,
        ,
        ,
        "2015550123",
        ,
        ,
        ,
        [7]
      ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "US", 1, "011", "1", , , "1", , , 1, [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [
        ,
        "(\\d{3})(\\d{4})",
        "$1-$2",
        ["[24-9]|3(?:[02-9]|1[1-9])"]
      ], [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], , , 1]], [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UY: [, [, , "4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", , , , , , , [7, 8, 10]], [, , "(?:1(?:770|987)|(?:2\\d|4[2-7])\\d\\d)\\d{4}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [, , "(?:4\\d{5}|80[05])\\d{4}|405\\d{4}", , , , "8001234", , , [7, 10]], [
        ,
        ,
        "90[0-8]\\d{4}",
        ,
        ,
        ,
        "9001234",
        ,
        ,
        [7]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", , "0", , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      UZ: [, [, , "(?:33|55|[679]\\d|88)\\d{7}", , , , , , , [9]], [
        ,
        ,
        "(?:6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}",
        ,
        ,
        ,
        "669050123"
      ], [
        ,
        ,
        "(?:(?:33|88|9[0-57-9])\\d{3}|55(?:50[013]|90\\d)|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
        ,
        ,
        ,
        "912345678"
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VA: [, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , "06698\\d{1,6}", , , , "0669812345", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [
        ,
        ,
        "80(?:0\\d{3}|3)\\d{3}",
        ,
        ,
        ,
        "800123456",
        ,
        ,
        [6, 9]
      ], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "06698", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
      VC: [
        ,
        [, , "(?:[58]\\d\\d|784|900)\\d{7}", , , , , , , [10], [7]],
        [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]],
        [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}", , , , "7844301234", , , , [7]],
        [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
        [, , "900[2-9]\\d{6}", , , , "9002345678"],
        [, , , , , , , , , [-1]],
        [
          ,
          ,
          "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}",
          ,
          ,
          ,
          "5002345678"
        ],
        [, , "78451[0-2]\\d{4}", , , , "7845101234", , , , [7]],
        "VC",
        1,
        "011",
        "1",
        ,
        ,
        "1|([2-7]\\d{6})$",
        "784$1",
        ,
        ,
        ,
        ,
        [, , , , , , , , , [-1]],
        ,
        "784",
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      VE: [
        ,
        [, , "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", , , , , , , [10], [7]],
        [, , "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}", , , , "2121234567", , , , [7]],
        [, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"],
        [, , "800\\d{7}", , , , "8001234567"],
        [, , "90[01]\\d{7}", , , , "9001234567"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "VE",
        58,
        "00",
        "0",
        ,
        ,
        "0",
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1", "$CC $1"]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "501\\d{7}", , , , "5010123456", , , , [7]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      VG: [, [, , "(?:284|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "284496[0-5]\\d{3}|284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}", , , , "2842291234", , , , [7]], [, , "284496[6-9]\\d{3}|284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|5(?:4[0-7]|68|9[69]))\\d{4}", , , , "2843001234", , , , [7]], [
        ,
        ,
        "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "8002345678"
      ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "1|([2-578]\\d{6})$", "284$1", , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VI: [, [
        ,
        ,
        "[58]\\d{9}|(?:34|90)0\\d{7}",
        ,
        ,
        ,
        ,
        ,
        ,
        [10],
        [7]
      ], [, , "340(?:2(?:0[0-38]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "340(?:2(?:0[0-38]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
        ,
        ,
        "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-7]|33|44|66|77|88)[2-9]\\d{6}",
        ,
        ,
        ,
        "5002345678"
      ], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "1|([2-9]\\d{6})$", "340$1", , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      VN: [, [, , "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", , , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-79]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:5(?:2[238]|59)|89[689]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", , , , "912345678", , , [9]], [
        ,
        ,
        "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
        ,
        ,
        ,
        "1800123456",
        ,
        ,
        [8, 9, 10]
      ], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "672\\d{6}", , , , "672012345", , , [9]], "VN", 84, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", , 1], [
        ,
        "(\\d{2})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["2[48]"],
        "0$1",
        ,
        1
      ], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , , , , [7, 8]], [
        ,
        ,
        "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
        ,
        ,
        ,
        "1992000",
        ,
        ,
        [7, 8]
      ], , , [, , , , , , , , , [-1]]],
      VU: [
        ,
        [, , "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", , , , , , , [5, 7]],
        [, , "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", , , , "22123", , , [5]],
        [, , "(?:[58]\\d|7[013-7])\\d{5}", , , , "5912345", , , [7]],
        [, , "81[18]\\d\\d", , , , "81123", , , [5]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , "9(?:0[1-9]|1[01])\\d{4}", , , , "9010123", , , [7]],
        "VU",
        678,
        "00",
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , "(?:3[03]|900\\d)\\d{3}", , , , "30123"],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      WF: [, [, , "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", , , , , , , [6, 9]], [, , "72\\d{4}", , , , "721234", , , [6]], [, , "(?:72|8[23])\\d{4}", , , , "821234", , , [6]], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234", , , [6]]],
      WS: [, [
        ,
        ,
        "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
        ,
        ,
        ,
        ,
        ,
        ,
        [5, 6, 7, 10]
      ], [, , "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", , , , "22123", , , [5, 6]], [, , "(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", , , , "7212345", , , [7, 10]], [, , "800\\d{3}", , , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(\\d{5})", "$1", ["[2-5]|6[1-9]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      XK: [, [, , "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", , , , , , , [
        8,
        9
      ]], [, , "(?:2[89]|39)0\\d{6}|[23][89]\\d{6}", , , , "28012345"], [, , "4[3-9]\\d{6}", , , , "43201234", , , [8]], [, , "800\\d{5}", , , , "80001234", , , [8]], [, , "900\\d{5}", , , , "90001234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "XK", 383, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      YE: [, [
        ,
        ,
        "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [7, 8, 9],
        [6]
      ], [, , "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", , , , "1234567", , , [7, 8], [6]], [, , "7[0137]\\d{7}", , , , "712345678", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YE", 967, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      YT: [, [
        ,
        ,
        "80\\d{7}|(?:26|63)9\\d{6}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9]
      ], [, , "269(?:0[0-367]|5[0-3]|6\\d|[78]0)\\d{4}", , , , "269601234"], [, , "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YT", 262, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , "269|63", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      ZA: [, [, , "[1-79]\\d{8}|8\\d{4,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [
        ,
        ,
        "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}",
        ,
        ,
        ,
        "101234567",
        ,
        ,
        [9]
      ], [, , "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", , , , "711234567", , , [5, 6, 7, 8, 9]], [, , "80\\d{7}", , , , "801234567", , , [9]], [, , "(?:86[2-9]|9[0-2]\\d)\\d{6}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [
        ,
        ,
        "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}",
        ,
        ,
        ,
        "871234567",
        ,
        ,
        [9]
      ], "ZA", 27, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6,7}", , , , "861123456", , , [9, 10]], , , [, , , , , , , , , [-1]]],
      ZM: [, [, , "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", , , , , , , [9], [6]], [
        ,
        ,
        "21[1-8]\\d{6}",
        ,
        ,
        ,
        "211234567",
        ,
        ,
        ,
        [6]
      ], [, , "(?:7[679]|9[5-8])\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "63\\d{7}", , , , "630123456"], "ZM", 260, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ]],
      ZW: [, [, , "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [
        ,
        ,
        "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
        ,
        ,
        ,
        "1312345",
        ,
        ,
        ,
        [3, 4]
      ], [, , "7(?:[178]\\d|3[1-9])\\d{6}", , , , "712345678", , , [9]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [
        [, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"],
        [, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
        [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
        [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"],
        [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
        [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"],
        [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
        [
          ,
          "(\\d{2})(\\d{3,5})",
          "$1 $2",
          ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
          "0$1"
        ],
        [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"],
        [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]
      ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      800: [, [, , "(?:005|[1-9]\\d\\d)\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:005|[1-9]\\d\\d)\\d{5}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 800, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], , , [, , , , , , , , , [-1]]],
      808: [, [, , "[1-9]\\d{7}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1-9]\\d{7}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      870: [, [, , "7\\d{11}|[35-7]\\d{8}", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      878: [, [, , "10\\d{10}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      881: [
        ,
        [, , "[0-36-9]\\d{8}", , , , , , , [9]],
        [, , , , , , , , , [-1]],
        [, , "[0-36-9]\\d{8}", , , , "612345678"],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        "001",
        881,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]],
        ,
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]],
        [, , , , , , , , , [-1]],
        ,
        ,
        [, , , , , , , , , [-1]]
      ],
      882: [, [, , "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , "342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}", , , , "3421234", , , [7, 8, 9, 10, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        [-1]
      ], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["4"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[19]"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], [
        ,
        "(\\d{3})(\\d{4})(\\d{4})",
        "$1 $2 $3",
        ["34"]
      ], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-3]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]],
      883: [, [, , "(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?", , , , , , , [9, 10, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}", , , , "510012345"], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [
        ,
        "(\\d{3})(\\d{3})(\\d{4})",
        "$1 $2 $3",
        ["2"]
      ], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[35]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
      888: [, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]],
      979: [, [
        ,
        ,
        "[1359]\\d{8}",
        ,
        ,
        ,
        ,
        ,
        ,
        [9],
        [8]
      ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1359]\\d{8}", , , , "123456789", , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]
    };
    function H() {
      this.g = {};
    }
    H.g = void 0;
    H.h = function() {
      return H.g ? H.g : H.g = new H();
    };
    var wa = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "\uFF10": "0", "\uFF11": "1", "\uFF12": "2", "\uFF13": "3", "\uFF14": "4", "\uFF15": "5", "\uFF16": "6", "\uFF17": "7", "\uFF18": "8", "\uFF19": "9", "\u0660": "0", "\u0661": "1", "\u0662": "2", "\u0663": "3", "\u0664": "4", "\u0665": "5", "\u0666": "6", "\u0667": "7", "\u0668": "8", "\u0669": "9", "\u06F0": "0", "\u06F1": "1", "\u06F2": "2", "\u06F3": "3", "\u06F4": "4", "\u06F5": "5", "\u06F6": "6", "\u06F7": "7", "\u06F8": "8", "\u06F9": "9" }, xa = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      "+": "+",
      "*": "*",
      "#": "#"
    }, ya = {
      0: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      "\uFF10": "0",
      "\uFF11": "1",
      "\uFF12": "2",
      "\uFF13": "3",
      "\uFF14": "4",
      "\uFF15": "5",
      "\uFF16": "6",
      "\uFF17": "7",
      "\uFF18": "8",
      "\uFF19": "9",
      "\u0660": "0",
      "\u0661": "1",
      "\u0662": "2",
      "\u0663": "3",
      "\u0664": "4",
      "\u0665": "5",
      "\u0666": "6",
      "\u0667": "7",
      "\u0668": "8",
      "\u0669": "9",
      "\u06F0": "0",
      "\u06F1": "1",
      "\u06F2": "2",
      "\u06F3": "3",
      "\u06F4": "4",
      "\u06F5": "5",
      "\u06F6": "6",
      "\u06F7": "7",
      "\u06F8": "8",
      "\u06F9": "9",
      A: "2",
      B: "2",
      C: "2",
      D: "3",
      E: "3",
      F: "3",
      G: "4",
      H: "4",
      I: "4",
      J: "5",
      K: "5",
      L: "5",
      M: "6",
      N: "6",
      O: "6",
      P: "7",
      Q: "7",
      R: "7",
      S: "7",
      T: "8",
      U: "8",
      V: "8",
      W: "9",
      X: "9",
      Y: "9",
      Z: "9"
    }, za = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/, Aa = RegExp("[+\uFF0B]+"), I = RegExp("^[+\uFF0B]+"), Ba = RegExp("([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9])"), Ca = RegExp("[+\uFF0B0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]"), Da = /[\\\/] *x/, Ea = RegExp("[^0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9A-Za-z#]+$"), Fa = /(?:.*?[A-Za-z]){3}.*/;
    function J(a) {
      return "([0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]{1," + a + "})";
    }
    function Ga() {
      return ";ext=" + J("20") + "|[ \xA0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)[:\\.\uFF0E]?[ \xA0\\t,-]*" + (J("20") + "#?|[ \xA0\\t,]*(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)[:\\.\uFF0E]?[ \xA0\\t,-]*") + (J("9") + "#?|[- ]+") + (J("6") + "#|[ \xA0\\t]*(?:,{2}|;)[:\\.\uFF0E]?[ \xA0\\t,-]*") + (J("15") + "#?|[ \xA0\\t]*(?:,)+[:\\.\uFF0E]?[ \xA0\\t,-]*") + (J("9") + "#?");
    }
    var Ha = new RegExp("(?:" + Ga() + ")$", "i"), Ia = new RegExp("^[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]{2}$|^[+\uFF0B]*(?:[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E*]*[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]){3,}[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E*A-Za-z0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]*(?:" + Ga() + ")?$", "i"), Ja = /(\$\d)/, Ka = /^\(?\$1\)?$/;
    function La(a) {
      return 2 > a.length ? false : K(Ia, a);
    }
    function Ma(a) {
      return K(Fa, a) ? L(a, ya) : L(a, wa);
    }
    function Na(a) {
      var b = Ma(a.toString());
      A(a);
      a.g(b);
    }
    function Oa() {
      return Object.keys(G).filter(function(a) {
        return isNaN(a);
      });
    }
    function Pa() {
      return Object.keys(G).filter(function(a) {
        return !isNaN(a);
      }).map(function(a) {
        return parseInt(a, 10);
      });
    }
    function Qa() {
      var a = Object.keys(F);
      return [...Pa(), ...a.map(function(b) {
        return parseInt(b, 10);
      })];
    }
    function Ra(a) {
      return null != a && (1 != v(a, 9) || -1 != r(a, 9)[0]);
    }
    function L(a, b) {
      for (var c = new z(), d2, e = a.length, f = 0; f < e; ++f)
        d2 = a.charAt(f), d2 = b[d2.toUpperCase()], null != d2 && c.g(d2);
      return c.toString();
    }
    function Sa(a) {
      return 0 == a.length || Ka.test(a);
    }
    function M(a) {
      return null != a && isNaN(a) && a.toUpperCase() in G;
    }
    function N(a, b, c) {
      if (0 == n2(b, 2) && m(b, 5)) {
        var d2 = u(b, 5);
        if (0 < d2.length)
          return d2;
      }
      d2 = u(b, 1);
      var e = O(b);
      if (0 == c)
        return Ta(d2, 0, e, "");
      if (!(d2 in F))
        return e;
      a = P(a, d2, R(d2));
      b = Ua(b, a, c);
      e = Va(e, a, c);
      return Ta(d2, c, e, b);
    }
    function P(a, b, c) {
      return "001" == c ? S(a, "" + b) : S(a, c);
    }
    function Wa(a, b) {
      var c = T;
      if (!M(b))
        return N(c, a, 1);
      var d2 = u(a, 1), e = O(a);
      if (!(d2 in F))
        return e;
      if (1 == d2) {
        if (null != b && F[1].includes(b.toUpperCase()))
          return d2 + " " + N(c, a, 2);
      } else if (d2 == Xa(c, b))
        return N(c, a, 2);
      var f = S(c, b), g = u(f, 11);
      b = "";
      m(f, 17) ? b = u(f, 17) : K(za, g) && (b = g);
      c = P(c, d2, R(d2));
      e = Va(e, c, 1);
      a = Ua(a, c, 1);
      return 0 < b.length ? b + " " + d2 + " " + e + a : Ta(d2, 1, e, a);
    }
    function O(a) {
      if (!m(a, 2))
        return "";
      var b = "" + n2(a, 2);
      return m(a, 4) && n2(a, 4) && 0 < u(a, 8) ? Array(u(a, 8) + 1).join("0") + b : b;
    }
    function Ta(a, b, c, d2) {
      switch (b) {
        case 0:
          return "+" + a + c + d2;
        case 1:
          return "+" + a + " " + c + d2;
        case 3:
          return "tel:+" + a + "-" + c + d2;
        default:
          return c + d2;
      }
    }
    function Va(a, b, c) {
      a: {
        b = 0 == r(b, 20).length || 2 == c ? r(b, 19) : r(b, 20);
        for (var d2, e = b.length, f = 0; f < e; ++f) {
          d2 = b[f];
          var g = v(d2, 3);
          if (0 == g || 0 == a.search(n2(d2, 3, g - 1))) {
            if (g = new RegExp(n2(d2, 1)), K(g, a)) {
              b = d2;
              break a;
            }
          }
        }
        b = null;
      }
      null == b ? c = a : (e = b, b = u(e, 2), d2 = new RegExp(n2(e, 1)), u(e, 5), e = u(e, 4), a = 2 == c && null != e && 0 < e.length ? a.replace(d2, b.replace(Ja, e)) : a.replace(d2, b), 3 == c && (a = a.replace(RegExp("^[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]+"), ""), a = a.replace(RegExp("[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]+", "g"), "-")), c = a);
      return c;
    }
    function Ya(a, b) {
      var c = T;
      if (!M(a))
        return null;
      b = Za(S(c, a), b);
      try {
        if (m(b, 6)) {
          var d2 = n2(b, 6);
          return $a(c, d2, a);
        }
      } catch (e) {
      }
      return null;
    }
    function Ua(a, b, c) {
      return m(a, 3) && 0 != n2(a, 3).length ? 3 == c ? ";ext=" + n2(a, 3) : m(b, 13) ? n2(b, 13) + u(a, 3) : " ext. " + u(a, 3) : "";
    }
    function Za(a, b) {
      switch (b) {
        case 4:
          return n2(a, 5);
        case 3:
          return n2(a, 4);
        case 1:
          return n2(a, 3);
        case 0:
        case 2:
          return n2(a, 2);
        case 5:
          return n2(a, 6);
        case 6:
          return n2(a, 8);
        case 7:
          return n2(a, 7);
        case 8:
          return n2(a, 21);
        case 9:
          return n2(a, 25);
        case 10:
          return n2(a, 28);
        default:
          return n2(a, 1);
      }
    }
    function ab(a, b) {
      return U(a, n2(b, 1)) ? U(a, n2(b, 5)) ? 4 : U(a, n2(b, 4)) ? 3 : U(a, n2(b, 6)) ? 5 : U(a, n2(b, 8)) ? 6 : U(a, n2(b, 7)) ? 7 : U(a, n2(b, 21)) ? 8 : U(a, n2(b, 25)) ? 9 : U(a, n2(b, 28)) ? 10 : U(a, n2(b, 2)) ? n2(b, 18) || U(a, n2(b, 3)) ? 2 : 0 : !n2(b, 18) && U(a, n2(b, 3)) ? 1 : -1 : -1;
    }
    function S(a, b) {
      if (null == b)
        return null;
      b = b.toUpperCase();
      var c = a.g[b];
      if (null == c) {
        c = G[b];
        if (null == c)
          return null;
        c = new y().g(D.m(), c);
        a.g[b] = c;
      }
      return c;
    }
    function U(a, b) {
      var c = a.length;
      return 0 < v(b, 9) && -1 == r(b, 9).indexOf(c) ? false : K(u(b, 2), a);
    }
    function bb(a) {
      var b = T, c = cb(b, a);
      var d2 = u(a, 1);
      var e = P(b, d2, c);
      null == e || "001" != c && d2 != Xa(b, c) ? e = false : (a = O(a), e = -1 != ab(a, e));
      return e;
    }
    function cb(a, b) {
      if (null == b)
        return null;
      var c = u(b, 1);
      c = F[c];
      if (null == c)
        a = null;
      else if (1 == c.length)
        a = c[0];
      else
        a: {
          b = O(b);
          for (var d2, e = c.length, f = 0; f < e; f++) {
            d2 = c[f];
            var g = S(a, d2);
            if (m(g, 23)) {
              if (0 == b.search(n2(g, 23))) {
                a = d2;
                break a;
              }
            } else if (-1 != ab(b, g)) {
              a = d2;
              break a;
            }
          }
          a = null;
        }
      return a;
    }
    function R(a) {
      a = F[a];
      return null == a ? "ZZ" : a[0];
    }
    function Xa(a, b) {
      a = S(a, b);
      if (null == a)
        throw Error("Invalid region code: " + b);
      return u(a, 10);
    }
    function db(a) {
      a = eb(a);
      return 0 == a || 4 == a;
    }
    function fb(a, b, c, d2) {
      var e = Za(c, d2), f = 0 == v(e, 9) ? r(n2(c, 1), 9) : r(e, 9);
      e = r(e, 10);
      if (2 == d2)
        if (Ra(Za(c, 0)))
          a = Za(c, 1), Ra(a) && (f = f.concat(0 == v(a, 9) ? r(n2(c, 1), 9) : r(a, 9)), f.sort(), 0 == e.length ? e = r(a, 10) : (e = e.concat(r(a, 10)), e.sort()));
        else
          return fb(a, b, c, 1);
      if (-1 == f[0])
        return 5;
      b = b.length;
      if (-1 < e.indexOf(b))
        return 4;
      c = f[0];
      return c == b ? 0 : c > b ? 2 : f[f.length - 1] < b ? 3 : -1 < f.indexOf(b, 1) ? 0 : 5;
    }
    function eb(a) {
      var b = T, c = O(a);
      a = u(a, 1);
      if (!(a in F))
        return 1;
      a = P(b, a, R(a));
      return fb(b, c, a, -1);
    }
    function gb(a, b) {
      a = a.toString();
      if (0 == a.length || "0" == a.charAt(0))
        return 0;
      for (var c, d2 = a.length, e = 1; 3 >= e && e <= d2; ++e)
        if (c = parseInt(a.substring(0, e), 10), c in F)
          return b.g(a.substring(e)), c;
      return 0;
    }
    function hb(a, b, c, d2, e) {
      if (0 == b.length)
        return 0;
      b = new z(b);
      var f;
      null != c && (f = n2(c, 11));
      null == f && (f = "NonMatch");
      var g = b.toString();
      if (0 == g.length)
        f = 20;
      else if (I.test(g))
        g = g.replace(I, ""), A(b), b.g(Ma(g)), f = 1;
      else {
        g = new RegExp(f);
        Na(b);
        f = b.toString();
        if (0 == f.search(g)) {
          g = f.match(g)[0].length;
          var l = f.substring(g).match(Ba);
          l && null != l[1] && 0 < l[1].length && "0" == L(l[1], wa) ? f = false : (A(b), b.g(f.substring(g)), f = true);
        } else
          f = false;
        f = f ? 5 : 20;
      }
      if (20 != f) {
        if (2 >= b.h.length)
          throw Error("Phone number too short after IDD");
        a = gb(
          b,
          d2
        );
        if (0 != a)
          return p(e, 1, a), a;
        throw Error("Invalid country calling code");
      }
      if (null != c && (f = u(c, 10), g = "" + f, l = b.toString(), 0 == l.lastIndexOf(g, 0) && (g = new z(l.substring(g.length)), l = n2(c, 1), l = new RegExp(u(l, 2)), ib(g, c, null), g = g.toString(), !K(l, b.toString()) && K(l, g) || 3 == fb(a, b.toString(), c, -1))))
        return d2.g(g), p(e, 1, f), f;
      p(e, 1, 0);
      return 0;
    }
    function ib(a, b, c) {
      var d2 = a.toString(), e = d2.length, f = n2(b, 15);
      if (0 != e && null != f && 0 != f.length) {
        var g = new RegExp("^(?:" + f + ")");
        if (e = g.exec(d2)) {
          f = new RegExp(u(n2(b, 1), 2));
          var l = K(f, d2), q = e.length - 1;
          b = n2(b, 16);
          if (null == b || 0 == b.length || null == e[q] || 0 == e[q].length) {
            if (!l || K(f, d2.substring(e[0].length)))
              null != c && 0 < q && null != e[q] && c.g(e[1]), a.set(d2.substring(e[0].length));
          } else if (d2 = d2.replace(g, b), !l || K(f, d2))
            null != c && 0 < q && c.g(e[1]), a.set(d2);
        }
      }
    }
    function $a(a, b, c) {
      if (null == b)
        throw Error("The string supplied did not seem to be a phone number");
      if (250 < b.length)
        throw Error("The string supplied is too long to be a phone number");
      var d2 = new z(), e = b.indexOf(";phone-context=");
      if (0 <= e) {
        var f = e + 15;
        if ("+" == b.charAt(f)) {
          var g = b.indexOf(";", f);
          0 < g ? d2.g(b.substring(f, g)) : d2.g(b.substring(f));
        }
        f = b.indexOf("tel:");
        d2.g(b.substring(0 <= f ? f + 4 : 0, e));
      } else
        e = d2.g, f = b.search(Ca), 0 <= f ? (b = b.substring(f), b = b.replace(Ea, ""), f = b.search(Da), 0 <= f && (b = b.substring(0, f))) : b = "", e.call(d2, b);
      b = d2.toString();
      e = b.indexOf(";isub=");
      0 < e && (A(d2), d2.g(b.substring(0, e)));
      if (!La(d2.toString()))
        throw Error("The string supplied did not seem to be a phone number");
      b = d2.toString();
      if (!(M(c) || null != b && 0 < b.length && I.test(b)))
        throw Error("Invalid country calling code");
      b = new E();
      a: {
        e = d2.toString();
        f = e.search(Ha);
        if (0 <= f && La(e.substring(0, f))) {
          g = e.match(Ha);
          for (var l = g.length, q = 1; q < l; ++q)
            if (null != g[q] && 0 < g[q].length) {
              A(d2);
              d2.g(e.substring(0, f));
              e = g[q];
              break a;
            }
        }
        e = "";
      }
      0 < e.length && p(b, 3, e);
      f = S(a, c);
      e = new z();
      g = 0;
      l = d2.toString();
      try {
        g = hb(a, l, f, e, b);
      } catch (Q) {
        if ("Invalid country calling code" == Q.message && I.test(l)) {
          if (l = l.replace(I, ""), g = hb(a, l, f, e, b), 0 == g)
            throw Q;
        } else
          throw Q;
      }
      0 != g ? (d2 = R(g), d2 != c && (f = P(a, g, d2))) : (Na(d2), e.g(d2.toString()), null != c && (g = u(f, 10), p(b, 1, g)));
      if (2 > e.h.length)
        throw Error("The string supplied is too short to be a phone number");
      null != f && (c = new z(e.toString()), ib(c, f, new z()), a = fb(a, c.toString(), f, -1), 2 != a && 4 != a && 5 != a && (e = c));
      a = e.toString();
      c = a.length;
      if (2 > c)
        throw Error("The string supplied is too short to be a phone number");
      if (17 < c)
        throw Error("The string supplied is too long to be a phone number");
      if (1 < a.length && "0" == a.charAt(0)) {
        p(b, 4, true);
        for (c = 1; c < a.length - 1 && "0" == a.charAt(c); )
          c++;
        1 != c && p(b, 8, c);
      }
      p(b, 2, parseInt(a, 10));
      return b;
    }
    H.prototype.ia = function(a) {
      var b = S(this, cb(this, a));
      if (null == b)
        return true;
      a = O(a);
      return !U(a, n2(b, 24));
    };
    function K(a, b) {
      return (a = "string" == typeof a ? b.match("^(?:" + a + ")$") : b.match(a)) && a[0].length == b.length ? true : false;
    }
    function jb(a) {
      this.ja = RegExp("\u2008");
      this.ka = "";
      this.v = new z();
      this.ca = "";
      this.s = new z();
      this.aa = new z();
      this.u = true;
      this.da = this.ba = this.na = false;
      this.oa = H.h();
      this.$ = 0;
      this.h = new z();
      this.ga = false;
      this.o = "";
      this.g = new z();
      this.j = [];
      this.la = a;
      this.ua = this.l = kb(this, this.la);
    }
    var lb = new D();
    p(lb, 11, "NA");
    var mb = RegExp("^[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*\\$1[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*(\\$\\d[-x\u2010-\u2015\u2212\u30FC\uFF0D-\uFF0F \xA0\xAD\u200B\u2060\u3000()\uFF08\uFF09\uFF3B\uFF3D.\\[\\]/~\u2053\u223C\uFF5E]*)*$"), nb = /[- ]/;
    function kb(a, b) {
      var c = a.oa;
      b = M(b) ? Xa(c, b) : 0;
      a = S(a.oa, R(b));
      return null != a ? a : lb;
    }
    function ob(a) {
      for (var b = a.j.length, c = 0; c < b; ++c) {
        var d2 = a.j[c], e = u(d2, 1);
        if (a.ca == e)
          return false;
        var f = a;
        var g = d2, l = u(g, 1);
        A(f.v);
        var q = f;
        g = u(g, 2);
        var Q = "999999999999999".match(l)[0];
        Q.length < q.g.h.length ? q = "" : (q = Q.replace(new RegExp(l, "g"), g), q = q.replace(RegExp("9", "g"), "\u2008"));
        0 < q.length ? (f.v.g(q), f = true) : f = false;
        if (f)
          return a.ca = e, a.ga = nb.test(n2(d2, 4)), a.$ = 0, true;
      }
      return a.u = false;
    }
    function pb(a, b) {
      for (var c = [], d2 = b.length - 3, e = a.j.length, f = 0; f < e; ++f) {
        var g = a.j[f];
        0 == v(g, 3) ? c.push(a.j[f]) : (g = n2(g, 3, Math.min(d2, v(g, 3) - 1)), 0 == b.search(g) && c.push(a.j[f]));
      }
      a.j = c;
    }
    function qb(a, b) {
      a.s.g(b);
      var c = b;
      Ba.test(c) || 1 == a.s.h.length && Aa.test(c) ? ("+" == b ? (c = b, a.aa.g(b)) : (c = wa[b], a.aa.g(c), a.g.g(c)), b = c) : (a.u = false, a.na = true);
      if (!a.u) {
        if (!a.na) {
          if (rb(a)) {
            if (sb(a))
              return tb(a);
          } else if (0 < a.o.length && (b = a.g.toString(), A(a.g), a.g.g(a.o), a.g.g(b), b = a.h.toString(), c = b.lastIndexOf(a.o), A(a.h), a.h.g(b.substring(0, c))), a.o != ub(a))
            return a.h.g(" "), tb(a);
        }
        return a.s.toString();
      }
      switch (a.aa.h.length) {
        case 0:
        case 1:
        case 2:
          return a.s.toString();
        case 3:
          if (rb(a))
            a.da = true;
          else
            return a.o = ub(a), vb(a);
        default:
          if (a.da)
            return sb(a) && (a.da = false), a.h.toString() + a.g.toString();
          if (0 < a.j.length) {
            b = wb(a, b);
            c = xb(a);
            if (0 < c.length)
              return c;
            pb(a, a.g.toString());
            return ob(a) ? yb(a) : a.u ? zb(a, b) : a.s.toString();
          }
          return vb(a);
      }
    }
    function tb(a) {
      a.u = true;
      a.da = false;
      a.j = [];
      a.$ = 0;
      A(a.v);
      a.ca = "";
      return vb(a);
    }
    function xb(a) {
      for (var b = a.g.toString(), c = a.j.length, d2 = 0; d2 < c; ++d2) {
        var e = a.j[d2], f = u(e, 1);
        if (new RegExp("^(?:" + f + ")$").test(b) && (a.ga = nb.test(n2(e, 4)), e = b.replace(new RegExp(f, "g"), n2(e, 2)), e = zb(a, e), L(e, xa) == a.aa))
          return e;
      }
      return "";
    }
    function zb(a, b) {
      var c = a.h.h.length;
      return a.ga && 0 < c && " " != a.h.toString().charAt(c - 1) ? a.h + " " + b : a.h + b;
    }
    function vb(a) {
      var b = a.g.toString();
      if (3 <= b.length) {
        for (var c = a.ba && 0 == a.o.length && 0 < v(a.l, 20) ? r(a.l, 20) : r(a.l, 19), d2 = c.length, e = 0; e < d2; ++e) {
          var f = c[e];
          0 < a.o.length && Sa(u(f, 4)) && !n2(f, 6) && !m(f, 5) || (0 != a.o.length || a.ba || Sa(u(f, 4)) || n2(f, 6)) && mb.test(u(f, 2)) && a.j.push(f);
        }
        pb(a, b);
        b = xb(a);
        return 0 < b.length ? b : ob(a) ? yb(a) : a.s.toString();
      }
      return zb(a, b);
    }
    function yb(a) {
      var b = a.g.toString(), c = b.length;
      if (0 < c) {
        for (var d2 = "", e = 0; e < c; e++)
          d2 = wb(a, b.charAt(e));
        return a.u ? zb(a, d2) : a.s.toString();
      }
      return a.h.toString();
    }
    function ub(a) {
      var b = a.g.toString(), c = 0;
      if (1 != a.l.ha())
        var d2 = false;
      else
        d2 = a.g.toString(), d2 = "1" == d2.charAt(0) && "0" != d2.charAt(1) && "1" != d2.charAt(1);
      d2 ? (c = 1, a.h.g("1").g(" "), a.ba = true) : m(a.l, 15) && (d2 = new RegExp("^(?:" + n2(a.l, 15) + ")"), d2 = b.match(d2), null != d2 && null != d2[0] && 0 < d2[0].length && (a.ba = true, c = d2[0].length, a.h.g(b.substring(0, c))));
      A(a.g);
      a.g.g(b.substring(c));
      return b.substring(0, c);
    }
    function rb(a) {
      var b = a.aa.toString(), c = new RegExp("^(?:\\+|" + n2(a.l, 11) + ")");
      c = b.match(c);
      return null != c && null != c[0] && 0 < c[0].length ? (a.ba = true, c = c[0].length, A(a.g), a.g.g(b.substring(c)), A(a.h), a.h.g(b.substring(0, c)), "+" != b.charAt(0) && a.h.g(" "), true) : false;
    }
    function sb(a) {
      if (0 == a.g.h.length)
        return false;
      var b = new z(), c = gb(a.g, b);
      if (0 == c)
        return false;
      A(a.g);
      a.g.g(b.toString());
      b = R(c);
      "001" == b ? a.l = S(a.oa, "" + c) : b != a.la && (a.l = kb(a, b));
      a.h.g("" + c).g(" ");
      a.o = "";
      return true;
    }
    function wb(a, b) {
      var c = a.v.toString();
      if (0 <= c.substring(a.$).search(a.ja)) {
        var d2 = c.search(a.ja);
        b = c.replace(a.ja, b);
        A(a.v);
        a.v.g(b);
        a.$ = d2;
        return b.substring(0, a.$ + 1);
      }
      1 == a.j.length && (a.u = false);
      a.ca = "";
      return a.s.toString();
    }
    var T = H.h();
    function Ab(a) {
      var b = T, c = cb(b, a);
      b = P(b, u(a, 1), c);
      null == b ? a = -1 : (a = O(a), a = ab(a, b));
      switch (a) {
        case 0:
          return "fixed-line";
        case 2:
          return "fixed-line-or-mobile";
        case 1:
          return "mobile";
        case 8:
          return "pager";
        case 7:
          return "personal-number";
        case 4:
          return "premium-rate";
        case 5:
          return "shared-cost";
        case 3:
          return "toll-free";
        case 9:
          return "uan";
        case 6:
          return "voip";
        default:
        case -1:
          return "unknown";
      }
    }
    function Bb(a) {
      switch (a) {
        case "fixed-line":
          return 0;
        case "fixed-line-or-mobile":
          return 2;
        case "mobile":
          return 1;
        case "pager":
          return 8;
        case "personal-number":
          return 7;
        case "premium-rate":
          return 4;
        case "shared-cost":
          return 5;
        case "toll-free":
          return 3;
        case "uan":
          return 9;
        case "voip":
          return 6;
        default:
        case "unknown":
          return -1;
      }
    }
    function Cb(a) {
      try {
        switch (eb(a)) {
          case 0:
            return "is-possible";
          case 1:
            return "invalid-country-code";
          case 3:
            return "too-long";
          case 2:
            return "too-short";
        }
        if (db(a))
          return "is-possible";
      } catch (b) {
      }
      return "unknown";
    }
    function Db(a, b) {
      if ("+" !== a.charAt(0) && "00" !== a.slice(0, 2))
        return { parsed: c, ea: d2 };
      try {
        var c = $a(T, a, b);
      } catch (e) {
      }
      if (c) {
        var d2 = cb(T, c);
        if (null != d2 && "ZZ" !== d2)
          return { parsed: c, ea: d2 };
      }
      for (b = 1; 4 > b; ++b) {
        d2 = void 0;
        if (a.length < b + 1)
          return { parsed: c, ea: d2 };
        d2 = R(a.substring(1, b + 1));
        if ("ZZ" !== d2)
          return { ea: d2 };
      }
      return { parsed: c, ea: void 0 };
    }
    function V(a, b) {
      if (!(this instanceof V))
        return new V(a, b);
      if ("string" === typeof a)
        var c = false;
      else
        try {
          bb(a), c = true;
        } catch (e) {
          c = false;
        }
      let d2;
      if (!c && "string" !== typeof a)
        throw Error("Invalid phone number, expected a string");
      if (!c && null != b && "string" !== typeof b)
        throw Error("Invalid region code, expected a string");
      c || (a = a.trim(), b && "+" === a.charAt(0) && (b = null), b && "+" !== a.charAt(0) && "00" !== a.slice(0, 2) || ({ ea: b = null, parsed: d2 } = Db(a, b)));
      this.g = { number: {}, regionCode: b, valid: false, possible: false };
      if (c)
        this.h = a;
      else {
        this.h = null;
        this.g.number.input = a;
        if (!b) {
          this.g.possibility = "invalid-country-code";
          return;
        }
        if (0 === Eb(b)) {
          this.g.possibility = "invalid-country-code";
          return;
        }
        try {
          this.h = d2 ? d2 : $a(T, a, b);
        } catch (e) {
          this.g.possibility = Cb(a);
          return;
        }
      }
      this.g.number.international = N(T, this.h, 1);
      this.g.number.national = N(T, this.h, 2);
      this.g.number.e164 = N(T, this.h, 0);
      this.g.number.rfc3966 = N(T, this.h, 3);
      this.g.number.significant = O(this.h);
      this.g.canBeInternationallyDialled = T.ia(this.h);
      this.g.possible = db(this.h);
      this.g.valid = bb(this.h);
      this.g.type = Ab(this.h);
      this.g.possibility = Cb(this.h);
    }
    var W = ["PhoneNumber$$module$src$index"], X = aa;
    W[0] in X || "undefined" == typeof X.execScript || X.execScript("var " + W[0]);
    for (var Y; W.length && (Y = W.shift()); )
      W.length || void 0 === V ? X[Y] && X[Y] !== Object.prototype[Y] ? X = X[Y] : X = X[Y] = {} : X[Y] = V;
    function Eb(a) {
      return M(a) ? Xa(T, a) : 0;
    }
    V.getCountryCodeForRegionCode = Eb;
    V.getRegionCodeForCountryCode = function(a) {
      return R(a);
    };
    function Fb(a) {
      var b = {};
      return a.filter((c) => {
        if (b.hasOwnProperty(c))
          return false;
        b[c] = 1;
        return true;
      });
    }
    V.getSupportedRegionCodes = function() {
      return Fb(Oa());
    };
    V.getSupportedCallingCodes = function() {
      return Fb(Qa());
    };
    V.getExample = function(a, b) {
      var c;
      b ? c = Ya(a, Bb(b)) : c = Ya(a, 0);
      return new V(c, a);
    };
    V.getAsYouType = function(a) {
      return new Z(a);
    };
    V.prototype.toJSON = function() {
      return this.g;
    };
    V.prototype.toJSON = V.prototype.toJSON;
    V.prototype.ia = function() {
      return this.g.canBeInternationallyDialled;
    };
    V.prototype.canBeInternationallyDialled = V.prototype.ia;
    V.prototype.ya = function() {
      return this.g.valid;
    };
    V.prototype.isValid = V.prototype.ya;
    V.prototype.xa = function() {
      return this.g.possible;
    };
    V.prototype.isPossible = V.prototype.xa;
    V.prototype.getType = function() {
      return this.g.type;
    };
    V.prototype.getType = V.prototype.getType;
    V.prototype.wa = function() {
      return "mobile" === this.g.type || "fixed-line-or-mobile" === this.g.type;
    };
    V.prototype.isMobile = V.prototype.wa;
    V.prototype.va = function() {
      return "fixed-line" === this.g.type || "fixed-line-or-mobile" === this.g.type;
    };
    V.prototype.isFixedLine = V.prototype.va;
    V.prototype.qa = function(a) {
      return this.g.number[null == a ? "e164" : a];
    };
    V.prototype.getNumber = V.prototype.qa;
    V.prototype.ra = function(a) {
      return Wa(this.h, a);
    };
    V.prototype.getNumberFrom = V.prototype.ra;
    V.prototype.ta = function() {
      return this.g.regionCode;
    };
    V.prototype.getRegionCode = V.prototype.ta;
    V.prototype.ha = function() {
      return Eb(this.g.regionCode);
    };
    V.prototype.getCountryCode = V.prototype.ha;
    function Z(a) {
      this.l = a;
      this.j = new jb(a);
      this.g = this.h = "";
    }
    Z.prototype.pa = function(a) {
      this.h += a;
      var b = this.j;
      b.ka = qb(b, a);
      return this.g = b.ka;
    };
    Z.prototype.addChar = Z.prototype.pa;
    Z.prototype.za = function() {
      return this.g;
    };
    Z.prototype.number = Z.prototype.za;
    Z.prototype.Aa = function() {
      return "" === this.h ? this.g : this.reset(this.h.slice(0, this.h.length - 1));
    };
    Z.prototype.removeChar = Z.prototype.Aa;
    Z.prototype.reset = function(a) {
      var b = this.j;
      b.ka = "";
      A(b.s);
      A(b.aa);
      A(b.v);
      b.$ = 0;
      b.ca = "";
      A(b.h);
      b.o = "";
      A(b.g);
      b.u = true;
      b.na = false;
      b.ba = false;
      b.da = false;
      b.j = [];
      b.ga = false;
      b.l != b.ua && (b.l = kb(b, b.la));
      this.g = this.h = "";
      if (a) {
        b = 0;
        for (var c = a.length; b < c; ++b)
          this.pa(a.charAt(b));
      }
      return this.g;
    };
    Z.prototype.reset = Z.prototype.reset;
    Z.prototype.sa = function() {
      return new V(this.g, this.l);
    };
    Z.prototype.getPhoneNumber = Z.prototype.sa;
  }).call(
    module.exports || typeof globalThis !== "undefined" && globalThis || typeof commonjsGlobal !== "undefined" && commonjsGlobal || typeof window !== "undefined" && window || typeof self !== "undefined" && self || commonjsGlobal
  );
})(lib);
(function(module) {
  const exportedName = "PhoneNumber$$module$src$index";
  module.exports = lib.exports[exportedName] || (typeof globalThis !== "undefined" && globalThis || typeof commonjsGlobal !== "undefined" && commonjsGlobal || typeof window !== "undefined" && window || typeof self !== "undefined" && self || commonjsGlobal)[exportedName];
  Object.defineProperty(
    module.exports,
    "__esModule",
    {
      value: true
    }
  );
  module.exports.default = module.exports;
  module.exports.parsePhoneNumber = module.exports;
  module.exports.getCountryCodeForRegionCode = module.exports.getCountryCodeForRegionCode;
  module.exports.getRegionCodeForCountryCode = module.exports.getRegionCodeForCountryCode;
  module.exports.getSupportedCallingCodes = module.exports.getSupportedCallingCodes;
  module.exports.getSupportedRegionCodes = module.exports.getSupportedRegionCodes;
  module.exports.getExample = module.exports.getExample;
  module.exports.getAsYouType = module.exports.getAsYouType;
})(awesomePhonenumber);
var index = /* @__PURE__ */ getDefaultExportFromCjs(awesomePhonenumber.exports);
var utc$1 = { exports: {} };
(function(module, exports) {
  !function(t3, i2) {
    module.exports = i2();
  }(commonjsGlobal$1, function() {
    var t3 = "minute", i2 = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n2) {
      var u = f.prototype;
      n2.utc = function(t4) {
        var i3 = { date: t4, utc: true, args: arguments };
        return new f(i3);
      }, u.utc = function(i3) {
        var e2 = n2(this.toDate(), { locale: this.$L, utc: true });
        return i3 ? e2.add(this.utcOffset(), t3) : e2;
      }, u.local = function() {
        return n2(this.toDate(), { locale: this.$L, utc: false });
      };
      var o = u.parse;
      u.parse = function(t4) {
        t4.utc && (this.$u = true), this.$utils().u(t4.$offset) || (this.$offset = t4.$offset), o.call(this, t4);
      };
      var r = u.init;
      u.init = function() {
        if (this.$u) {
          var t4 = this.$d;
          this.$y = t4.getUTCFullYear(), this.$M = t4.getUTCMonth(), this.$D = t4.getUTCDate(), this.$W = t4.getUTCDay(), this.$H = t4.getUTCHours(), this.$m = t4.getUTCMinutes(), this.$s = t4.getUTCSeconds(), this.$ms = t4.getUTCMilliseconds();
        } else
          r.call(this);
      };
      var a = u.utcOffset;
      u.utcOffset = function(s2, f2) {
        var n3 = this.$utils().u;
        if (n3(s2))
          return this.$u ? 0 : n3(this.$offset) ? a.call(this) : this.$offset;
        if ("string" == typeof s2 && (s2 = function(t4) {
          void 0 === t4 && (t4 = "");
          var s3 = t4.match(i2);
          if (!s3)
            return null;
          var f3 = ("" + s3[0]).match(e) || ["-", 0, 0], n4 = f3[0], u3 = 60 * +f3[1] + +f3[2];
          return 0 === u3 ? 0 : "+" === n4 ? u3 : -u3;
        }(s2), null === s2))
          return this;
        var u2 = Math.abs(s2) <= 16 ? 60 * s2 : s2, o2 = this;
        if (f2)
          return o2.$offset = u2, o2.$u = 0 === s2, o2;
        if (0 !== s2) {
          var r2 = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (o2 = this.local().add(u2 + r2, t3)).$offset = u2, o2.$x.$localOffset = r2;
        } else
          o2 = this.utc();
        return o2;
      };
      var h = u.format;
      u.format = function(t4) {
        var i3 = t4 || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return h.call(this, i3);
      }, u.valueOf = function() {
        var t4 = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * t4;
      }, u.isUTC = function() {
        return !!this.$u;
      }, u.toISOString = function() {
        return this.toDate().toISOString();
      }, u.toString = function() {
        return this.toDate().toUTCString();
      };
      var l = u.toDate;
      u.toDate = function(t4) {
        return "s" === t4 && this.$offset ? n2(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
      };
      var c = u.diff;
      u.diff = function(t4, i3, e2) {
        if (t4 && this.$u === t4.$u)
          return c.call(this, t4, i3, e2);
        var s2 = this.local(), f2 = n2(t4).local();
        return c.call(s2, f2, i3, e2);
      };
    };
  });
})(utc$1);
var utc = utc$1.exports;
dayjs.extend(utc);
function dayjsUTC(value) {
  return dayjs(value).utc();
}
const Formatter = class {
  constructor(i18n2) {
    this.i18n = i18n2;
  }
  install(Vue2) {
    Vue2.prototype.Formatter = this;
  }
  useFormatNumber(value, digit = 0) {
    if (value !== null && value !== 0 && value !== void 0) {
      const isInteger = Number.isInteger(value);
      return Intl.NumberFormat(this.i18n.locale, {
        minimumFractionDigits: isInteger ? 0 : digit
      }).format(value);
    }
    return 0;
  }
  useFormatPrice(value, digit = 0) {
    const isInteger = Number.isInteger(value);
    return new Intl.NumberFormat(this.i18n.locale, {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: isInteger ? 0 : digit
    }).format(value);
  }
  useFormatPhone(number, type = "international") {
    if (number === null || number === "" || number === void 0) {
      return null;
    }
    const pn = new index(number);
    return pn.getNumber(type);
  }
  useFormatDate(date, useLocalTime = false) {
    const format = this.i18n.locale === "fr" ? "DD/MM/YYYY" : "YYYY-MM-DD";
    return useLocalTime ? dayjsUTC(date).local().format(format) : dayjsUTC(date).format(format);
  }
  useFormatDateTime(date, useLocalTime = false) {
    const format = this.i18n.locale === "fr" ? "DD/MM/YYYY HH:mm" : "YYYY-MM-DD HH:mm";
    return useLocalTime ? dayjsUTC(date).local().format(format) : dayjsUTC(date).format(format);
  }
};
var render$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HRow", { attrs: { "align-items": "center", "gap": "16" } }, [_vm.mandateIssuesCount > 0 ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("model.issue", _vm.mandateIssuesCount, { number: _vm.mandateIssuesCount })) + " ")];
  }, proxy: true }], null, false, 588731662) }) : _vm._e(), _vm.isExpired ? _c("HTag", { attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$t("mandate.isExpired")) + " ! ")];
  }, proxy: true }], null, false, 607531710) }) : _vm._e(), _vm.isGraceExpires ? _c("HTag", { attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$t("mandate.grace.outdated")) + " ! ")];
  }, proxy: true }], null, false, 1555551857) }) : _vm._e(), !_vm.hasAlert ? _c("p", [_vm._v(" " + _vm._s(_vm.$t("main.noAlerts")) + " ")]) : _vm._e()], 1);
};
var staticRenderFns$c = [];
var AMandateAlerts_vue_vue_type_style_index_0_scoped_true_lang = "";
dayjs.extend(isSameOrBefore);
const script$c = {
  name: "AMandateAlerts",
  props: {
    mandate: {
      type: Object,
      default: () => {
      },
      required: true
    },
    mandateIssuesCount: {
      type: Number,
      default: 0,
      required: false
    }
  },
  computed: {
    isExpired() {
      return this.mandate && this.mandate.expired;
    },
    isGraceExpires() {
      return this.mandate.grace && this.mandate.grace.active && dayjsUTC(this.mandate.grace.expires).isSameOrBefore(new Date());
    },
    hasAlert() {
      return this.isExpired || this.isGraceExpires || this.mandateIssuesCount !== 0;
    }
  }
};
const __cssModules$c = {};
var __component__$c = /* @__PURE__ */ normalizeComponent(
  script$c,
  render$c,
  staticRenderFns$c,
  false,
  injectStyles$c,
  "4175f2c0",
  null,
  null
);
function injectStyles$c(context) {
  for (let o in __cssModules$c) {
    this[o] = __cssModules$c[o];
  }
}
var AMandateAlerts = /* @__PURE__ */ function() {
  return __component__$c.exports;
}();
var render$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-mandate-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HCol", { attrs: { "gap": "16" } }, [_c("HCol", { attrs: { "gap": "4" } }, [_vm.mandate.type ? _c("h4", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.mandate.type.name))]) : _vm._e(), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v("Ref: " + _vm._s(_vm.mandate.reference || _vm.mandate.id))])]), _vm.client ? _c("AClientName", { attrs: { "client": _vm.client, "bold": "" } }) : _vm._e(), _vm.mandate.address ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", [_vm._v(_vm._s(_vm.mandate.address.line1))]), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.mandate.address.postcode) + " " + _vm._s(_vm.mandate.address.town))])]) : _vm._e(), _vm.ownerName ? _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("ada.followed_by")) + " " + _vm._s(_vm.ownerName))]) : _vm._e(), _vm.mandate.type ? _c("HCol", { staticClass: "text-bold", attrs: { "gap": "4" } }, [_vm.mandate.type && _vm.mandate.price && _vm.mandate.type.for === "property" ? [_c("span", [_vm._v(" " + _vm._s(_vm.Formatter.useFormatPrice(_vm.mandate.price.current.value + _vm.mandate.fees.current.value)) + " HAI ")]), _c("span", { class: _vm.mandate.fees.current.exact ? "" : "text-red" }, [_vm._v(" " + _vm._s(_vm.Formatter.useFormatPrice(_vm.mandate.fees.current.value)) + " " + _vm._s(_vm.$t("commissions.fees")) + " ")])] : _vm._e(), _vm.mandate.type && _vm.mandate.price && _vm.mandate.type.for === "client" ? _c("span", [_vm._v(" " + _vm._s(_vm.Formatter.useFormatPrice(_vm.mandate.price.current.min)) + " - " + _vm._s(_vm.Formatter.useFormatPrice(_vm.mandate.price.current.max)) + " ")]) : _vm._e()], 2) : _vm._e()], 1)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_c("HRow", { staticClass: "a-mandate-card__footer", attrs: { "justify-content": "space-between", "gap": "16" } }, [_c("HRow", { attrs: { "gap": "16" } }, [_vm.mandate.type && _vm.mandate.type.exclusive ? _c("HTag", { attrs: { "label": _vm.$t("property.exclusive"), "color": "red" } }) : _vm._e(), _c("AMandateAlerts", { attrs: { "mandate": _vm.mandate, "mandate-issues-count": _vm.mandateIssuesCount } })], 1), _vm.mandate.status ? _c("AMandateStatusLabel", { attrs: { "status": _vm.mandate.status } }) : _vm._e()], 1)];
  }, proxy: true }]) });
};
var staticRenderFns$b = [];
var AMandateCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$b = {
  name: "AMandateCard",
  components: {
    AClientName,
    AMandateStatusLabel,
    AMandateAlerts
  },
  props: {
    mandate: {
      type: Object,
      required: true
    },
    client: {
      type: Object,
      required: false,
      validator(obj) {
        return (obj.title === "MR" || obj.title === "MS") && obj.firstName && obj.lastName;
      },
      default: () => {
      }
    },
    ownerName: {
      type: String,
      default: ""
    },
    mandateIssuesCount: {
      type: Number,
      default: 0
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$b = {};
var __component__$b = /* @__PURE__ */ normalizeComponent(
  script$b,
  render$b,
  staticRenderFns$b,
  false,
  injectStyles$b,
  "71a48408",
  null,
  null
);
function injectStyles$b(context) {
  for (let o in __cssModules$b) {
    this[o] = __cssModules$b[o];
  }
}
var AMandateCard = /* @__PURE__ */ function() {
  return __component__$b.exports;
}();
var render$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HRow", { class: _vm.bold ? "text-bold" : "", attrs: { "gap": "4" } }, [_vm.isNotary ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("notary.title")) + " ")]) : _vm._e(), _c("span", [_vm._v(" " + _vm._s(_vm.notary.firstName) + " ")]), _c("span", { staticClass: "text-uppercase" }, [_vm._v(" " + _vm._s(_vm.notary.lastName) + " ")])]);
};
var staticRenderFns$a = [];
const script$a = {
  name: "ANotaryName",
  props: {
    notary: {
      type: Object,
      default: () => {
      },
      validator(obj) {
        return obj.firstName && obj.lastName;
      }
    },
    bold: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isNotary() {
      var _a;
      return this.notary.id && ((_a = this.notary.id) == null ? void 0 : _a.substring(0, 3)) === "NOT";
    }
  }
};
const __cssModules$a = {};
var __component__$a = /* @__PURE__ */ normalizeComponent(
  script$a,
  render$a,
  staticRenderFns$a,
  false,
  injectStyles$a,
  null,
  null,
  null
);
function injectStyles$a(context) {
  for (let o in __cssModules$a) {
    this[o] = __cssModules$a[o];
  }
}
var ANotaryName = /* @__PURE__ */ function() {
  return __component__$a.exports;
}();
var render$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-notary-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected, "has-footer": false }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HCol", { staticClass: "flex-1", attrs: { "gap": "16" } }, [_c("HCol", { attrs: { "gap": "4" } }, [_c("h4", [_c("ANotaryName", { attrs: { "notary": _vm.notary, "bold": "" } })], 1), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v("Ref: " + _vm._s(_vm.notary.id))])]), _vm.notary.address ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", [_vm._v(_vm._s(_vm.notary.address.line1))]), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.notary.address.postcode) + " " + _vm._s(_vm.notary.address.town))])]) : _vm._e(), _c("HCol", { attrs: { "gap": "4" } }, [_c("p", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.Formatter.useFormatPhone(_vm.notary.telephone)))]), _c("p", [_vm._v(_vm._s(_vm.notary.email))])])], 1)];
  }, proxy: true }]) });
};
var staticRenderFns$9 = [];
var ANotaryCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$9 = {
  name: "ANotaryCard",
  components: { ANotaryName },
  props: {
    notary: {
      type: Object,
      default: () => {
      }
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$9 = {};
var __component__$9 = /* @__PURE__ */ normalizeComponent(
  script$9,
  render$9,
  staticRenderFns$9,
  false,
  injectStyles$9,
  "20421727",
  null,
  null
);
function injectStyles$9(context) {
  for (let o in __cssModules$9) {
    this[o] = __cssModules$9[o];
  }
}
var ANotaryCard = /* @__PURE__ */ function() {
  return __component__$9.exports;
}();
var render$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.compact ? _c("HTag", { attrs: { "label": _vm.$t("offer.statusList." + _vm.status), "color": _vm.getColor } }) : _c("HInfoModal", { attrs: { "dark": "" }, scopedSlots: _vm._u([{ key: "activator", fn: function() {
    return [_c("HTag", { attrs: { "color": _vm.getColor, "label": "\u20AC" } })];
  }, proxy: true }, { key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$t("offer.statusList." + _vm.status)) + " ")];
  }, proxy: true }]) });
};
var staticRenderFns$8 = [];
var AOfferStatus_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$8 = {
  name: "AOfferStatus",
  props: {
    status: {
      type: String,
      validator(value) {
        return value === "pending" || value === "pending_signature" || value === "accepted" || value === "refused" || value === "canceled";
      },
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getColor() {
      if (this.status === "pending") {
        return "blue-400";
      }
      if (this.status === "pending_signature") {
        return "yellow";
      }
      if (this.status === "accepted") {
        return "green";
      }
      if (this.status === "refused") {
        return "red";
      }
      if (this.status === "canceled") {
        return "grey-500";
      }
      return "";
    }
  }
};
const __cssModules$8 = {};
var __component__$8 = /* @__PURE__ */ normalizeComponent(
  script$8,
  render$8,
  staticRenderFns$8,
  false,
  injectStyles$8,
  "07d51455",
  null,
  null
);
function injectStyles$8(context) {
  for (let o in __cssModules$8) {
    this[o] = __cssModules$8[o];
  }
}
var AOfferStatus = /* @__PURE__ */ function() {
  return __component__$8.exports;
}();
var render$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-offer-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HCol", { attrs: { "gap": "16" } }, [_c("HCol", { attrs: { "gap": "4" } }, [_c("h4", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.$t("offer.offerCardTitle")) + " " + _vm._s(_vm.offer.propertyId))]), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v("Ref: " + _vm._s(_vm.offer.id))])]), _vm.clients.length > 0 || _vm.companies.length > 0 ? _c("HCol", { attrs: { "gap": "4" } }, [_vm._l(_vm.clients, function(client2) {
      return _c("p", { key: client2 }, [_c("AClientName", { attrs: { "client": client2, "bold": "" } })], 1);
    }), _vm._l(_vm.companies, function(company) {
      return _c("p", { key: company, staticClass: "text-bold" }, [_vm._v(" " + _vm._s(company.name) + " ")]);
    })], 2) : _vm._e(), _c("HCol", { attrs: { "gap": "4" } }, [_vm.offer.validityDate && _vm.offer.status === "pending" ? _c("p", [_vm._v(" " + _vm._s(_vm.$t("offer.validUntil")) + " " + _vm._s(_vm.validityDateFormatted) + " ")]) : _vm._e(), _vm.offer.status === "accepted" && _vm.offer.vendorSignatureDate ? _c("p", [_vm._v(" " + _vm._s(_vm.$t("offer.cdvLimit")) + " " + _vm._s(_vm.cdvLimitDate) + " ")]) : _vm._e()]), _vm.ownerName ? _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("client.followed_by")) + " " + _vm._s(_vm.ownerName))]) : _vm._e(), _c("HCol", { attrs: { "gap": "4" } }, [_c("span", { staticClass: "text-bold" }, [_vm._v(" " + _vm._s(_vm.Formatter.useFormatPrice(_vm.offer.totalPrice + _vm.offer.totalFees)) + " HAI ")]), _c("span", [_vm._v(_vm._s(_vm.$t("property.including_fees", { fees: _vm.Formatter.useFormatPrice(_vm.offer.totalFees) })))])])], 1)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_c("HRow", { staticClass: "a-offer-card__footer", attrs: { "justify-content": "space-between", "gap": "16" } }, [_vm.offer.mortgageSuspensiveClause ? _c("HTag", { attrs: { "color": "yellow", "label": _vm.$t("offer.mortgageSuspensiveClause") } }) : _vm._e(), _c("AOfferStatus", { attrs: { "status": _vm.offer.status } })], 1)];
  }, proxy: true }]) });
};
var staticRenderFns$7 = [];
var AOfferCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$7 = {
  name: "AOfferCard",
  components: {
    AClientName,
    AOfferStatus
  },
  props: {
    offer: {
      type: Object,
      required: true
    },
    ownerName: {
      type: String,
      default: ""
    },
    clients: {
      type: Array,
      validator(arr) {
        return arr.every((client2) => client2.firstName && client2.lastName);
      },
      default: () => []
    },
    companies: {
      type: Array,
      validator(arr) {
        return arr.every((company) => company.name);
      },
      default: () => []
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  computed: {
    validityDateFormatted() {
      return dayjsUTC(this.offer.validityDate).format("DD/MM/YYYY");
    },
    cdvLimitDate() {
      return dayjsUTC(this.offer.vendorSignatureDate).add(this.offer.cdvDelay, "months").format("DD/MM/YYYY");
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$7 = {};
var __component__$7 = /* @__PURE__ */ normalizeComponent(
  script$7,
  render$7,
  staticRenderFns$7,
  false,
  injectStyles$7,
  "bd54c87e",
  null,
  null
);
function injectStyles$7(context) {
  for (let o in __cssModules$7) {
    this[o] = __cssModules$7[o];
  }
}
var AOfferCard = /* @__PURE__ */ function() {
  return __component__$7.exports;
}();
var render$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HRow", { staticClass: "a-program-alerts", attrs: { "align-items": "center", "gap": "16" } }, [_vm.programIssuesCount > 0 ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("model.issue", _vm.programIssuesCount, { number: _vm.programIssuesCount })) + " ")];
  }, proxy: true }], null, false, 4170044942) }) : _vm._e(), _vm.contractExpired ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("contract.expired_contracts", _vm.contractExpired)) + " ")];
  }, proxy: true }], null, false, 386178869) }) : _vm._e(), !_vm.hasAlert ? _c("p", [_vm._v(" " + _vm._s(_vm.$t("main.noAlerts")) + " ")]) : _vm._e()], 1);
};
var staticRenderFns$6 = [];
const script$6 = {
  name: "AProgramAlerts",
  props: {
    programIssuesCount: {
      type: Number,
      default: 0,
      required: false
    },
    contractExpired: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    hasAlert() {
      return this.programIssuesCount > 0 || this.contractExpired;
    }
  }
};
const __cssModules$6 = {};
var __component__$6 = /* @__PURE__ */ normalizeComponent(
  script$6,
  render$6,
  staticRenderFns$6,
  false,
  injectStyles$6,
  null,
  null,
  null
);
function injectStyles$6(context) {
  for (let o in __cssModules$6) {
    this[o] = __cssModules$6[o];
  }
}
var AProgramAlerts = /* @__PURE__ */ function() {
  return __component__$6.exports;
}();
var render$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-program-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HCol", { attrs: { "gap": "16" } }, [_c("HCol", { attrs: { "gap": "4" } }, [_c("h4", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.$t("program.name")) + " - " + _vm._s(_vm.program.name))]), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("contract.name")) + " : " + _vm._s(_vm.program.mandate.reference))]), _c("p", { staticClass: "text-s text-grey-500 a-program-card-description" }, [_vm._v(" " + _vm._s(_vm.program.description && _vm.program.description[_vm.$i18n.locale] ? _vm.program.description[_vm.$i18n.locale] : "") + " ")])]), _vm.address ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", [_vm._v(_vm._s(_vm.address.line1))]), _vm.address.line2 ? _c("p", [_vm._v(_vm._s(_vm.address.line2))]) : _vm._e(), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.address.postcode) + " " + _vm._s(_vm.address.town))]), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.program.typology ? _vm.program.typology.toString() : ""))])]) : _vm._e(), _vm.contact ? _c("HCol", { attrs: { "gap": "4" } }, [_c("HRow", { staticClass: "text-bold" }, [_c("AClientName", { attrs: { "client": _vm.contact } }), _vm.contact.role ? _c("p", { staticClass: "text-capitalize" }, [_vm._v(" - " + _vm._s(_vm.contact.role))]) : _vm._e()], 1), _c("p", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.getContactPhone))]), _c("p", [_vm._v(_vm._s(_vm.getContactEmail))])], 1) : _vm._e(), _vm.program.actableDate ? _c("HRow", [_c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(" " + _vm._s(_vm.$t("lot.actability")) + " quarter." + _vm._s(_vm.program.actableDate.quarter) + " / " + _vm._s(_vm.program.actableDate.year))])]) : _vm._e(), _vm.program.deliveryDate ? _c("HRow", [_c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(" " + _vm._s(_vm.$t("lot.delivery")) + " quarter." + _vm._s(_vm.program.deliveryDate.quarter) + " / " + _vm._s(_vm.program.deliveryDate.year))])]) : _vm._e(), _vm.ownerName ? _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("client.followed_by")) + " " + _vm._s(_vm.ownerName))]) : _vm._e()], 1)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_c("HRow", { staticClass: "a-program-card__footer", attrs: { "justify-content": "space-between", "gap": "16" } }, [_c("AProgramAlerts", { attrs: { "program-issues-count": _vm.programIssues && _vm.programIssues.length ? _vm.programIssues.length : 0, "contract-expired": _vm.isContractExpired } })], 1), _c("AProgramStatusLabel", { attrs: { "status": _vm.program.status } })];
  }, proxy: true }]) });
};
var staticRenderFns$5 = [];
var AProgramCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$5 = {
  name: "AProgramCard",
  components: {
    AClientName,
    AProgramAlerts,
    AProgramStatusLabel
  },
  props: {
    program: {
      type: Object,
      required: true
    },
    ownerName: {
      type: String,
      default: ""
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  computed: {
    contact() {
      var _a, _b;
      return ((_a = this.program) == null ? void 0 : _a.contacts.length) > 0 ? (_b = this.program) == null ? void 0 : _b.contacts[0] : void 0;
    },
    address() {
      var _a, _b;
      return ((_a = this.program) == null ? void 0 : _a.addresses.length) > 0 ? (_b = this.program) == null ? void 0 : _b.addresses[0] : void 0;
    },
    getContactPhone() {
      const contact = this.contact;
      return (contact == null ? void 0 : contact.mobile) ? this.Formatter.useFormatPhone(contact == null ? void 0 : contact.mobile) : "";
    },
    getContactEmail() {
      const contact = this.contact;
      return (contact == null ? void 0 : contact.email) ? contact == null ? void 0 : contact.email : "";
    },
    isContractExpired() {
      var _a, _b;
      return (_b = (_a = this.program) == null ? void 0 : _a.contract) == null ? void 0 : _b.expired;
    },
    programIssues() {
      var _a;
      return (_a = this.program) == null ? void 0 : _a.issues;
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$5 = {};
var __component__$5 = /* @__PURE__ */ normalizeComponent(
  script$5,
  render$5,
  staticRenderFns$5,
  false,
  injectStyles$5,
  "8da090de",
  null,
  null
);
function injectStyles$5(context) {
  for (let o in __cssModules$5) {
    this[o] = __cssModules$5[o];
  }
}
var AProgramCard = /* @__PURE__ */ function() {
  return __component__$5.exports;
}();
function _typeof$6(obj) {
  "@babel/helpers - typeof";
  return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$6(obj);
}
function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$6(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$6(descriptor.key), descriptor);
  }
}
function _createClass$6(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$6(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$6(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$6(arg) {
  var key = _toPrimitive$6(arg, "string");
  return _typeof$6(key) === "symbol" ? key : String(key);
}
function _toPrimitive$6(input, hint) {
  if (_typeof$6(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$6(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var BaseDPE$2 = /* @__PURE__ */ function() {
  function BaseDPE2() {
    _classCallCheck$6(this, BaseDPE2);
  }
  _createClass$6(BaseDPE2, [{
    key: "mappings",
    get: function get2() {
      return {
        energy: this.energy,
        gas: this.gas
      };
    }
  }, {
    key: "energy",
    get: function get2() {
      return this.constructor.energy;
    }
  }, {
    key: "gas",
    get: function get2() {
      return this.constructor.gas;
    }
  }, {
    key: "getEnergyClass",
    value: function getEnergyClass(energy) {
      return this.energy.find(function(item) {
        return energy <= item.max;
      });
    }
  }, {
    key: "getGasClass",
    value: function getGasClass(gas) {
      return this.gas.find(function(item) {
        return gas <= item.max;
      });
    }
  }, {
    key: "getEnergyLetter",
    value: function getEnergyLetter(energy) {
      var _this$getEnergyClass;
      return (_this$getEnergyClass = this.getEnergyClass(energy)) === null || _this$getEnergyClass === void 0 ? void 0 : _this$getEnergyClass.label;
    }
  }, {
    key: "getGasLetter",
    value: function getGasLetter(gas) {
      var _this$getGasClass;
      return (_this$getGasClass = this.getGasClass(gas)) === null || _this$getGasClass === void 0 ? void 0 : _this$getGasClass.label;
    }
  }, {
    key: "getClasses",
    value: function getClasses(energy, gas) {
      return {
        energy: this.getEnergyClass(energy),
        gas: this.getGasClass(gas)
      };
    }
  }, {
    key: "getLetter",
    value: function getLetter(energy, gas) {
      var _classes$energy, _classes$gas, _classes$energy2, _classes$gas2;
      var classes = this.getClasses(energy, gas);
      return ((_classes$energy = classes.energy) === null || _classes$energy === void 0 ? void 0 : _classes$energy.rank) > ((_classes$gas = classes.gas) === null || _classes$gas === void 0 ? void 0 : _classes$gas.rank) ? (_classes$energy2 = classes.energy) === null || _classes$energy2 === void 0 ? void 0 : _classes$energy2.label : (_classes$gas2 = classes.gas) === null || _classes$gas2 === void 0 ? void 0 : _classes$gas2.label;
    }
  }, {
    key: "drawEnergySVG",
    value: function drawEnergySVG(energy, gas, width, height) {
    }
  }, {
    key: "drawGasSVG",
    value: function drawGasSVG(gas, width, height) {
    }
  }, {
    key: "drawSVG",
    value: function drawSVG(energy, gas, width, height) {
    }
  }], [{
    key: "energy",
    get: function get2() {
    }
  }, {
    key: "gas",
    get: function get2() {
    }
  }]);
  return BaseDPE2;
}();
var baseDPE = BaseDPE$2;
function _typeof$5(obj) {
  "@babel/helpers - typeof";
  return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$5(obj);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$3(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$3(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$3(arr);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$5(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$5(descriptor.key), descriptor);
  }
}
function _createClass$5(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$5(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$5(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$5(arg) {
  var key = _toPrimitive$5(arg, "string");
  return _typeof$5(key) === "symbol" ? key : String(key);
}
function _toPrimitive$5(input, hint) {
  if (_typeof$5(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$5(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var ClimaticZone$1 = /* @__PURE__ */ function() {
  function ClimaticZone2() {
    _classCallCheck$5(this, ClimaticZone2);
  }
  _createClass$5(ClimaticZone2, null, [{
    key: "H1A",
    get: function get2() {
      return ["02", "14", "27", "28", "59", "60", "61", "62", "75", "76", "77", "78", "80", "91", "92", "93", "94", "95"];
    }
  }, {
    key: "H1B",
    get: function get2() {
      return ["08", "10", "45", "51", "52", "54", "55", "57", "58", "67", "68", "70", "88", "89", "90"];
    }
  }, {
    key: "H1C",
    get: function get2() {
      return ["01", "03", "05", "15", "19", "21", "23", "25", "38", "39", "42", "43", "63", "69", "71", "73", "74", "87"];
    }
  }, {
    key: "H2A",
    get: function get2() {
      return ["22", "29", "35", "50", "56"];
    }
  }, {
    key: "H2B",
    get: function get2() {
      return ["16", "17", "18", "36", "37", "41", "44", "49", "53", "72", "79", "85", "86"];
    }
  }, {
    key: "H2C",
    get: function get2() {
      return ["09", "12", "24", "31", "32", "33", "40", "46", "47", "64", "65", "81", "82"];
    }
  }, {
    key: "H2D",
    get: function get2() {
      return ["07", "04", "26", "48", "84"];
    }
  }, {
    key: "H1",
    get: function get2() {
      return [].concat(_toConsumableArray(ClimaticZone2.H1A), _toConsumableArray(ClimaticZone2.H1B), _toConsumableArray(ClimaticZone2.H1C));
    }
  }, {
    key: "H2",
    get: function get2() {
      return [].concat(_toConsumableArray(ClimaticZone2.H2A), _toConsumableArray(ClimaticZone2.H2B), _toConsumableArray(ClimaticZone2.H2C), _toConsumableArray(ClimaticZone2.H2D));
    }
  }, {
    key: "H3",
    get: function get2() {
      return ["2A", "2B", "20", "06", "11", "13", "30", "34", "66", "83"];
    }
  }, {
    key: "DPE_2021_ZONE",
    get: function get2() {
      return [].concat(_toConsumableArray(ClimaticZone2.H1B), _toConsumableArray(ClimaticZone2.H1C), _toConsumableArray(ClimaticZone2.H2D));
    }
  }]);
  return ClimaticZone2;
}();
var climaticZone = ClimaticZone$1;
function _typeof$4(obj) {
  "@babel/helpers - typeof";
  return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$4(obj);
}
function _createForOfIteratorHelper$2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i2 = 0;
      var F = function F2() {
      };
      return { s: F, n: function n2() {
        if (i2 >= o.length)
          return { done: true };
        return { done: false, value: o[i2++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n2() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it["return"] != null)
        it["return"]();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$2(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$2(o, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$4(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$4(descriptor.key), descriptor);
  }
}
function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$4(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$4(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$4(arg) {
  var key = _toPrimitive$4(arg, "string");
  return _typeof$4(key) === "symbol" ? key : String(key);
}
function _toPrimitive$4(input, hint) {
  if (_typeof$4(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$4(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var Utils$2 = /* @__PURE__ */ function() {
  function Utils2() {
    _classCallCheck$4(this, Utils2);
  }
  _createClass$4(Utils2, null, [{
    key: "getMinMax",
    value: function getMinMax(_ref) {
      var min = _ref.min, max = _ref.max;
      if (min === -Infinity) {
        return "\u2264 ".concat(max);
      }
      if (max === Infinity) {
        return "> ".concat(min - 1);
      }
      return "".concat(min, " \xE0 ").concat(max);
    }
  }, {
    key: "singleLine",
    value: function singleLine(string) {
      var lines = string.split(/\r\n|[\n\v\f\r\x85\u2028\u2029]/g);
      var result = [];
      var _iterator = _createForOfIteratorHelper$2(lines), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var line = _step.value;
          result.push(line.trim());
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result.join("");
    }
  }]);
  return Utils2;
}();
var utils = Utils$2;
function _typeof$3(obj) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$3(obj);
}
function _createForOfIteratorHelper$1(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i2 = 0;
      var F = function F2() {
      };
      return { s: F, n: function n2() {
        if (i2 >= o.length)
          return { done: true };
        return { done: false, value: o[i2++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n2() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it["return"] != null)
        it["return"]();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$3(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$3(descriptor.key), descriptor);
  }
}
function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$3(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$3(arg) {
  var key = _toPrimitive$3(arg, "string");
  return _typeof$3(key) === "symbol" ? key : String(key);
}
function _toPrimitive$3(input, hint) {
  if (_typeof$3(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$3(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$2(o, p);
}
function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$2(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$2(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$2(this, result);
  };
}
function _possibleConstructorReturn$2(self2, call) {
  if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$2(self2);
}
function _assertThisInitialized$2(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$2(o);
}
var BaseDPE$1 = baseDPE;
var Utils$1 = utils;
var DPE_6_X$1 = /* @__PURE__ */ function(_BaseDPE) {
  _inherits$2(DPE_6_X2, _BaseDPE);
  var _super = _createSuper$2(DPE_6_X2);
  function DPE_6_X2() {
    _classCallCheck$3(this, DPE_6_X2);
    return _super.apply(this, arguments);
  }
  _createClass$3(DPE_6_X2, [{
    key: "drawEnergySVG",
    value: function drawEnergySVG(energy, gas) {
      var width = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 270;
      var height = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 190;
      var matchingClass = this.getEnergyClass(energy);
      var elements = [];
      var elmHeight = 19;
      var viewBoxWidth = 270;
      var _iterator = _createForOfIteratorHelper$1(this.energy), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var dpeClass = _step.value;
          var x = 5;
          var y = 15 + (elmHeight + 3) * (dpeClass.rank - 1);
          var length = 75 + (dpeClass.rank - 1) * 20;
          if (matchingClass.rank === dpeClass.rank) {
            var margin = 1.5;
            elements.push('\n                    <g>\n                        <path fill="#ffffff" stroke-width="1" stroke="#5b5b5b" d="M '.concat(x - margin, " ").concat(y - margin, " L ").concat(viewBoxWidth - 5, " ").concat(y - margin, " L ").concat(viewBoxWidth - 5, " ").concat(y + elmHeight + margin, " L ").concat(x - margin, " ").concat(y + elmHeight + margin, ' Z"/>\n                        <text x="').concat(viewBoxWidth - 15, '" y="').concat(y + elmHeight / 1.4, '" fill="#000000" font-size="11" text-anchor="end">').concat(energy, "</text>\n                    </g>\n                "));
          }
          elements.push('\n                <g>\n                    <polygon fill="'.concat(dpeClass.color, '" stroke="#000000" points="').concat(x, ",").concat(y, " ").concat(length - 15, ",").concat(y, " ").concat(length, ",").concat(y + elmHeight / 2, " ").concat(length - 15, ",").concat(y + elmHeight, " ").concat(x, ",").concat(y + elmHeight, " ").concat(x, ",").concat(y, '"/>\n                    <text x="').concat(x + 5, '" y="').concat(y + elmHeight / 1.4, '" fill="').concat(dpeClass.labelColor, '" font-size="11" text-anchor="start">').concat(Utils$1.getMinMax(dpeClass), '</text>\n                    <text x="').concat(length - 20, '" y="').concat(y + 15, '" fill="').concat(dpeClass.labelColor, '" font-size="15" text-anchor="end" font-weight="bold">').concat(dpeClass.label, "</text>\n                </g>\n            "));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      elements.push('\n            <g>\n                <text x="5" y="10" fill="#000000" font-size="13" font-weight="bold">Logement \xE9conome</text>\n                <text x="5" y="180" fill="#000000" font-size="13" font-weight="bold">Logement \xE9nergivore</text>\n            </g>\n        ');
      return Utils$1.singleLine('\n            <svg viewBox="0 -4 '.concat(viewBoxWidth, ' 190" width="').concat(width, '" height="').concat(height, `" xmlns="http://www.w3.org/2000/svg" font-family="'Arial Narrow', sans-serif" preserveAspectRatio="xMidYMid meet">
            `).concat(elements.join("\n"), "\n            </svg>\n        "));
    }
  }, {
    key: "drawGasSVG",
    value: function drawGasSVG(gas) {
      var width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 270;
      var height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 190;
      var matchingClass = this.getGasClass(gas);
      var elements = [];
      var elmHeight = 19;
      var viewBoxWidth = 270;
      var _iterator2 = _createForOfIteratorHelper$1(this.gas), _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
          var dpeClass = _step2.value;
          var x = 5;
          var y = 15 + (elmHeight + 3) * (dpeClass.rank - 1);
          var length = 75 + (dpeClass.rank - 1) * 20;
          if (matchingClass.rank === dpeClass.rank) {
            var margin = 1.5;
            elements.push('\n                    <g>\n                        <path fill="#ffffff" stroke-width="1" stroke="#5b5b5b" d="M '.concat(x - margin, " ").concat(y - margin, " L ").concat(viewBoxWidth - 5, " ").concat(y - margin, " L ").concat(viewBoxWidth - 5, " ").concat(y + elmHeight + margin, " L ").concat(x - margin, " ").concat(y + elmHeight + margin, ' Z"/>\n                        <text x="').concat(viewBoxWidth - 15, '" y="').concat(y + elmHeight / 1.4, '" fill="#000000" font-size="11" text-anchor="end">').concat(gas, "</text>\n                    </g>\n                "));
          }
          elements.push('\n                <g>\n                    <polygon fill="'.concat(dpeClass.color, '" stroke="#000000" points="').concat(x, ",").concat(y, " ").concat(length, ",").concat(y, " ").concat(length, ",").concat(y + elmHeight, " ").concat(x, ",").concat(y + elmHeight, " ").concat(x, ",").concat(y, '"/>\n                    <text x="').concat(x + 5, '" y="').concat(y + elmHeight / 1.4, '" fill="').concat(dpeClass.labelColor, '" font-size="11" text-anchor="start">').concat(Utils$1.getMinMax(dpeClass), '</text>\n                    <text x="').concat(length - 5, '" y="').concat(y + 15, '" fill="').concat(dpeClass.labelColor, '" font-size="15" text-anchor="end" font-weight="bold">').concat(dpeClass.label, "</text>\n                </g>\n            "));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      elements.push('\n            <g>\n                <text x="5" y="10" fill="#000000" font-size="13" font-weight="bold">Faible \xE9mission de GES</text>\n                <text x="5" y="180" fill="#000000" font-size="13" font-weight="bold">Forte \xE9mission de GES</text>\n            </g>\n        ');
      return Utils$1.singleLine('\n            <svg viewBox="0 -4 '.concat(viewBoxWidth, ' 190" width="').concat(width, '" height="').concat(height, `" xmlns="http://www.w3.org/2000/svg" font-family="'Arial Narrow', sans-serif" preserveAspectRatio="xMidYMid meet">
                `).concat(elements.join("\n"), "\n            </svg>\n        "));
    }
  }, {
    key: "drawSVG",
    value: function drawSVG(energy, gas) {
      var width = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 540;
      var height = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 190;
      return Utils$1.singleLine('\n            <svg viewBox="0 0 540 190" width="'.concat(width, '" height="').concat(height, '" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">\n                <g>\n                    ').concat(this.drawEnergySVG(energy, gas), '\n                </g>\n                <g transform="translate(270, 0)">\n                    ').concat(this.drawGasSVG(gas), "\n                </g>\n            </svg>\n        "));
    }
  }], [{
    key: "energy",
    get: function get2() {
      return [{
        rank: 1,
        min: -Infinity,
        max: 50,
        color: "#319834",
        label: "A",
        labelColor: "#000"
      }, {
        rank: 2,
        min: 51,
        max: 90,
        color: "#33cc31",
        label: "B",
        labelColor: "#000"
      }, {
        rank: 3,
        min: 91,
        max: 150,
        color: "#cbfc34",
        label: "C",
        labelColor: "#000"
      }, {
        rank: 4,
        min: 151,
        max: 230,
        color: "#fbfe06",
        label: "D",
        labelColor: "#000"
      }, {
        rank: 5,
        min: 231,
        max: 330,
        color: "#fbcc05",
        label: "E",
        labelColor: "#000"
      }, {
        rank: 6,
        min: 331,
        max: 450,
        color: "#fc9935",
        label: "F",
        labelColor: "#000"
      }, {
        rank: 7,
        min: 451,
        max: Infinity,
        color: "#fc0205",
        label: "G",
        labelColor: "#FFF"
      }];
    }
  }, {
    key: "gas",
    get: function get2() {
      return [{
        rank: 1,
        min: -Infinity,
        max: 5,
        color: "#f2eff4",
        label: "A",
        labelColor: "#000"
      }, {
        rank: 2,
        min: 6,
        max: 10,
        color: "#dfc1f7",
        label: "B",
        labelColor: "#000"
      }, {
        rank: 3,
        min: 11,
        max: 20,
        color: "#d6aaf4",
        label: "C",
        labelColor: "#000"
      }, {
        rank: 4,
        min: 21,
        max: 35,
        color: "#cc93f4",
        label: "D",
        labelColor: "#000"
      }, {
        rank: 5,
        min: 36,
        max: 55,
        color: "#bb72f3",
        label: "E",
        labelColor: "#FFF"
      }, {
        rank: 6,
        min: 56,
        max: 80,
        color: "#a94cee",
        label: "F",
        labelColor: "#FFF"
      }, {
        rank: 7,
        min: 81,
        max: Infinity,
        color: "#8b1ae1",
        label: "G",
        labelColor: "#FFF"
      }];
    }
  }]);
  return DPE_6_X2;
}(BaseDPE$1);
var dpe_6_x = DPE_6_X$1;
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i2 = 0;
      var F = function F2() {
      };
      return { s: F, n: function n2() {
        if (i2 >= o.length)
          return { done: true };
        return { done: false, value: o[i2++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n2() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it["return"] != null)
        it["return"]();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$2(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$2(descriptor.key), descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$2(arg) {
  var key = _toPrimitive$2(arg, "string");
  return _typeof$2(key) === "symbol" ? key : String(key);
}
function _toPrimitive$2(input, hint) {
  if (_typeof$2(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$2(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf$1(o, p);
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _possibleConstructorReturn$1(self2, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1(o);
}
var BaseDPE = baseDPE;
var Utils = utils;
var DPE_2021$2 = /* @__PURE__ */ function(_BaseDPE) {
  _inherits$1(DPE_20212, _BaseDPE);
  var _super = _createSuper$1(DPE_20212);
  function DPE_20212() {
    _classCallCheck$2(this, DPE_20212);
    return _super.apply(this, arguments);
  }
  _createClass$2(DPE_20212, [{
    key: "drawEnergySVG",
    value: function drawEnergySVG(energy, gas) {
      var width = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 620;
      var height = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 320;
      var letter = this.getLetter(energy, gas);
      var elements = [];
      var viewBoxWidth = 620;
      var baseHeight = 30;
      var baseLength = 40;
      var margin = 5;
      var boxLength = 170;
      var rightY = function rightY2(y2) {
        return baseLength + y2 * 0.7;
      };
      var x = boxLength + 50;
      var y = 20;
      if (letter === "A") {
        y += 3;
      }
      if (["F", "G"].includes(letter)) {
        x += 65;
      }
      var rightBoxLength = boxLength * (8 / 16);
      var middleLeftBox = x - boxLength + boxLength * (8 / 16) / 2;
      var middleRightBox = x - rightBoxLength / 2;
      var yF = 0;
      var yGEnd = 0;
      elements.push('\n            <g>\n                <text x="'.concat(x, '" y="').concat(y, '" fill="').concat(this.energy[0].color, '" font-size="12" text-anchor="start">logement tr\xE8s performant</text>\n            </g>\n        '));
      y += 7;
      var _iterator = _createForOfIteratorHelper(this.energy), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var dpeClass = _step.value;
          var big = letter === dpeClass.label;
          var h = big ? baseHeight * 2 : baseHeight;
          var yMiddle = y + h / 2;
          var length = rightY(y);
          var tip = rightY(yMiddle);
          if (dpeClass.label === "F") {
            yF = y;
          }
          if (dpeClass.label === "G") {
            yGEnd = y + h;
          }
          elements.push('\n                <g>\n                    <path fill="'.concat(dpeClass.color, '" d="m ').concat(x, " ").concat(y, " h ").concat(length, " l ").concat(tip - length, " ").concat(h / 2, " l ").concat(-(tip - length), " ").concat(h / 2, " h ").concat(-length, ' Z" ').concat(big ? 'stroke="#000" stroke-width="2"' : "", '/>\n                    <text x="').concat(x + 10, '" y="').concat(yMiddle, '" fill="').concat(dpeClass.labelColor, '" font-size="').concat(big ? 52 : 20, '" ').concat(big ? 'stroke="#000" stroke-width="2"' : "", ' text-anchor="start" dominant-baseline="central">').concat(dpeClass.label, "</text>\n                </g>\n            "));
          if (big) {
            elements.push('\n                    <g>\n                        <path stroke="#000" stroke-width="2" fill="none" d="m '.concat(x, " ").concat(y, " v ").concat(h, " h ").concat(-boxLength, " a 2.5,2.5,0,0,1-2.5-2.5 v ").concat(-h + 5, ' a2.5,2.5,0,0,1,2.5-2.5 Z"/>\n                        <path stroke="#000" stroke-width="2" fill="none" d="m ').concat(x - rightBoxLength, " ").concat(y + h / 6, " v ").concat(h / 1.5, '"/>\n    \n                        <text x="').concat(middleLeftBox, '" y="').concat(y - margin * 3.5, '" fill="#000" font-size="10" text-anchor="middle">consommation</text>\n                        <text x="').concat(middleLeftBox, '" y="').concat(y - margin * 1.3, '" fill="#949599" font-size="10" text-anchor="middle">(\xE9nergie primaire)</text>\n                        <text x="').concat(middleLeftBox, '" y="').concat(y + h * 2 / 4, '" fill="#000" font-size="22" text-anchor="middle">').concat(energy, '</text>\n                        <text x="').concat(middleLeftBox, '" y="').concat(y + h * 3.2 / 4, '" fill="#000" font-size="10" text-anchor="middle">kWh/m\xB2/an</text>\n    \n                        <text x="').concat(middleRightBox, '" y="').concat(y - margin, '" fill="#000" font-size="10" text-anchor="middle">\xE9missions</text>\n                        <text x="').concat(middleRightBox, '" y="').concat(y + h * 2 / 4, '" fill="#000" font-size="22" text-anchor="middle">').concat(gas, '</text>\n                        <text x="').concat(middleRightBox, '" y="').concat(y + h * 3.2 / 4, '" fill="#000" font-size="10" text-anchor="middle">kg CO\u2082/m\xB2/an</text>\n                    </g>\n                '));
          }
          y += h + margin;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      elements.push('\n            <g>\n                <text x="'.concat(x, '" y="').concat(y + margin * 2, '" fill="').concat(this.energy[this.energy.length - 1].color, `" font-size="12" text-anchor="start">logement extr\xEAmement consommateur d'\xE9nergie</text>
            </g>
        `));
      if (["F", "G"].includes(letter)) {
        x -= 180;
      }
      elements.push('\n            <g>\n                <path stroke="#9d9d9c" stroke-width="5" fill="none" d="m '.concat(x - 10, " ").concat(yF, " v ").concat(yGEnd - yF, '" stroke-linecap="butt" stroke-linejoin="miter"/>\n                <text x="').concat(x - 15, '" y="').concat(yF + (yGEnd - yF) / 2 - 3, '" fill="#9d9d9c" font-size="12" text-anchor="end">passoire</text>\n                <text x="').concat(x - 15, '" y="').concat(yF + (yGEnd - yF) / 2 + 11, '" fill="#9d9d9c" font-size="12" text-anchor="end">\xE9nerg\xE9tique</text>\n            </g>\n        '));
      return Utils.singleLine('\n            <svg viewBox="0 0 '.concat(viewBoxWidth, ' 320" width="').concat(width, '" height="').concat(height, `" xmlns="http://www.w3.org/2000/svg" font-family="'Red Hat Display',sans-serif" stroke-linecap="round" stroke-linejoin="round" font-weight="800" preserveAspectRatio="xMidYMid meet">
                <style>
                    @import url("https://fonts.googleapis.com/css?family=Red+Hat+Display:800,800i");
                </style>
                `).concat(elements.join("\n"), "\n            </svg>\n        "));
    }
  }, {
    key: "drawGasSVG",
    value: function drawGasSVG(gas) {
      var width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 420;
      var height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 320;
      var letter = this.getGasLetter(gas);
      var elements = [];
      var baseHeight = 30;
      var baseLength = 40;
      var margin = 5;
      var rightY = function rightY2(y2) {
        return baseLength + y2 * 0.7;
      };
      var x = 5;
      var y = 20;
      elements.push('\n            <g>\n                <text x="'.concat(x, '" y="').concat(y, '" fill="').concat(this.gas[0].color, `" font-size="12" text-anchor="start">peu d'\xE9missions de CO\u2082</text>
            </g>
        `));
      y += 7;
      var _iterator2 = _createForOfIteratorHelper(this.gas), _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
          var dpeClass = _step2.value;
          var big = letter === dpeClass.label;
          var h = big ? baseHeight * 2 : baseHeight;
          var length = rightY(y);
          var yMiddle = y + h / 2;
          elements.push('\n                <g>\n                    <path fill="'.concat(dpeClass.color, '" d="m ').concat(x, " ").concat(y, " h ").concat(length, " a 1 1 0 0 1 0 ").concat(h, " h ").concat(-length, ' Z" ').concat(big ? 'stroke="#000" stroke-width="2"' : "", '/>\n                    <text x="').concat(x + 10, '" y="').concat(yMiddle, '" fill="').concat(dpeClass.labelColor, '" font-size="').concat(big ? 52 : 20, '" text-anchor="start" ').concat(big ? 'stroke="#000" stroke-width="2"' : "", ' dominant-baseline="central">').concat(dpeClass.label, "</text>\n                </g>\n            "));
          if (big) {
            elements.push('\n                    <g>\n                        <text x="'.concat(x + 400, '" y="').concat(yMiddle, '" fill="#000" font-size="10" text-anchor="end" dominant-baseline="central">kg CO\u2082/m\xB2/an</text>\n                        <text x="').concat(x + 320, '" y="').concat(yMiddle, '" fill="#000" font-size="22" text-anchor="end" dominant-baseline="central">').concat(gas, '</text>\n                        <path fill="#000" d="M ').concat(x + 250, " ").concat(yMiddle, " H ").concat(x + length + h, '" stroke="#000" stroke-width="2"/>\n                    </g>\n                '));
          }
          y += h + margin;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      elements.push('\n            <g>\n                <text x="'.concat(x, '" y="').concat(y + margin * 2, '" fill="').concat(this.gas[this.gas.length - 1].color, '" font-size="12" text-anchor="start">\xE9missions de CO\u2082 tr\xE8s importantes</text>\n            </g>\n        '));
      return Utils.singleLine('\n            <svg viewBox="0 0 420 320" width="'.concat(width, '" height="').concat(height, `" xmlns="http://www.w3.org/2000/svg" font-family="'Red Hat Display',sans-serif" stroke-linecap="round" stroke-linejoin="round" font-weight="800" preserveAspectRatio="xMidYMid meet">
                <style>
                    @import url("https://fonts.googleapis.com/css?family=Red+Hat+Display:800,800i");
                </style>
                `).concat(elements.join("\n"), "\n            </svg>\n        "));
    }
  }, {
    key: "drawSVG",
    value: function drawSVG(energy, gas) {
      var width = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1040;
      var height = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 320;
      return Utils.singleLine('\n            <svg viewBox="0 0 1040 320" width="'.concat(width, '" height="').concat(height, '" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">\n                <g>\n                    ').concat(this.drawEnergySVG(energy, gas), '\n                </g>\n                <g transform="translate(620, 0)">\n                    ').concat(this.drawGasSVG(gas), "\n                </g>\n            </svg>\n        "));
    }
  }], [{
    key: "energy",
    get: function get2() {
      return [{
        rank: 1,
        min: -Infinity,
        max: 69,
        color: "#00a06d",
        label: "A",
        labelColor: "#FFF"
      }, {
        rank: 2,
        min: 70,
        max: 109,
        color: "#52b153",
        label: "B",
        labelColor: "#FFF"
      }, {
        rank: 3,
        min: 110,
        max: 179,
        color: "#a5cc74",
        label: "C",
        labelColor: "#FFF"
      }, {
        rank: 4,
        min: 180,
        max: 249,
        color: "#f4e70f",
        label: "D",
        labelColor: "#FFF"
      }, {
        rank: 5,
        min: 250,
        max: 329,
        color: "#f0b40f",
        label: "E",
        labelColor: "#FFF"
      }, {
        rank: 6,
        min: 330,
        max: 419,
        color: "#eb8235",
        label: "F",
        labelColor: "#FFF"
      }, {
        rank: 7,
        min: 420,
        max: Infinity,
        color: "#d7221f",
        label: "G",
        labelColor: "#FFF"
      }];
    }
  }, {
    key: "gas",
    get: function get2() {
      return [{
        rank: 1,
        min: -Infinity,
        max: 5,
        color: "#a4dbf8",
        label: "A",
        labelColor: "#FFF"
      }, {
        rank: 2,
        min: 6,
        max: 10,
        color: "#8cb4d3",
        label: "B",
        labelColor: "#FFF"
      }, {
        rank: 3,
        min: 11,
        max: 29,
        color: "#7792b1",
        label: "C",
        labelColor: "#FFF"
      }, {
        rank: 4,
        min: 30,
        max: 49,
        color: "#606f8f",
        label: "D",
        labelColor: "#FFF"
      }, {
        rank: 5,
        min: 50,
        max: 69,
        color: "#4d5271",
        label: "E",
        labelColor: "#FFF"
      }, {
        rank: 6,
        min: 70,
        max: 99,
        color: "#393551",
        label: "F",
        labelColor: "#FFF"
      }, {
        rank: 7,
        min: 100,
        max: Infinity,
        color: "#281b35",
        label: "G",
        labelColor: "#FFF"
      }];
    }
  }]);
  return DPE_20212;
}(BaseDPE);
var dpe_2021 = DPE_2021$2;
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return _typeof$1(key) === "symbol" ? key : String(key);
}
function _toPrimitive$1(input, hint) {
  if (_typeof$1(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$1(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var DPE_2021$1 = dpe_2021;
var DPE_2021_Zone$1 = /* @__PURE__ */ function(_DPE_) {
  _inherits(DPE_2021_Zone2, _DPE_);
  var _super = _createSuper(DPE_2021_Zone2);
  function DPE_2021_Zone2() {
    _classCallCheck$1(this, DPE_2021_Zone2);
    return _super.apply(this, arguments);
  }
  _createClass$1(DPE_2021_Zone2, null, [{
    key: "energy",
    get: function get2() {
      return [DPE_2021$1.energy[0], DPE_2021$1.energy[1], DPE_2021$1.energy[2], DPE_2021$1.energy[3], _objectSpread(_objectSpread({}, DPE_2021$1.energy[4]), {}, {
        min: 250,
        max: 389
      }), _objectSpread(_objectSpread({}, DPE_2021$1.energy[5]), {}, {
        min: 390,
        max: 499
      }), _objectSpread(_objectSpread({}, DPE_2021$1.energy[6]), {}, {
        min: 500,
        max: Infinity
      })];
    }
  }, {
    key: "gas",
    get: function get2() {
      return [DPE_2021$1.gas[0], DPE_2021$1.gas[1], DPE_2021$1.gas[2], DPE_2021$1.gas[3], _objectSpread(_objectSpread({}, DPE_2021$1.gas[4]), {}, {
        min: 50,
        max: 79
      }), _objectSpread(_objectSpread({}, DPE_2021$1.gas[5]), {}, {
        min: 80,
        max: 109
      }), _objectSpread(_objectSpread({}, DPE_2021$1.gas[6]), {}, {
        min: 110,
        max: Infinity
      })];
    }
  }]);
  return DPE_2021_Zone2;
}(DPE_2021$1);
var dpe_2021_zone = DPE_2021_Zone$1;
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var ClimaticZone = climaticZone;
var DPE_6_X = new dpe_6_x();
var DPE_2021 = new dpe_2021();
var DPE_2021_Zone = new dpe_2021_zone();
var Type = /* @__PURE__ */ function() {
  function Type2() {
    _classCallCheck(this, Type2);
  }
  _createClass(Type2, null, [{
    key: "values",
    value: function values() {
      return [Type2.TYPE_6_1, Type2.TYPE_6_2, Type2.TYPE_6_3, Type2.TYPE_2021];
    }
  }]);
  return Type2;
}();
_defineProperty(Type, "TYPE_6_1", "6.1");
_defineProperty(Type, "TYPE_6_2", "6.2");
_defineProperty(Type, "TYPE_6_3", "6.3");
_defineProperty(Type, "TYPE_2021", "2021");
var DPE = /* @__PURE__ */ function() {
  function DPE2() {
    _classCallCheck(this, DPE2);
  }
  _createClass(DPE2, null, [{
    key: "isOver800m",
    value: function isOver800m(altitude) {
      if (typeof altitude === "number") {
        return altitude > 800;
      }
      return altitude === "over_800m";
    }
  }, {
    key: "getDPE",
    value: function getDPE(type, zipcode, altitude) {
      switch (type) {
        case Type.TYPE_6_1:
        case Type.TYPE_6_2:
        case Type.TYPE_6_3:
          return DPE_6_X;
        case Type.TYPE_2021:
          if (DPE2.isOver800m(altitude) && ClimaticZone.DPE_2021_ZONE.includes(zipcode.slice(0, 2))) {
            return DPE_2021_Zone;
          }
          return DPE_2021;
        default:
          throw new Error("Unknown DPE type: ".concat(type));
      }
    }
  }, {
    key: "getLetter",
    value: function getLetter(type, energy, gas, zipcode, altitude) {
      return this.getDPE(type, zipcode, altitude).getLetter(energy, gas);
    }
  }, {
    key: "getLetters",
    value: function getLetters(type, energy, gas, zipcode, altitude) {
      var dpe = this.getDPE(type, zipcode, altitude);
      return {
        energy: dpe.getEnergyLetter(energy),
        gas: dpe.getGasLetter(gas)
      };
    }
  }, {
    key: "getClasses",
    value: function getClasses(type, energy, gas, zipcode, altitude) {
      return this.getDPE(type, zipcode, altitude).getClasses(energy, gas);
    }
  }, {
    key: "drawSVG",
    value: function drawSVG(type, energy, gas, zipcode, altitude, width, height) {
      return this.getDPE(type, zipcode, altitude).drawSVG(energy, gas, width, height);
    }
  }]);
  return DPE2;
}();
_defineProperty(DPE, "Type", Type);
var build = DPE;
var render$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HRow", { attrs: { "align-items": "center", "gap": "16" } }, [_vm.propertyOffersCount > 0 ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("model.offer", _vm.propertyOffersCount, { number: _vm.propertyOffersCount })) + " ")];
  }, proxy: true }], null, false, 3391536719) }) : _vm._e(), _vm.propertyIssuesCount > 0 ? _c("HTag", { staticClass: "text-capitalize", attrs: { "color": "red" }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_vm._v(" " + _vm._s(_vm.$tc("model.issue", _vm.propertyIssuesCount, { number: _vm.propertyIssuesCount })) + " ")];
  }, proxy: true }], null, false, 95735662) }) : _vm._e(), _vm.isDpeGraceActiveValid ? _c("HTag", { attrs: { "label": _vm.$t("property.dpe.view.active"), "color": "green" } }) : _vm._e(), _vm.isEnergyAuditMissing ? _c("HTag", { attrs: { "label": _vm.$t("property.dpe.energyAudit.missing"), "color": "red" } }) : _vm._e(), _vm.isDpeGraceActiveExpire ? _c("HTag", { attrs: { "label": _vm.$t("property.dpe.view.expire"), "color": "red" } }) : _vm._e(), !_vm.hasAlert ? _c("p", { staticClass: "no-alerts" }, [_vm._v(" " + _vm._s(_vm.$t("main.noAlerts")) + " ")]) : _vm._e()], 1);
};
var staticRenderFns$4 = [];
var APropertyAlerts_vue_vue_type_style_index_0_scoped_true_lang = "";
dayjs.extend(isSameOrBefore);
const script$4 = {
  name: "APropertyAlerts",
  props: {
    property: {
      type: Object,
      default: () => {
      },
      required: true
    },
    propertyOffersCount: {
      type: Number,
      default: 0,
      required: false
    },
    propertyIssuesCount: {
      type: Number,
      default: 0,
      required: false
    }
  },
  computed: {
    isDpeGraceActive() {
      return this.property && this.property.dpe && this.property.dpe.grace && this.property.dpe.grace.active;
    },
    isDpeGraceExpires() {
      var _a, _b, _c;
      return dayjsUTC((_c = (_b = (_a = this.property) == null ? void 0 : _a.dpe) == null ? void 0 : _b.grace) == null ? void 0 : _c.expires).isSameOrBefore(new Date());
    },
    isDpeGraceActiveValid() {
      return this.isDpeGraceActive && !this.isDpeGraceExpires;
    },
    isEnergyAuditMissing() {
      var _a, _b, _c, _d2, _e, _f, _g, _h, _i2, _j, _k, _l, _m, _n2;
      try {
        const dpeLetter = build.getDPE((_b = (_a = this.property) == null ? void 0 : _a.dpe) == null ? void 0 : _b.type, (_d2 = (_c = this.property) == null ? void 0 : _c.address) == null ? void 0 : _d2.postcode, (_f = (_e = this.property) == null ? void 0 : _e.dpe) == null ? void 0 : _f.altitude).getLetter((_h = (_g = this.property) == null ? void 0 : _g.dpe) == null ? void 0 : _h.energy, (_j = (_i2 = this.property) == null ? void 0 : _i2.dpe) == null ? void 0 : _j.gas);
        return ((_l = (_k = this.property) == null ? void 0 : _k.dpe) == null ? void 0 : _l.type) === "2021" && (dpeLetter === "F" || dpeLetter === "G") && !((_n2 = (_m = this.property) == null ? void 0 : _m.dpe) == null ? void 0 : _n2.energyAudit);
      } catch (e) {
        return false;
      }
    },
    isDpeGraceActiveExpire() {
      return this.isDpeGraceActive && this.isDpeGraceExpires;
    },
    hasAlert() {
      return this.isDpeGraceActiveValid || this.isDpeGraceActiveExpire || this.isEnergyAuditMissing || this.propertyOffersCount || this.propertyIssuesCount;
    }
  }
};
const __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent(
  script$4,
  render$4,
  staticRenderFns$4,
  false,
  injectStyles$4,
  "2f8d28dd",
  null,
  null
);
function injectStyles$4(context) {
  for (let o in __cssModules$4) {
    this[o] = __cssModules$4[o];
  }
}
var APropertyAlerts = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var render$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("img", { style: _vm.getStyle, attrs: { "src": _vm.getRatingIcon, "alt": "rating-" + _vm.rating } });
};
var staticRenderFns$3 = [];
var APropertyRating_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$3 = {
  name: "APropertyRating",
  props: {
    rating: {
      type: Number,
      required: true,
      validator(number) {
        return number > 0 && number <= 3;
      }
    },
    size: {
      type: Number,
      required: false,
      default: 20
    }
  },
  computed: {
    getRatingIcon() {
      if (this.rating === 1) {
        return new URL("data:image/png;base64,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", self.location).href;
      }
      if (this.rating === 2) {
        return new URL("data:image/png;base64,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", self.location).href;
      }
      if (this.rating === 3) {
        return new URL("data:image/png;base64,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", self.location).href;
      }
      return "";
    },
    getStyle() {
      return `width: ${this.size}px; height: ${this.size}px;`;
    }
  }
};
const __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent(
  script$3,
  render$3,
  staticRenderFns$3,
  false,
  injectStyles$3,
  "a4127eee",
  null,
  null
);
function injectStyles$3(context) {
  for (let o in __cssModules$3) {
    this[o] = __cssModules$3[o];
  }
}
var APropertyRating = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HTag", { attrs: { "label": _vm.$t("property.statusList." + _vm.status), "color": _vm.getColor } });
};
var staticRenderFns$2 = [];
var APropertyStatusLabel_vue_vue_type_style_index_0_scoped_true_lang = "";
const script$2 = {
  name: "APropertyStatusLabel",
  props: {
    status: {
      type: String,
      validator(value) {
        return value === "draft" || value === "estimation" || value === "sale" || value === "offer" || value === "offer_other" || value === "sold" || value === "sold_other" || value === "archived";
      },
      required: true
    }
  },
  computed: {
    getColor() {
      if (this.status === "draft") {
        return "grey-300";
      }
      if (this.status === "estimation") {
        return "blue-300";
      }
      if (this.status === "sale") {
        return "blue-400";
      }
      if (this.status === "offer" || this.status === "offer_other") {
        return "yellow";
      }
      if (this.status === "sold" || this.status === "sold_other") {
        return "green";
      }
      if (this.status === "archived") {
        return "grey-500";
      }
      return "";
    }
  }
};
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(
  script$2,
  render$2,
  staticRenderFns$2,
  false,
  injectStyles$2,
  "6ea8de25",
  null,
  null
);
function injectStyles$2(context) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
var APropertyStatusLabel = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-property-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HRow", { staticClass: "a-property-card__content", attrs: { "flex-wrap": "wrap", "gap": "8" } }, [_c("HRow", { staticClass: "a-property-card__image", attrs: { "align-items": "center", "justify-content": "center" } }, [_vm.getPropertyThumbnail ? _c("img", { attrs: { "src": _vm.getPropertyThumbnail, "alt": "property-main-image" } }) : _c("HIcon", { attrs: { "icon": "house", "size": "90", "color": "grey-500" } })], 1), _c("HCol", { staticClass: "a-property-card__info padding-16", attrs: { "gap": "16" } }, [_vm.property.rating || _vm.property.partnerPropertyId || _vm.property.exclusive ? _c("HRow", { attrs: { "justify-content": "flex-end", "gap": "16" } }, [_vm.property.rating ? _c("APropertyRating", { attrs: { "rating": _vm.property.rating } }) : _vm._e(), _vm.property.partnerPropertyId ? _c("HIcon", { attrs: { "icon": "handshake", "size": "20" } }) : _vm._e(), _vm.property.exclusive ? _c("HTag", { attrs: { "label": _vm.$t("property.exclusive"), "color": "red" } }) : _vm._e()], 1) : _vm._e(), _c("HCol", { attrs: { "gap": "4" } }, [_c("h4", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.property.type.name[_vm.$i18n.locale]))]), _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v("Ref: " + _vm._s(_vm.property.reference))])]), _vm.property.address ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", [_vm._v(_vm._s(_vm.property.address.line1))]), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.property.address.postcode) + " " + _vm._s(_vm.property.address.town))])]) : _vm._e(), _vm.ownerName ? _c("p", { staticClass: "text-s text-grey-500" }, [_vm._v(_vm._s(_vm.$t("ada.followed_by")) + " " + _vm._s(_vm.ownerName))]) : _vm._e(), _c("HCol", { attrs: { "gap": "4" } }, [_vm.property.fullPrice && !isNaN(_vm.property.fullPrice) ? _c("span", { staticClass: "text-bold" }, [_vm._v(" " + _vm._s(_vm.Formatter.useFormatPrice(_vm.property.fullPrice)) + " HAI ")]) : _vm.property.estimation && !isNaN(_vm.property.estimation.price) ? _c("span", { staticClass: "text-bold" }, [_vm._v(" " + _vm._s(_vm.Formatter.useFormatPrice(_vm.property.estimation.price)) + " (" + _vm._s(_vm.$t("property.estimated")) + ") ")]) : _vm._e(), _c("span", [_vm._v(_vm._s(_vm.$t("property.including_fees", { fees: _vm.Formatter.useFormatPrice(_vm.property.fees) })))])])], 1)], 1)];
  }, proxy: true }, { key: "footer", fn: function() {
    return [_c("HRow", { staticClass: "a-property-card__footer", attrs: { "justify-content": "space-between", "gap": "16" } }, [_c("HRow", [_c("APropertyAlerts", { attrs: { "property": _vm.property, "property-issues-count": _vm.propertyIssuesCount, "property-offers-count": _vm.propertyOffersCount } })], 1), _c("HRow", { attrs: { "gap": "16" } }, [_vm.propertyOfferStatus ? _c("AOfferStatus", { attrs: { "status": _vm.propertyOfferStatus, "compact": "" } }) : _vm._e(), _vm.isPropertyNew ? _c("HTag", { attrs: { "color": "blue-300", "label": _vm.$t("property.new") } }) : _vm._e(), _c("APropertyStatusLabel", { attrs: { "status": _vm.property.status } })], 1)], 1)];
  }, proxy: true }]) });
};
var staticRenderFns$1 = [];
var APropertyCard_vue_vue_type_style_index_0_rel_stylesheet_2Fscss_scoped_true_lang = "";
const script$1 = {
  name: "APropertyCard",
  components: {
    APropertyRating,
    APropertyAlerts,
    AOfferStatus,
    APropertyStatusLabel
  },
  props: {
    property: {
      type: Object,
      required: true
    },
    ownerName: {
      type: String,
      default: ""
    },
    isPropertyNew: {
      type: Boolean,
      default: false
    },
    propertyOfferStatus: {
      type: String,
      default: ""
    },
    propertyOffersCount: {
      type: Number,
      default: 0,
      required: false
    },
    propertyIssuesCount: {
      type: Number,
      default: 0,
      required: false
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  computed: {
    getPropertyThumbnail() {
      if (Array.isArray(this.property.images) && this.property.images.length > 0) {
        return this.property.images[0].thumbnails["inside_250"] || this.property.images[0].thumbnails["inside_800"] || this.property.images[0].url;
      }
      return "";
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  script$1,
  render$1,
  staticRenderFns$1,
  false,
  injectStyles$1,
  "2e344b04",
  null,
  null
);
function injectStyles$1(context) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var APropertyCard = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("HCard", { staticClass: "a-user-card", attrs: { "can-be-selected": _vm.canBeSelected, "selected": _vm.selected, "has-footer": false }, on: { "click": _vm.onClick }, scopedSlots: _vm._u([{ key: "default", fn: function() {
    return [_c("HRow", { staticClass: "a-user-card__content", attrs: { "flex-wrap": "wrap", "gap": "24" } }, [_c("HCol", { attrs: { "gap": "8" } }, [_vm.user.photo ? _c("img", { staticClass: "a-user-card__image", attrs: { "src": _vm.user.photo, "alt": "user-main-image" } }) : _c("HIcon", { attrs: { "icon": "user", "size": "72", "color": "grey-500" } }), _vm.user.options && _vm.user.options.preferredLanguage ? _c("AFlag", { attrs: { "flag": _vm.user.options.preferredLanguage } }) : _vm._e()], 1), _c("HCol", { staticClass: "a-user-card__info padding-16", attrs: { "gap": "16" } }, [_c("h4", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.user.firstName + " " + _vm.user.lastName))]), _c("HCol", { attrs: { "gap": "4" } }, [_c("p", { staticClass: "text-bold" }, [_vm._v(_vm._s(_vm.getPrimaryPhone))]), _c("p", [_vm._v(_vm._s(_vm.user.email))])]), _vm.user.address ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", [_vm._v(_vm._s(_vm.user.address.line1))]), _vm.user.address.line2 ? _c("p", [_vm._v(_vm._s(_vm.user.address.line2))]) : _vm._e(), _c("p", { staticClass: "text-uppercase" }, [_vm._v(_vm._s(_vm.user.address.postcode) + " " + _vm._s(_vm.user.address.town))])]) : _vm._e(), _c("HRow", { staticClass: "text-s", attrs: { "gap": "7" } }, [_c("p", [_vm._v(_vm._s(_vm.$t("user.businessCard")) + ":")]), _c("p", [_vm._v(_vm._s(_vm.user.cartePro ? _vm.Formatter.useFormatDate(_vm.user.cartePro) : "-"))])]), _vm.groups || _vm.coachingGroups ? _c("HCol", { staticClass: "text-grey-500 text-s", attrs: { "gap": "14" } }, [_vm.groups ? _c("HCol", { attrs: { "gap": "4" } }, _vm._l(_vm.groups, function(group) {
      return _c("HRow", { key: group.id }, [_c("p", [_vm._v(" " + _vm._s(group.name) + " "), group.ownerName ? _c("span", [_vm._v(" - " + _vm._s(group.ownerName))]) : _vm._e()])]);
    }), 1) : _vm._e(), _vm.coachingGroups ? _c("HCol", { attrs: { "gap": "4" } }, [_c("p", { staticClass: "text-bold" }, [_vm._v("Coaching groups")]), _vm._l(_vm.coachingGroups, function(group) {
      return _c("p", { key: group.id }, [_vm._v(_vm._s(group.name))]);
    })], 2) : _vm._e()], 1) : _vm._e()], 1)], 1)];
  }, proxy: true }]) });
};
var staticRenderFns = [];
var AUserCard_vue_vue_type_style_index_0_scoped_true_lang = "";
const script = {
  name: "AUserCard",
  components: {
    AFlag
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    groupsOwners: {
      type: Array,
      default: () => [],
      validator(arr) {
        return arr === null || arr.every((o) => o.groupId && o.ownerName);
      }
    },
    canBeSelected: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  computed: {
    getPrimaryPhone() {
      var _a;
      const primary = (_a = this.user.phones) == null ? void 0 : _a.find((phone) => phone.primary);
      return (primary == null ? void 0 : primary.number) ? this.Formatter.useFormatPhone(primary.number) : "";
    },
    coachingGroups() {
      if (!this.user.groups) {
        return void 0;
      }
      return this.user.groups.filter((g) => !g.alias);
    },
    groups() {
      if (!this.user.groups) {
        return void 0;
      }
      const groups = this.user.groups.filter((g) => g.alias);
      return groups.map((group) => {
        const groupOwner = this.groupsOwners.find((g) => g.groupId === group.id);
        return {
          ...group,
          ownerName: groupOwner ? groupOwner.ownerName : null
        };
      });
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "183a178a",
  null,
  null
);
function injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var AUserCard = /* @__PURE__ */ function() {
  return __component__.exports;
}();
var Components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AAdaCard,
  AAvenantCard,
  ABookingCard,
  ABookingStatusLabel,
  AClientAlerts,
  AClientCard,
  AClientName,
  AClientRating,
  AClientState,
  ACompanyAlerts,
  ACompanyCard,
  AContractAlerts,
  AContractCard,
  AContractStatusLabel,
  AFavorite,
  AFlag,
  ALotAlerts,
  ALotCard,
  AMandateAlerts,
  AMandateCard,
  AMandateStatusLabel,
  ANotaryCard,
  ANotaryName,
  AOfferCard,
  AOfferStatus,
  AProgramAlerts,
  AProgramCard,
  AProgramStatusLabel,
  APropertyAlerts,
  APropertyCard,
  APropertyRating,
  APropertyStatusLabel,
  AUserCard
}, Symbol.toStringTag, { value: "Module" }));
class Aglaea {
  constructor() {
    __publicField(this, "installed", []);
    __publicField(this, "framework");
  }
  static install(Vue2) {
    for (const key in Components) {
      Vue2.component(key, Components[key]);
    }
  }
  init(root) {
    for (const property2 of this.installed) {
      const service = this.framework[property2];
      service.framework = this.framework;
      service.init(root);
    }
  }
  use(service) {
    const property2 = service.property;
    if (this.installed.includes(property2)) {
      return;
    }
    this.framework[property2] = new service();
    this.installed.push(property2);
  }
}
/*!
 * vue-i18n v8.28.2 
 * (c) 2022 kazuya kawaguchi
 * Released under the MIT License.
 */
var numberFormatKeys = [
  "compactDisplay",
  "currency",
  "currencyDisplay",
  "currencySign",
  "localeMatcher",
  "notation",
  "numberingSystem",
  "signDisplay",
  "style",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits"
];
var dateTimeFormatKeys = [
  "dateStyle",
  "timeStyle",
  "calendar",
  "localeMatcher",
  "hour12",
  "hourCycle",
  "timeZone",
  "formatMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName"
];
function warn(msg, err) {
  if (typeof console !== "undefined") {
    console.warn("[vue-i18n] " + msg);
    if (err) {
      console.warn(err.stack);
    }
  }
}
function error(msg, err) {
  if (typeof console !== "undefined") {
    console.error("[vue-i18n] " + msg);
    if (err) {
      console.error(err.stack);
    }
  }
}
var isArray = Array.isArray;
function isObject(obj) {
  return obj !== null && typeof obj === "object";
}
function isBoolean(val) {
  return typeof val === "boolean";
}
function isString(val) {
  return typeof val === "string";
}
var toString = Object.prototype.toString;
var OBJECT_STRING = "[object Object]";
function isPlainObject(obj) {
  return toString.call(obj) === OBJECT_STRING;
}
function isNull(val) {
  return val === null || val === void 0;
}
function isFunction(val) {
  return typeof val === "function";
}
function parseArgs() {
  var args = [], len = arguments.length;
  while (len--)
    args[len] = arguments[len];
  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject(args[0]) || isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === "string") {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === "string") {
      locale = args[0];
    }
    if (isObject(args[1]) || isArray(args[1])) {
      params = args[1];
    }
  }
  return { locale, params };
}
function looseClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
function remove(arr, item) {
  if (arr.delete(item)) {
    return arr;
  }
}
function arrayFrom(arr) {
  var ret = [];
  arr.forEach(function(a) {
    return ret.push(a);
  });
  return ret;
}
function includes(arr, item) {
  return !!~arr.indexOf(item);
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}
function merge(target) {
  var arguments$1 = arguments;
  var output = Object(target);
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments$1[i2];
    if (source !== void 0 && source !== null) {
      var key = void 0;
      for (key in source) {
        if (hasOwn(source, key)) {
          if (isObject(source[key])) {
            output[key] = merge(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output;
}
function looseEqual(a, b) {
  if (a === b) {
    return true;
  }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = isArray(a);
      var isArrayB = isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function(e, i2) {
          return looseEqual(e, b[i2]);
        });
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function(key) {
          return looseEqual(a[key], b[key]);
        });
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
}
function escapeHtml(rawText) {
  return rawText.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
function escapeParams(params) {
  if (params != null) {
    Object.keys(params).forEach(function(key) {
      if (typeof params[key] == "string") {
        params[key] = escapeHtml(params[key]);
      }
    });
  }
  return params;
}
function extend(Vue2) {
  if (!Vue2.prototype.hasOwnProperty("$i18n")) {
    Object.defineProperty(Vue2.prototype, "$i18n", {
      get: function get2() {
        return this._i18n;
      }
    });
  }
  Vue2.prototype.$t = function(key) {
    var values = [], len = arguments.length - 1;
    while (len-- > 0)
      values[len] = arguments[len + 1];
    var i18n2 = this.$i18n;
    return i18n2._t.apply(i18n2, [key, i18n2.locale, i18n2._getMessages(), this].concat(values));
  };
  Vue2.prototype.$tc = function(key, choice) {
    var values = [], len = arguments.length - 2;
    while (len-- > 0)
      values[len] = arguments[len + 2];
    var i18n2 = this.$i18n;
    return i18n2._tc.apply(i18n2, [key, i18n2.locale, i18n2._getMessages(), this, choice].concat(values));
  };
  Vue2.prototype.$te = function(key, locale) {
    var i18n2 = this.$i18n;
    return i18n2._te(key, i18n2.locale, i18n2._getMessages(), locale);
  };
  Vue2.prototype.$d = function(value) {
    var ref;
    var args = [], len = arguments.length - 1;
    while (len-- > 0)
      args[len] = arguments[len + 1];
    return (ref = this.$i18n).d.apply(ref, [value].concat(args));
  };
  Vue2.prototype.$n = function(value) {
    var ref;
    var args = [], len = arguments.length - 1;
    while (len-- > 0)
      args[len] = arguments[len + 1];
    return (ref = this.$i18n).n.apply(ref, [value].concat(args));
  };
}
function defineMixin(bridge) {
  if (bridge === void 0)
    bridge = false;
  function mounted() {
    if (this !== this.$root && this.$options.__INTLIFY_META__ && this.$el) {
      this.$el.setAttribute("data-intlify", this.$options.__INTLIFY_META__);
    }
  }
  return bridge ? { mounted } : {
    beforeCreate: function beforeCreate() {
      var options = this.$options;
      options.i18n = options.i18n || (options.__i18nBridge || options.__i18n ? {} : null);
      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          if (options.__i18nBridge || options.__i18n) {
            try {
              var localeMessages = options.i18n && options.i18n.messages ? options.i18n.messages : {};
              var _i18n = options.__i18nBridge || options.__i18n;
              _i18n.forEach(function(resource) {
                localeMessages = merge(localeMessages, JSON.parse(resource));
              });
              Object.keys(localeMessages).forEach(function(locale) {
                options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
              });
            } catch (e) {
            }
          }
          this._i18n = options.i18n;
          this._i18nWatcher = this._i18n.watchI18nData();
        } else if (isPlainObject(options.i18n)) {
          var rootI18n = this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n ? this.$root.$i18n : null;
          if (rootI18n) {
            options.i18n.root = this.$root;
            options.i18n.formatter = rootI18n.formatter;
            options.i18n.fallbackLocale = rootI18n.fallbackLocale;
            options.i18n.formatFallbackMessages = rootI18n.formatFallbackMessages;
            options.i18n.silentTranslationWarn = rootI18n.silentTranslationWarn;
            options.i18n.silentFallbackWarn = rootI18n.silentFallbackWarn;
            options.i18n.pluralizationRules = rootI18n.pluralizationRules;
            options.i18n.preserveDirectiveContent = rootI18n.preserveDirectiveContent;
          }
          if (options.__i18nBridge || options.__i18n) {
            try {
              var localeMessages$1 = options.i18n && options.i18n.messages ? options.i18n.messages : {};
              var _i18n$1 = options.__i18nBridge || options.__i18n;
              _i18n$1.forEach(function(resource) {
                localeMessages$1 = merge(localeMessages$1, JSON.parse(resource));
              });
              options.i18n.messages = localeMessages$1;
            } catch (e) {
            }
          }
          var ref = options.i18n;
          var sharedMessages = ref.sharedMessages;
          if (sharedMessages && isPlainObject(sharedMessages)) {
            options.i18n.messages = merge(options.i18n.messages, sharedMessages);
          }
          this._i18n = new VueI18n(options.i18n);
          this._i18nWatcher = this._i18n.watchI18nData();
          if (options.i18n.sync === void 0 || !!options.i18n.sync) {
            this._localeWatcher = this.$i18n.watchLocale();
          }
          if (rootI18n) {
            rootI18n.onComponentInstanceCreated(this._i18n);
          }
        } else
          ;
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        this._i18n = this.$root.$i18n;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        this._i18n = options.parent.$i18n;
      }
    },
    beforeMount: function beforeMount() {
      var options = this.$options;
      options.i18n = options.i18n || (options.__i18nBridge || options.__i18n ? {} : null);
      if (options.i18n) {
        if (options.i18n instanceof VueI18n) {
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else if (isPlainObject(options.i18n)) {
          this._i18n.subscribeDataChanging(this);
          this._subscribing = true;
        } else
          ;
      } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      }
    },
    mounted,
    beforeDestroy: function beforeDestroy() {
      if (!this._i18n) {
        return;
      }
      var self2 = this;
      this.$nextTick(function() {
        if (self2._subscribing) {
          self2._i18n.unsubscribeDataChanging(self2);
          delete self2._subscribing;
        }
        if (self2._i18nWatcher) {
          self2._i18nWatcher();
          self2._i18n.destroyVM();
          delete self2._i18nWatcher;
        }
        if (self2._localeWatcher) {
          self2._localeWatcher();
          delete self2._localeWatcher;
        }
      });
    }
  };
}
var interpolationComponent = {
  name: "i18n",
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: "span"
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render2(h, ref) {
    var data = ref.data;
    var parent = ref.parent;
    var props = ref.props;
    var slots = ref.slots;
    var $i18n = parent.$i18n;
    if (!$i18n) {
      return;
    }
    var path = props.path;
    var locale = props.locale;
    var places = props.places;
    var params = slots();
    var children = $i18n.i(
      path,
      locale,
      onlyHasDefaultPlace(params) || places ? useLegacyPlaces(params.default, places) : params
    );
    var tag = !!props.tag && props.tag !== true || props.tag === false ? props.tag : "span";
    return tag ? h(tag, data, children) : children;
  }
};
function onlyHasDefaultPlace(params) {
  var prop;
  for (prop in params) {
    if (prop !== "default") {
      return false;
    }
  }
  return Boolean(prop);
}
function useLegacyPlaces(children, places) {
  var params = places ? createParamsFromPlaces(places) : {};
  if (!children) {
    return params;
  }
  children = children.filter(function(child) {
    return child.tag || child.text.trim() !== "";
  });
  var everyPlace = children.every(vnodeHasPlaceAttribute);
  return children.reduce(
    everyPlace ? assignChildPlace : assignChildIndex,
    params
  );
}
function createParamsFromPlaces(places) {
  return Array.isArray(places) ? places.reduce(assignChildIndex, {}) : Object.assign({}, places);
}
function assignChildPlace(params, child) {
  if (child.data && child.data.attrs && child.data.attrs.place) {
    params[child.data.attrs.place] = child;
  }
  return params;
}
function assignChildIndex(params, child, index2) {
  params[index2] = child;
  return params;
}
function vnodeHasPlaceAttribute(vnode) {
  return Boolean(vnode.data && vnode.data.attrs && vnode.data.attrs.place);
}
var numberComponent = {
  name: "i18n-n",
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: "span"
    },
    value: {
      type: Number,
      required: true
    },
    format: {
      type: [String, Object]
    },
    locale: {
      type: String
    }
  },
  render: function render3(h, ref) {
    var props = ref.props;
    var parent = ref.parent;
    var data = ref.data;
    var i18n2 = parent.$i18n;
    if (!i18n2) {
      return null;
    }
    var key = null;
    var options = null;
    if (isString(props.format)) {
      key = props.format;
    } else if (isObject(props.format)) {
      if (props.format.key) {
        key = props.format.key;
      }
      options = Object.keys(props.format).reduce(function(acc, prop) {
        var obj;
        if (includes(numberFormatKeys, prop)) {
          return Object.assign({}, acc, (obj = {}, obj[prop] = props.format[prop], obj));
        }
        return acc;
      }, null);
    }
    var locale = props.locale || i18n2.locale;
    var parts = i18n2._ntp(props.value, locale, key, options);
    var values = parts.map(function(part, index2) {
      var obj;
      var slot = data.scopedSlots && data.scopedSlots[part.type];
      return slot ? slot((obj = {}, obj[part.type] = part.value, obj.index = index2, obj.parts = parts, obj)) : part.value;
    });
    var tag = !!props.tag && props.tag !== true || props.tag === false ? props.tag : "span";
    return tag ? h(tag, {
      attrs: data.attrs,
      "class": data["class"],
      staticClass: data.staticClass
    }, values) : values;
  }
};
function bind(el, binding, vnode) {
  if (!assert(el, vnode)) {
    return;
  }
  t(el, binding, vnode);
}
function update(el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) {
    return;
  }
  var i18n2 = vnode.context.$i18n;
  if (localeEqual(el, vnode) && (looseEqual(binding.value, binding.oldValue) && looseEqual(el._localeMessage, i18n2.getLocaleMessage(i18n2.locale)))) {
    return;
  }
  t(el, binding, vnode);
}
function unbind(el, binding, vnode, oldVNode) {
  var vm = vnode.context;
  if (!vm) {
    warn("Vue instance does not exists in VNode context");
    return;
  }
  var i18n2 = vnode.context.$i18n || {};
  if (!binding.modifiers.preserve && !i18n2.preserveDirectiveContent) {
    el.textContent = "";
  }
  el._vt = void 0;
  delete el["_vt"];
  el._locale = void 0;
  delete el["_locale"];
  el._localeMessage = void 0;
  delete el["_localeMessage"];
}
function assert(el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn("Vue instance does not exists in VNode context");
    return false;
  }
  if (!vm.$i18n) {
    warn("VueI18n instance does not exists in Vue instance");
    return false;
  }
  return true;
}
function localeEqual(el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale;
}
function t(el, binding, vnode) {
  var ref$1, ref$2;
  var value = binding.value;
  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  var choice = ref.choice;
  if (!path && !locale && !args) {
    warn("value type not supported");
    return;
  }
  if (!path) {
    warn("`path` is required in v-t directive");
    return;
  }
  var vm = vnode.context;
  if (choice != null) {
    el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [path, choice].concat(makeParams(locale, args)));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [path].concat(makeParams(locale, args)));
  }
  el._locale = vm.$i18n.locale;
  el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
}
function parseValue(value) {
  var path;
  var locale;
  var args;
  var choice;
  if (isString(value)) {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }
  return { path, locale, args, choice };
}
function makeParams(locale, args) {
  var params = [];
  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }
  return params;
}
var Vue;
function install(_Vue, options) {
  if (options === void 0)
    options = { bridge: false };
  install.installed = true;
  Vue = _Vue;
  Vue.version && Number(Vue.version.split(".")[0]) || -1;
  extend(Vue);
  Vue.mixin(defineMixin(options.bridge));
  Vue.directive("t", { bind, update, unbind });
  Vue.component(interpolationComponent.name, interpolationComponent);
  Vue.component(numberComponent.name, numberComponent);
  var strats = Vue.config.optionMergeStrategies;
  strats.i18n = function(parentVal, childVal) {
    return childVal === void 0 ? parentVal : childVal;
  };
}
var BaseFormatter = function BaseFormatter2() {
  this._caches = /* @__PURE__ */ Object.create(null);
};
BaseFormatter.prototype.interpolate = function interpolate(message, values) {
  if (!values) {
    return [message];
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values);
};
var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;
function parse(format) {
  var tokens = [];
  var position = 0;
  var text = "";
  while (position < format.length) {
    var char = format[position++];
    if (char === "{") {
      if (text) {
        tokens.push({ type: "text", value: text });
      }
      text = "";
      var sub = "";
      char = format[position++];
      while (char !== void 0 && char !== "}") {
        sub += char;
        char = format[position++];
      }
      var isClosed = char === "}";
      var type = RE_TOKEN_LIST_VALUE.test(sub) ? "list" : isClosed && RE_TOKEN_NAMED_VALUE.test(sub) ? "named" : "unknown";
      tokens.push({ value: sub, type });
    } else if (char === "%") {
      if (format[position] !== "{") {
        text += char;
      }
    } else {
      text += char;
    }
  }
  text && tokens.push({ type: "text", value: text });
  return tokens;
}
function compile(tokens, values) {
  var compiled = [];
  var index2 = 0;
  var mode = Array.isArray(values) ? "list" : isObject(values) ? "named" : "unknown";
  if (mode === "unknown") {
    return compiled;
  }
  while (index2 < tokens.length) {
    var token = tokens[index2];
    switch (token.type) {
      case "text":
        compiled.push(token.value);
        break;
      case "list":
        compiled.push(values[parseInt(token.value, 10)]);
        break;
      case "named":
        if (mode === "named") {
          compiled.push(values[token.value]);
        }
        break;
    }
    index2++;
  }
  return compiled;
}
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;
var pathStateMachine = [];
pathStateMachine[BEFORE_PATH] = {
  "ws": [BEFORE_PATH],
  "ident": [IN_IDENT, APPEND],
  "[": [IN_SUB_PATH],
  "eof": [AFTER_PATH]
};
pathStateMachine[IN_PATH] = {
  "ws": [IN_PATH],
  ".": [BEFORE_IDENT],
  "[": [IN_SUB_PATH],
  "eof": [AFTER_PATH]
};
pathStateMachine[BEFORE_IDENT] = {
  "ws": [BEFORE_IDENT],
  "ident": [IN_IDENT, APPEND],
  "0": [IN_IDENT, APPEND],
  "number": [IN_IDENT, APPEND]
};
pathStateMachine[IN_IDENT] = {
  "ident": [IN_IDENT, APPEND],
  "0": [IN_IDENT, APPEND],
  "number": [IN_IDENT, APPEND],
  "ws": [IN_PATH, PUSH],
  ".": [BEFORE_IDENT, PUSH],
  "[": [IN_SUB_PATH, PUSH],
  "eof": [AFTER_PATH, PUSH]
};
pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  "[": [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  "]": [IN_PATH, PUSH_SUB_PATH],
  "eof": ERROR,
  "else": [IN_SUB_PATH, APPEND]
};
pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  "eof": ERROR,
  "else": [IN_SINGLE_QUOTE, APPEND]
};
pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  "eof": ERROR,
  "else": [IN_DOUBLE_QUOTE, APPEND]
};
var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral(exp) {
  return literalValueRE.test(exp);
}
function stripQuotes(str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 34 || a === 39) ? str.slice(1, -1) : str;
}
function getPathCharType(ch) {
  if (ch === void 0 || ch === null) {
    return "eof";
  }
  var code = ch.charCodeAt(0);
  switch (code) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return ch;
    case 95:
    case 36:
    case 45:
      return "ident";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "ws";
  }
  return "ident";
}
function formatSubPath(path) {
  var trimmed = path.trim();
  if (path.charAt(0) === "0" && isNaN(path)) {
    return false;
  }
  return isLiteral(trimmed) ? stripQuotes(trimmed) : "*" + trimmed;
}
function parse$1(path) {
  var keys = [];
  var index2 = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];
  actions[PUSH] = function() {
    if (key !== void 0) {
      keys.push(key);
      key = void 0;
    }
  };
  actions[APPEND] = function() {
    if (key === void 0) {
      key = newChar;
    } else {
      key += newChar;
    }
  };
  actions[INC_SUB_PATH_DEPTH] = function() {
    actions[APPEND]();
    subPathDepth++;
  };
  actions[PUSH_SUB_PATH] = function() {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      if (key === void 0) {
        return false;
      }
      key = formatSubPath(key);
      if (key === false) {
        return false;
      } else {
        actions[PUSH]();
      }
    }
  };
  function maybeUnescapeQuote() {
    var nextChar = path[index2 + 1];
    if (mode === IN_SINGLE_QUOTE && nextChar === "'" || mode === IN_DOUBLE_QUOTE && nextChar === '"') {
      index2++;
      newChar = "\\" + nextChar;
      actions[APPEND]();
      return true;
    }
  }
  while (mode !== null) {
    index2++;
    c = path[index2];
    if (c === "\\" && maybeUnescapeQuote()) {
      continue;
    }
    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap["else"] || ERROR;
    if (transition === ERROR) {
      return;
    }
    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === void 0 ? c : newChar;
      if (action() === false) {
        return;
      }
    }
    if (mode === AFTER_PATH) {
      return keys;
    }
  }
}
var I18nPath = function I18nPath2() {
  this._cache = /* @__PURE__ */ Object.create(null);
};
I18nPath.prototype.parsePath = function parsePath(path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || [];
};
I18nPath.prototype.getPathValue = function getPathValue(obj, path) {
  if (!isObject(obj)) {
    return null;
  }
  var paths = this.parsePath(path);
  if (paths.length === 0) {
    return null;
  } else {
    var length = paths.length;
    var last = obj;
    var i2 = 0;
    while (i2 < length) {
      var value = last[paths[i2]];
      if (value === void 0 || value === null) {
        return null;
      }
      last = value;
      i2++;
    }
    return last;
  }
};
var htmlTagMatcher = /<\/?[\w\s="/.':;#-\/]+>/;
var linkKeyMatcher = /(?:@(?:\.[a-zA-Z]+)?:(?:[\w\-_|./]+|\([\w\-_:|./]+\)))/g;
var linkKeyPrefixMatcher = /^@(?:\.([a-zA-Z]+))?:/;
var bracketsMatcher = /[()]/g;
var defaultModifiers = {
  "upper": function(str) {
    return str.toLocaleUpperCase();
  },
  "lower": function(str) {
    return str.toLocaleLowerCase();
  },
  "capitalize": function(str) {
    return "" + str.charAt(0).toLocaleUpperCase() + str.substr(1);
  }
};
var defaultFormatter = new BaseFormatter();
var VueI18n = function VueI18n2(options) {
  var this$1$1 = this;
  if (options === void 0)
    options = {};
  if (!Vue && typeof window !== "undefined" && window.Vue) {
    install(window.Vue);
  }
  var locale = options.locale || "en-US";
  var fallbackLocale = options.fallbackLocale === false ? false : options.fallbackLocale || "en-US";
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || options.datetimeFormats || {};
  var numberFormats = options.numberFormats || {};
  this._vm = null;
  this._formatter = options.formatter || defaultFormatter;
  this._modifiers = options.modifiers || {};
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === void 0 ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === void 0 ? true : !!options.fallbackRoot;
  this._fallbackRootWithEmptyString = options.fallbackRootWithEmptyString === void 0 ? true : !!options.fallbackRootWithEmptyString;
  this._formatFallbackMessages = options.formatFallbackMessages === void 0 ? false : !!options.formatFallbackMessages;
  this._silentTranslationWarn = options.silentTranslationWarn === void 0 ? false : options.silentTranslationWarn;
  this._silentFallbackWarn = options.silentFallbackWarn === void 0 ? false : !!options.silentFallbackWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = /* @__PURE__ */ new Set();
  this._componentInstanceCreatedListener = options.componentInstanceCreatedListener || null;
  this._preserveDirectiveContent = options.preserveDirectiveContent === void 0 ? false : !!options.preserveDirectiveContent;
  this.pluralizationRules = options.pluralizationRules || {};
  this._warnHtmlInMessage = options.warnHtmlInMessage || "off";
  this._postTranslation = options.postTranslation || null;
  this._escapeParameterHtml = options.escapeParameterHtml || false;
  if ("__VUE_I18N_BRIDGE__" in options) {
    this.__VUE_I18N_BRIDGE__ = options.__VUE_I18N_BRIDGE__;
  }
  this.getChoiceIndex = function(choice, choicesLength) {
    var thisPrototype = Object.getPrototypeOf(this$1$1);
    if (thisPrototype && thisPrototype.getChoiceIndex) {
      var prototypeGetChoiceIndex = thisPrototype.getChoiceIndex;
      return prototypeGetChoiceIndex.call(this$1$1, choice, choicesLength);
    }
    var defaultImpl = function(_choice, _choicesLength) {
      _choice = Math.abs(_choice);
      if (_choicesLength === 2) {
        return _choice ? _choice > 1 ? 1 : 0 : 1;
      }
      return _choice ? Math.min(_choice, 2) : 0;
    };
    if (this$1$1.locale in this$1$1.pluralizationRules) {
      return this$1$1.pluralizationRules[this$1$1.locale].apply(this$1$1, [choice, choicesLength]);
    } else {
      return defaultImpl(choice, choicesLength);
    }
  };
  this._exist = function(message, key) {
    if (!message || !key) {
      return false;
    }
    if (!isNull(this$1$1._path.getPathValue(message, key))) {
      return true;
    }
    if (message[key]) {
      return true;
    }
    return false;
  };
  if (this._warnHtmlInMessage === "warn" || this._warnHtmlInMessage === "error") {
    Object.keys(messages).forEach(function(locale2) {
      this$1$1._checkLocaleMessage(locale2, this$1$1._warnHtmlInMessage, messages[locale2]);
    });
  }
  this._initVM({
    locale,
    fallbackLocale,
    messages,
    dateTimeFormats,
    numberFormats
  });
};
var prototypeAccessors = { vm: { configurable: true }, messages: { configurable: true }, dateTimeFormats: { configurable: true }, numberFormats: { configurable: true }, availableLocales: { configurable: true }, locale: { configurable: true }, fallbackLocale: { configurable: true }, formatFallbackMessages: { configurable: true }, missing: { configurable: true }, formatter: { configurable: true }, silentTranslationWarn: { configurable: true }, silentFallbackWarn: { configurable: true }, preserveDirectiveContent: { configurable: true }, warnHtmlInMessage: { configurable: true }, postTranslation: { configurable: true }, sync: { configurable: true } };
VueI18n.prototype._checkLocaleMessage = function _checkLocaleMessage(locale, level, message) {
  var paths = [];
  var fn = function(level2, locale2, message2, paths2) {
    if (isPlainObject(message2)) {
      Object.keys(message2).forEach(function(key) {
        var val = message2[key];
        if (isPlainObject(val)) {
          paths2.push(key);
          paths2.push(".");
          fn(level2, locale2, val, paths2);
          paths2.pop();
          paths2.pop();
        } else {
          paths2.push(key);
          fn(level2, locale2, val, paths2);
          paths2.pop();
        }
      });
    } else if (isArray(message2)) {
      message2.forEach(function(item, index2) {
        if (isPlainObject(item)) {
          paths2.push("[" + index2 + "]");
          paths2.push(".");
          fn(level2, locale2, item, paths2);
          paths2.pop();
          paths2.pop();
        } else {
          paths2.push("[" + index2 + "]");
          fn(level2, locale2, item, paths2);
          paths2.pop();
        }
      });
    } else if (isString(message2)) {
      var ret = htmlTagMatcher.test(message2);
      if (ret) {
        var msg = "Detected HTML in message '" + message2 + "' of keypath '" + paths2.join("") + "' at '" + locale2 + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
        if (level2 === "warn") {
          warn(msg);
        } else if (level2 === "error") {
          error(msg);
        }
      }
    }
  };
  fn(level, locale, message, paths);
};
VueI18n.prototype._initVM = function _initVM(data) {
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  this._vm = new Vue({ data, __VUE18N__INSTANCE__: true });
  Vue.config.silent = silent;
};
VueI18n.prototype.destroyVM = function destroyVM() {
  this._vm.$destroy();
};
VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging(vm) {
  this._dataListeners.add(vm);
};
VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging(vm) {
  remove(this._dataListeners, vm);
};
VueI18n.prototype.watchI18nData = function watchI18nData() {
  var this$1$1 = this;
  return this._vm.$watch("$data", function() {
    var listeners = arrayFrom(this$1$1._dataListeners);
    var i2 = listeners.length;
    while (i2--) {
      Vue.nextTick(function() {
        listeners[i2] && listeners[i2].$forceUpdate();
      });
    }
  }, { deep: true });
};
VueI18n.prototype.watchLocale = function watchLocale(composer) {
  if (!composer) {
    if (!this._sync || !this._root) {
      return null;
    }
    var target = this._vm;
    return this._root.$i18n.vm.$watch("locale", function(val) {
      target.$set(target, "locale", val);
      target.$forceUpdate();
    }, { immediate: true });
  } else {
    if (!this.__VUE_I18N_BRIDGE__) {
      return null;
    }
    var self2 = this;
    var target$1 = this._vm;
    return this.vm.$watch("locale", function(val) {
      target$1.$set(target$1, "locale", val);
      if (self2.__VUE_I18N_BRIDGE__ && composer) {
        composer.locale.value = val;
      }
      target$1.$forceUpdate();
    }, { immediate: true });
  }
};
VueI18n.prototype.onComponentInstanceCreated = function onComponentInstanceCreated(newI18n) {
  if (this._componentInstanceCreatedListener) {
    this._componentInstanceCreatedListener(newI18n, this);
  }
};
prototypeAccessors.vm.get = function() {
  return this._vm;
};
prototypeAccessors.messages.get = function() {
  return looseClone(this._getMessages());
};
prototypeAccessors.dateTimeFormats.get = function() {
  return looseClone(this._getDateTimeFormats());
};
prototypeAccessors.numberFormats.get = function() {
  return looseClone(this._getNumberFormats());
};
prototypeAccessors.availableLocales.get = function() {
  return Object.keys(this.messages).sort();
};
prototypeAccessors.locale.get = function() {
  return this._vm.locale;
};
prototypeAccessors.locale.set = function(locale) {
  this._vm.$set(this._vm, "locale", locale);
};
prototypeAccessors.fallbackLocale.get = function() {
  return this._vm.fallbackLocale;
};
prototypeAccessors.fallbackLocale.set = function(locale) {
  this._localeChainCache = {};
  this._vm.$set(this._vm, "fallbackLocale", locale);
};
prototypeAccessors.formatFallbackMessages.get = function() {
  return this._formatFallbackMessages;
};
prototypeAccessors.formatFallbackMessages.set = function(fallback) {
  this._formatFallbackMessages = fallback;
};
prototypeAccessors.missing.get = function() {
  return this._missing;
};
prototypeAccessors.missing.set = function(handler) {
  this._missing = handler;
};
prototypeAccessors.formatter.get = function() {
  return this._formatter;
};
prototypeAccessors.formatter.set = function(formatter) {
  this._formatter = formatter;
};
prototypeAccessors.silentTranslationWarn.get = function() {
  return this._silentTranslationWarn;
};
prototypeAccessors.silentTranslationWarn.set = function(silent) {
  this._silentTranslationWarn = silent;
};
prototypeAccessors.silentFallbackWarn.get = function() {
  return this._silentFallbackWarn;
};
prototypeAccessors.silentFallbackWarn.set = function(silent) {
  this._silentFallbackWarn = silent;
};
prototypeAccessors.preserveDirectiveContent.get = function() {
  return this._preserveDirectiveContent;
};
prototypeAccessors.preserveDirectiveContent.set = function(preserve) {
  this._preserveDirectiveContent = preserve;
};
prototypeAccessors.warnHtmlInMessage.get = function() {
  return this._warnHtmlInMessage;
};
prototypeAccessors.warnHtmlInMessage.set = function(level) {
  var this$1$1 = this;
  var orgLevel = this._warnHtmlInMessage;
  this._warnHtmlInMessage = level;
  if (orgLevel !== level && (level === "warn" || level === "error")) {
    var messages = this._getMessages();
    Object.keys(messages).forEach(function(locale) {
      this$1$1._checkLocaleMessage(locale, this$1$1._warnHtmlInMessage, messages[locale]);
    });
  }
};
prototypeAccessors.postTranslation.get = function() {
  return this._postTranslation;
};
prototypeAccessors.postTranslation.set = function(handler) {
  this._postTranslation = handler;
};
prototypeAccessors.sync.get = function() {
  return this._sync;
};
prototypeAccessors.sync.set = function(val) {
  this._sync = val;
};
VueI18n.prototype._getMessages = function _getMessages() {
  return this._vm.messages;
};
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats() {
  return this._vm.dateTimeFormats;
};
VueI18n.prototype._getNumberFormats = function _getNumberFormats() {
  return this._vm.numberFormats;
};
VueI18n.prototype._warnDefault = function _warnDefault(locale, key, result, vm, values, interpolateMode) {
  if (!isNull(result)) {
    return result;
  }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (isString(missingRet)) {
      return missingRet;
    }
  }
  if (this._formatFallbackMessages) {
    var parsedArgs = parseArgs.apply(void 0, values);
    return this._render(key, interpolateMode, parsedArgs.params, key);
  } else {
    return key;
  }
};
VueI18n.prototype._isFallbackRoot = function _isFallbackRoot(val) {
  return (this._fallbackRootWithEmptyString ? !val : isNull(val)) && !isNull(this._root) && this._fallbackRoot;
};
VueI18n.prototype._isSilentFallbackWarn = function _isSilentFallbackWarn(key) {
  return this._silentFallbackWarn instanceof RegExp ? this._silentFallbackWarn.test(key) : this._silentFallbackWarn;
};
VueI18n.prototype._isSilentFallback = function _isSilentFallback(locale, key) {
  return this._isSilentFallbackWarn(key) && (this._isFallbackRoot() || locale !== this.fallbackLocale);
};
VueI18n.prototype._isSilentTranslationWarn = function _isSilentTranslationWarn(key) {
  return this._silentTranslationWarn instanceof RegExp ? this._silentTranslationWarn.test(key) : this._silentTranslationWarn;
};
VueI18n.prototype._interpolate = function _interpolate(locale, message, key, host, interpolateMode, values, visitedLinkStack) {
  if (!message) {
    return null;
  }
  var pathRet = this._path.getPathValue(message, key);
  if (isArray(pathRet) || isPlainObject(pathRet)) {
    return pathRet;
  }
  var ret;
  if (isNull(pathRet)) {
    if (isPlainObject(message)) {
      ret = message[key];
      if (!(isString(ret) || isFunction(ret))) {
        return null;
      }
    } else {
      return null;
    }
  } else {
    if (isString(pathRet) || isFunction(pathRet)) {
      ret = pathRet;
    } else {
      return null;
    }
  }
  if (isString(ret) && (ret.indexOf("@:") >= 0 || ret.indexOf("@.") >= 0)) {
    ret = this._link(locale, message, ret, host, "raw", values, visitedLinkStack);
  }
  return this._render(ret, interpolateMode, values, key);
};
VueI18n.prototype._link = function _link(locale, message, str, host, interpolateMode, values, visitedLinkStack) {
  var ret = str;
  var matches = ret.match(linkKeyMatcher);
  for (var idx in matches) {
    if (!matches.hasOwnProperty(idx)) {
      continue;
    }
    var link = matches[idx];
    var linkKeyPrefixMatches = link.match(linkKeyPrefixMatcher);
    var linkPrefix = linkKeyPrefixMatches[0];
    var formatterName = linkKeyPrefixMatches[1];
    var linkPlaceholder = link.replace(linkPrefix, "").replace(bracketsMatcher, "");
    if (includes(visitedLinkStack, linkPlaceholder)) {
      return ret;
    }
    visitedLinkStack.push(linkPlaceholder);
    var translated = this._interpolate(
      locale,
      message,
      linkPlaceholder,
      host,
      interpolateMode === "raw" ? "string" : interpolateMode,
      interpolateMode === "raw" ? void 0 : values,
      visitedLinkStack
    );
    if (this._isFallbackRoot(translated)) {
      if (!this._root) {
        throw Error("unexpected error");
      }
      var root = this._root.$i18n;
      translated = root._translate(
        root._getMessages(),
        root.locale,
        root.fallbackLocale,
        linkPlaceholder,
        host,
        interpolateMode,
        values
      );
    }
    translated = this._warnDefault(
      locale,
      linkPlaceholder,
      translated,
      host,
      isArray(values) ? values : [values],
      interpolateMode
    );
    if (this._modifiers.hasOwnProperty(formatterName)) {
      translated = this._modifiers[formatterName](translated);
    } else if (defaultModifiers.hasOwnProperty(formatterName)) {
      translated = defaultModifiers[formatterName](translated);
    }
    visitedLinkStack.pop();
    ret = !translated ? ret : ret.replace(link, translated);
  }
  return ret;
};
VueI18n.prototype._createMessageContext = function _createMessageContext(values, formatter, path, interpolateMode) {
  var this$1$1 = this;
  var _list = isArray(values) ? values : [];
  var _named = isObject(values) ? values : {};
  var list = function(index2) {
    return _list[index2];
  };
  var named = function(key) {
    return _named[key];
  };
  var messages = this._getMessages();
  var locale = this.locale;
  return {
    list,
    named,
    values,
    formatter,
    path,
    messages,
    locale,
    linked: function(linkedKey) {
      return this$1$1._interpolate(locale, messages[locale] || {}, linkedKey, null, interpolateMode, void 0, [linkedKey]);
    }
  };
};
VueI18n.prototype._render = function _render(message, interpolateMode, values, path) {
  if (isFunction(message)) {
    return message(
      this._createMessageContext(values, this._formatter || defaultFormatter, path, interpolateMode)
    );
  }
  var ret = this._formatter.interpolate(message, values, path);
  if (!ret) {
    ret = defaultFormatter.interpolate(message, values, path);
  }
  return interpolateMode === "string" && !isString(ret) ? ret.join("") : ret;
};
VueI18n.prototype._appendItemToChain = function _appendItemToChain(chain, item, blocks) {
  var follow = false;
  if (!includes(chain, item)) {
    follow = true;
    if (item) {
      follow = item[item.length - 1] !== "!";
      item = item.replace(/!/g, "");
      chain.push(item);
      if (blocks && blocks[item]) {
        follow = blocks[item];
      }
    }
  }
  return follow;
};
VueI18n.prototype._appendLocaleToChain = function _appendLocaleToChain(chain, locale, blocks) {
  var follow;
  var tokens = locale.split("-");
  do {
    var item = tokens.join("-");
    follow = this._appendItemToChain(chain, item, blocks);
    tokens.splice(-1, 1);
  } while (tokens.length && follow === true);
  return follow;
};
VueI18n.prototype._appendBlockToChain = function _appendBlockToChain(chain, block, blocks) {
  var follow = true;
  for (var i2 = 0; i2 < block.length && isBoolean(follow); i2++) {
    var locale = block[i2];
    if (isString(locale)) {
      follow = this._appendLocaleToChain(chain, locale, blocks);
    }
  }
  return follow;
};
VueI18n.prototype._getLocaleChain = function _getLocaleChain(start, fallbackLocale) {
  if (start === "") {
    return [];
  }
  if (!this._localeChainCache) {
    this._localeChainCache = {};
  }
  var chain = this._localeChainCache[start];
  if (!chain) {
    if (!fallbackLocale) {
      fallbackLocale = this.fallbackLocale;
    }
    chain = [];
    var block = [start];
    while (isArray(block)) {
      block = this._appendBlockToChain(
        chain,
        block,
        fallbackLocale
      );
    }
    var defaults;
    if (isArray(fallbackLocale)) {
      defaults = fallbackLocale;
    } else if (isObject(fallbackLocale)) {
      if (fallbackLocale["default"]) {
        defaults = fallbackLocale["default"];
      } else {
        defaults = null;
      }
    } else {
      defaults = fallbackLocale;
    }
    if (isString(defaults)) {
      block = [defaults];
    } else {
      block = defaults;
    }
    if (block) {
      this._appendBlockToChain(
        chain,
        block,
        null
      );
    }
    this._localeChainCache[start] = chain;
  }
  return chain;
};
VueI18n.prototype._translate = function _translate(messages, locale, fallback, key, host, interpolateMode, args) {
  var chain = this._getLocaleChain(locale, fallback);
  var res;
  for (var i2 = 0; i2 < chain.length; i2++) {
    var step = chain[i2];
    res = this._interpolate(step, messages[step], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) {
      if (step !== locale && false) {
        warn("Fall back to translate the keypath '" + key + "' with '" + step + "' locale.");
      }
      return res;
    }
  }
  return null;
};
VueI18n.prototype._t = function _t(key, _locale, messages, host) {
  var ref;
  var values = [], len = arguments.length - 4;
  while (len-- > 0)
    values[len] = arguments[len + 4];
  if (!key) {
    return "";
  }
  var parsedArgs = parseArgs.apply(void 0, values);
  if (this._escapeParameterHtml) {
    parsedArgs.params = escapeParams(parsedArgs.params);
  }
  var locale = parsedArgs.locale || _locale;
  var ret = this._translate(
    messages,
    locale,
    this.fallbackLocale,
    key,
    host,
    "string",
    parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    if (!this._root) {
      throw Error("unexpected error");
    }
    return (ref = this._root).$t.apply(ref, [key].concat(values));
  } else {
    ret = this._warnDefault(locale, key, ret, host, values, "string");
    if (this._postTranslation && ret !== null && ret !== void 0) {
      ret = this._postTranslation(ret, key);
    }
    return ret;
  }
};
VueI18n.prototype.t = function t2(key) {
  var ref;
  var values = [], len = arguments.length - 1;
  while (len-- > 0)
    values[len] = arguments[len + 1];
  return (ref = this)._t.apply(ref, [key, this.locale, this._getMessages(), null].concat(values));
};
VueI18n.prototype._i = function _i(key, locale, messages, host, values) {
  var ret = this._translate(messages, locale, this.fallbackLocale, key, host, "raw", values);
  if (this._isFallbackRoot(ret)) {
    if (!this._root) {
      throw Error("unexpected error");
    }
    return this._root.$i18n.i(key, locale, values);
  } else {
    return this._warnDefault(locale, key, ret, host, [values], "raw");
  }
};
VueI18n.prototype.i = function i(key, locale, values) {
  if (!key) {
    return "";
  }
  if (!isString(locale)) {
    locale = this.locale;
  }
  return this._i(key, locale, this._getMessages(), null, values);
};
VueI18n.prototype._tc = function _tc(key, _locale, messages, host, choice) {
  var ref;
  var values = [], len = arguments.length - 5;
  while (len-- > 0)
    values[len] = arguments[len + 5];
  if (!key) {
    return "";
  }
  if (choice === void 0) {
    choice = 1;
  }
  var predefined = { "count": choice, "n": choice };
  var parsedArgs = parseArgs.apply(void 0, values);
  parsedArgs.params = Object.assign(predefined, parsedArgs.params);
  values = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
  return this.fetchChoice((ref = this)._t.apply(ref, [key, _locale, messages, host].concat(values)), choice);
};
VueI18n.prototype.fetchChoice = function fetchChoice(message, choice) {
  if (!message || !isString(message)) {
    return null;
  }
  var choices = message.split("|");
  choice = this.getChoiceIndex(choice, choices.length);
  if (!choices[choice]) {
    return message;
  }
  return choices[choice].trim();
};
VueI18n.prototype.tc = function tc(key, choice) {
  var ref;
  var values = [], len = arguments.length - 2;
  while (len-- > 0)
    values[len] = arguments[len + 2];
  return (ref = this)._tc.apply(ref, [key, this.locale, this._getMessages(), null, choice].concat(values));
};
VueI18n.prototype._te = function _te(key, locale, messages) {
  var args = [], len = arguments.length - 3;
  while (len-- > 0)
    args[len] = arguments[len + 3];
  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key);
};
VueI18n.prototype.te = function te(key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale);
};
VueI18n.prototype.getLocaleMessage = function getLocaleMessage(locale) {
  return looseClone(this._vm.messages[locale] || {});
};
VueI18n.prototype.setLocaleMessage = function setLocaleMessage(locale, message) {
  if (this._warnHtmlInMessage === "warn" || this._warnHtmlInMessage === "error") {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, message);
};
VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage(locale, message) {
  if (this._warnHtmlInMessage === "warn" || this._warnHtmlInMessage === "error") {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, merge(
    typeof this._vm.messages[locale] !== "undefined" && Object.keys(this._vm.messages[locale]).length ? Object.assign({}, this._vm.messages[locale]) : {},
    message
  ));
};
VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat(locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {});
};
VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat(locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
  this._clearDateTimeFormat(locale, format);
};
VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat(locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, merge(this._vm.dateTimeFormats[locale] || {}, format));
  this._clearDateTimeFormat(locale, format);
};
VueI18n.prototype._clearDateTimeFormat = function _clearDateTimeFormat(locale, format) {
  for (var key in format) {
    var id = locale + "__" + key;
    if (!this._dateTimeFormatters.hasOwnProperty(id)) {
      continue;
    }
    delete this._dateTimeFormatters[id];
  }
};
VueI18n.prototype._localizeDateTime = function _localizeDateTime(value, locale, fallback, dateTimeFormats, key, options) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];
  var chain = this._getLocaleChain(locale, fallback);
  for (var i2 = 0; i2 < chain.length; i2++) {
    var current = _locale;
    var step = chain[i2];
    formats = dateTimeFormats[step];
    _locale = step;
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && false) {
        warn("Fall back to '" + step + "' datetime formats from '" + current + "' datetime formats.");
      }
    } else {
      break;
    }
  }
  if (isNull(formats) || isNull(formats[key])) {
    return null;
  } else {
    var format = formats[key];
    var formatter;
    if (options) {
      formatter = new Intl.DateTimeFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._dateTimeFormatters[id];
      if (!formatter) {
        formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
      }
    }
    return formatter.format(value);
  }
};
VueI18n.prototype._d = function _d(value, locale, key, options) {
  if (!key) {
    var dtf = !options ? new Intl.DateTimeFormat(locale) : new Intl.DateTimeFormat(locale, options);
    return dtf.format(value);
  }
  var ret = this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key, options);
  if (this._isFallbackRoot(ret)) {
    if (!this._root) {
      throw Error("unexpected error");
    }
    return this._root.$i18n.d(value, key, locale);
  } else {
    return ret || "";
  }
};
VueI18n.prototype.d = function d(value) {
  var args = [], len = arguments.length - 1;
  while (len-- > 0)
    args[len] = arguments[len + 1];
  var locale = this.locale;
  var key = null;
  var options = null;
  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
    options = Object.keys(args[0]).reduce(function(acc, key2) {
      var obj;
      if (includes(dateTimeFormatKeys, key2)) {
        return Object.assign({}, acc, (obj = {}, obj[key2] = args[0][key2], obj));
      }
      return acc;
    }, null);
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }
  return this._d(value, locale, key, options);
};
VueI18n.prototype.getNumberFormat = function getNumberFormat(locale) {
  return looseClone(this._vm.numberFormats[locale] || {});
};
VueI18n.prototype.setNumberFormat = function setNumberFormat(locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
  this._clearNumberFormat(locale, format);
};
VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat(locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, merge(this._vm.numberFormats[locale] || {}, format));
  this._clearNumberFormat(locale, format);
};
VueI18n.prototype._clearNumberFormat = function _clearNumberFormat(locale, format) {
  for (var key in format) {
    var id = locale + "__" + key;
    if (!this._numberFormatters.hasOwnProperty(id)) {
      continue;
    }
    delete this._numberFormatters[id];
  }
};
VueI18n.prototype._getNumberFormatter = function _getNumberFormatter(value, locale, fallback, numberFormats, key, options) {
  var _locale = locale;
  var formats = numberFormats[_locale];
  var chain = this._getLocaleChain(locale, fallback);
  for (var i2 = 0; i2 < chain.length; i2++) {
    var current = _locale;
    var step = chain[i2];
    formats = numberFormats[step];
    _locale = step;
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && false) {
        warn("Fall back to '" + step + "' number formats from '" + current + "' number formats.");
      }
    } else {
      break;
    }
  }
  if (isNull(formats) || isNull(formats[key])) {
    return null;
  } else {
    var format = formats[key];
    var formatter;
    if (options) {
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter;
  }
};
VueI18n.prototype._n = function _n(value, locale, key, options) {
  if (!VueI18n.availabilities.numberFormat) {
    return "";
  }
  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value);
  }
  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.format(value);
  if (this._isFallbackRoot(ret)) {
    if (!this._root) {
      throw Error("unexpected error");
    }
    return this._root.$i18n.n(value, Object.assign({}, { key, locale }, options));
  } else {
    return ret || "";
  }
};
VueI18n.prototype.n = function n(value) {
  var args = [], len = arguments.length - 1;
  while (len-- > 0)
    args[len] = arguments[len + 1];
  var locale = this.locale;
  var key = null;
  var options = null;
  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
      options = Object.keys(args[0]).reduce(function(acc, key2) {
        var obj;
        if (includes(numberFormatKeys, key2)) {
          return Object.assign({}, acc, (obj = {}, obj[key2] = args[0][key2], obj));
        }
        return acc;
      }, null);
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }
  return this._n(value, locale, key, options);
};
VueI18n.prototype._ntp = function _ntp(value, locale, key, options) {
  if (!VueI18n.availabilities.numberFormat) {
    return [];
  }
  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.formatToParts(value);
  }
  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.formatToParts(value);
  if (this._isFallbackRoot(ret)) {
    if (!this._root) {
      throw Error("unexpected error");
    }
    return this._root.$i18n._ntp(value, locale, key, options);
  } else {
    return ret || [];
  }
};
Object.defineProperties(VueI18n.prototype, prototypeAccessors);
var availabilities;
Object.defineProperty(VueI18n, "availabilities", {
  get: function get() {
    if (!availabilities) {
      var intlDefined = typeof Intl !== "undefined";
      availabilities = {
        dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== "undefined",
        numberFormat: intlDefined && typeof Intl.NumberFormat !== "undefined"
      };
    }
    return availabilities;
  }
});
VueI18n.install = install;
VueI18n.version = "8.28.2";
var VueI18n$1 = VueI18n;
const ada$1 = {
  active: "Active",
  activity: "Activity:",
  followed_by: "followed by",
  inactive: "Inactive",
  siren: "Siren:",
  status: {
    ongoing: "On going",
    sent: "Contract sent",
    received: "Contrat received",
    valid: "Valid"
  }
};
const avenant$1 = {
  title: "Avenant N\xB0 {number} for {reference}"
};
const booking$1 = {
  name: "Booking",
  price: "Price:",
  fees: "Fees:",
  statusList: {
    accepted: "Accepted",
    cancelled: "Cancelled"
  }
};
const client$1 = {
  followed_by: "followed by",
  mr: "Mr",
  ms: "Ms",
  "new": "New",
  states: {
    active_buyer: "Active buyer",
    active_seller: "Active seller",
    inactive_buyer: "Inactive buyer",
    inactive_seller: "Inactive seller"
  },
  unknown: "Unknown",
  visits_cancel: "{number} Appointments cancelled ! | {number} Appointment cancelled ! | {number} Appointments cancelled"
};
const commissions$1 = {
  fees: "Fees"
};
const contract$1 = {
  name: "Contract",
  expired_contracts: "{number} expired contracts ! | {number} expired contract ! | {number} expired contracts ! ",
  statusList: {
    draft: "Draft",
    ready: "Ready",
    sent: "Sent",
    signed_by_leggett: "Signed by Leggett",
    signed_by_developer: "Signed by Developer",
    completed: "Completed",
    "void": "Void",
    cancelled: "Cancelled"
  }
};
const developer$1 = {
  name: "Developer"
};
const lot$1 = {
  name: "Lot",
  actability: "Actability",
  delivery: "Delivery",
  grace_active: "Active grace"
};
const main$1 = {
  noAlerts: "No alert"
};
const mandate$1 = {
  expired_mandates: "{number} expired mandates ! | {number} expired mandate ! | {number} expired mandates ! ",
  grace: {
    outdated: "Grace outdated"
  },
  isExpired: "Expired mandate",
  statusList: {
    cancelled: "Cancelled",
    completed: "Completed",
    created: "Created",
    draft: "Draft",
    declined: "Declined",
    eavenant_ready: "E-avenant ready",
    emandate_ready: "E-mandate ready",
    prospection: "Prospection",
    ready: "Ready",
    renewed: "Renewed",
    sent: "Sent",
    signed: "Signed by clients",
    "void": "Void",
    voided: "Voided",
    delivered: "Delivered"
  }
};
const model$1 = {
  issue: "{number} discussions | {number} discussion | {number} discussions",
  offer: "{number} offers | {number} offer | {number} offers"
};
const notary$1 = {
  title: "Ma\xEEtre"
};
const offer$1 = {
  cdvLimit: "CDV preparation period until",
  mortgageSuspensiveClause: "Mortgage suspensive clause",
  offerCardTitle: "Offer on",
  statusList: {
    accepted: "Accepted",
    canceled: "Canceled",
    pending: "Pending",
    pending_signature: "Pending for signature",
    refused: "Refused"
  },
  validUntil: "Offer valid until"
};
const program$1 = {
  name: "Program",
  statusList: {
    draft: "Draft",
    ready: "Ready",
    "void": "Void",
    cancelled: "Cancelled"
  }
};
const property$1 = {
  dpe: {
    energyAudit: {
      missing: "Energy Audit missing"
    },
    view: {
      active: "Active grace DPE",
      expire: "Expired grace DPE"
    }
  },
  estimated: "Agent valuation",
  exclusive: "Exclusive",
  including_fees: "including {fees} fees",
  "new": "New",
  statusList: {
    archived: "Archived",
    draft: "Draft",
    estimation: "Estimation",
    offer: "Compromis Signed",
    offer_other: "Compromis signed by other",
    sale: "For Sale",
    sold: "Sold",
    sold_other: "Sold by other"
  }
};
const user$1 = {
  businessCard: "Professional card"
};
var enJson = {
  ada: ada$1,
  avenant: avenant$1,
  booking: booking$1,
  client: client$1,
  commissions: commissions$1,
  contract: contract$1,
  developer: developer$1,
  lot: lot$1,
  main: main$1,
  mandate: mandate$1,
  model: model$1,
  notary: notary$1,
  offer: offer$1,
  program: program$1,
  property: property$1,
  user: user$1
};
const ada = {
  active: "Actif",
  activity: "Activit\xE9 :",
  followed_by: "suivi par",
  inactive: "Inactif",
  siren: "Siren :",
  status: {
    ongoing: "En cours",
    sent: "Contrat envoy\xE9",
    received: "Contrat re\xE7u",
    valid: "Valide"
  }
};
const avenant = {
  title: "Avenant N\xB0 {number} pour {reference}"
};
const booking = {
  name: "R\xE9servation",
  price: "Prix :",
  fees: "Honoraires :",
  statusList: {
    accepted: "Accept\xE9e",
    cancelled: "Annul\xE9e"
  }
};
const client = {
  followed_by: "suivi par",
  mr: "M.",
  ms: "Mme.",
  "new": "Nouveau",
  states: {
    active_buyer: "Acqu\xE9reur actif",
    active_seller: "Vendeur actif",
    inactive_buyer: "Acqu\xE9reur inactif",
    inactive_seller: "Vendeur inactif"
  },
  unknown: "Inconnu",
  visits_cancel: "{number} RDV annul\xE9s ! | {number} RDV annul\xE9 ! | {number} RDV annul\xE9s"
};
const commissions = {
  fees: "Honoraires"
};
const contract = {
  name: "Contrat",
  expired_mandates: "{number} contrats expir\xE9s ! | {number} contrat expir\xE9 ! | {number} contrats expir\xE9s ! ",
  statusList: {
    draft: "Brouillon",
    ready: "Pr\xEAt",
    sent: "Envoy\xE9",
    signed_by_leggett: "Sign\xE9 par Leggett",
    signed_by_developer: "Sign\xE9 par le Promoteur",
    completed: "Compl\xE9t\xE9",
    "void": "Obsol\xE8te",
    cancelled: "Annul\xE9"
  }
};
const developer = {
  name: "Promoteur"
};
const lot = {
  name: "Lot",
  actability: "Actabilit\xE9",
  delivery: "Livraison",
  grace_active: "Grace active"
};
const main = {
  noAlerts: "Aucune alerte"
};
const mandate = {
  expired_mandates: "{number} mandats expir\xE9s ! | {number} mandat expir\xE9 ! | {number} mandats expir\xE9s ! ",
  grace: {
    outdated: "Gr\xE2ce d\xE9pass\xE9"
  },
  isExpired: "Mandat expir\xE9",
  statusList: {
    cancelled: "Annul\xE9",
    completed: "Compl\xE9t\xE9",
    created: "Cr\xE9\xE9",
    draft: "Brouillon",
    declined: "D\xE9clin\xE9",
    eavenant_ready: "E-avenant pr\xEAt",
    emandate_ready: "E-Mandat pr\xEAt",
    prospection: "Prospection",
    ready: "Pr\xEAt",
    renewed: "Renouvel\xE9",
    sent: "Envoy\xE9",
    signed: "Sign\xE9 par les vendeurs",
    "void": "Obsol\xE8te",
    voided: "Annul\xE9",
    delivered: "Re\xE7u"
  }
};
const model = {
  issue: "{number} discussion | {number} discussion | {number} discussions",
  offer: "{number} offre | {number} offre | {number} offres"
};
const notary = {
  title: "Ma\xEEtre"
};
const offer = {
  offerCardTitle: "Offre sur",
  cdvLimit: "D\xE9lai de pr\xE9paration du CDV jusq'au",
  mortgageSuspensiveClause: "Clause d'obtention d'un pr\xEAt",
  statusList: {
    accepted: "Accept\xE9",
    canceled: "Annul\xE9",
    pending: "En attente",
    pending_signature: "En attente de la signature",
    refused: "Refus\xE9"
  },
  validUntil: "Offre valide jusqu'au"
};
const program = {
  name: "Programme",
  statusList: {
    draft: "Brouillon",
    ready: "Pr\xEAt",
    "void": "Obsol\xE8te",
    cancelled: "Annul\xE9"
  }
};
const property = {
  dpe: {
    energyAudit: {
      missing: "Audit \xE9nerg\xE9tique manquant"
    },
    view: {
      active: "Gr\xE2ce DPE active",
      expire: "Gr\xE2ce DPE expir\xE9e"
    }
  },
  estimated: "Estimation de l'agent",
  exclusive: "Exclusif",
  including_fees: "dont {fees} d'honoraires",
  "new": "Nouveau",
  statusList: {
    archived: "Archiv\xE9",
    draft: "Brouillon",
    estimation: "Estimation",
    offer: "Compromis Sign\xE9",
    offer_other: "Compromis sign\xE9 par une autre agence",
    sale: "En vente",
    sold: "Vendu",
    sold_other: "Vendu par une autre agence"
  }
};
const user = {
  businessCard: "Carte professionnelle "
};
var frJson = {
  ada,
  avenant,
  booking,
  client,
  commissions,
  contract,
  developer,
  lot,
  main,
  mandate,
  model,
  notary,
  offer,
  program,
  property,
  user
};
Vue$1.use(VueI18n$1);
const i18n = new VueI18n$1({
  messages: {
    en: enJson,
    fr: frJson
  }
});
if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(Aglaea);
}
export { Aglaea, Formatter, i18n };
